/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `Any` scalar type represents any valid GraphQL value. */
  Any: { input: any; output: any; }
  /** The `Date` scalar type represents a date in UTC. */
  Date: { input: any; output: any; }
  /** The `DateTime` scalar type represents a date and time with time zone offset information. */
  DateTime: { input: string; output: string; }
  /** The `Decimal` scalar type represents a decimal floating-point number with high precision. */
  Decimal: { input: any; output: any; }
  /** The `Duration` scalar type represents a duration of time. */
  Duration: { input: any; output: any; }
  /** A LexoRank represented as a string */
  LexoRank: { input: any; output: any; }
  /** The `Long` scalar type represents a signed 64-bit integer. */
  Long: { input: any; output: any; }
  /** A reward code represented as a string */
  RewardCodeScalar: { input: any; output: any; }
  /** The `UnsignedLong` scalar type represents an unsigned 64-bit integer. */
  UnsignedLong: { input: number; output: number; }
};

export type AiContextDetails = {
  sources: Array<ContextSource>;
};

export type AiContextModelStats = {
  capabilities: Array<SupportedModelCapability>;
  compatibleAgents: Array<SupportedAgent>;
  inputModalities: Array<Modality>;
  isRegionRestricted: Scalars['Boolean']['output'];
  isTierAvailable: Scalars['Boolean']['output'];
  /** @deprecated Use maxInputTokens instead. */
  maxContextWindowSize: Scalars['Int']['output'];
  maxImages?: Maybe<Scalars['Int']['output']>;
  maxInputTokens: Scalars['Int']['output'];
  model: SupportedModel;
  modelId: Scalars['String']['output'];
  outputModalities: Array<Modality>;
  /** @deprecated Use capabilities instead. */
  supportedCapabilities: Array<SupportedModelCapability>;
  /** @deprecated Use inputModalities instead. */
  supportedInputModalities: Array<Modality>;
  tier: SupportedFeature;
  unsupportedCards: Array<UnsupportedCardStats>;
};

export type AiContextStats = {
  cards: Scalars['Int']['output'];
  files: Scalars['Int']['output'];
  images: Scalars['Int']['output'];
  models: Array<AiContextModelStats>;
  others: Scalars['Int']['output'];
  totalTokens: Scalars['Int']['output'];
};

export type AiMutations = {
  resetPreferredModels: CommandSuccessResultOfAiProfileState;
  setPreferredModelIds: CommandSuccessResultOfAiProfileState;
  /** @deprecated Use setPreferredModelIds with string model IDs for dynamic model support. */
  setPreferredModels: CommandSuccessResultOfAiProfileState;
};


export type AiMutationsSetPreferredModelIdsArgs = {
  agent: SupportedAgent;
  modelIds: Array<Scalars['String']['input']>;
};


export type AiMutationsSetPreferredModelsArgs = {
  agent: SupportedAgent;
  models: Array<SupportedModel>;
};

export type AiProfileDocument = ProjectedDocument & {
  created: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  modelPreferences: Array<KeyValuePairOfSupportedAgentAndListOfSupportedModel>;
  ownerId: Scalars['String']['output'];
  position: Scalars['UnsignedLong']['output'];
  streamPosition: Scalars['UnsignedLong']['output'];
  updated: Scalars['DateTime']['output'];
};

export type AiProfileState = {
  modelPreferences: Array<KeyValuePairOfStringAndIReadOnlyListOfString>;
  ownerId: Scalars['String']['output'];
};

export type AiQuery = {
  /** @deprecated Use allAgents for region-available defaults or myAgents for user preferences. */
  agents: Array<SupportedAgentDescription>;
  allAgents: Array<SupportedAgentDescription>;
  contextDetails: AiContextDetails;
  contextStats: AiContextStats;
  models: Array<SupportedModelAvailability>;
  myAgents: Array<MyAgentDescription>;
};


export type AiQueryAgentsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type AiQueryAllAgentsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type AiQueryContextDetailsArgs = {
  contentCardIds: Array<Scalars['String']['input']>;
  expandReferences?: InputMaybe<Scalars['Boolean']['input']>;
  promptCardId: Scalars['String']['input'];
  shareKey?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type AiQueryContextStatsArgs = {
  agent?: InputMaybe<SupportedAgent>;
  contentCardIds: Array<Scalars['String']['input']>;
  expandReferences?: InputMaybe<Scalars['Boolean']['input']>;
  parentWhiteboardId?: InputMaybe<Scalars['String']['input']>;
  promptCardId: Scalars['String']['input'];
  shareKey?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type AiQueryModelsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type AiQueryMyAgentsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export enum AgreementStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type AiUsagePerPeriod = {
  completionTokens: Scalars['Long']['output'];
  creditsBudgetPerPeriod?: Maybe<Scalars['UnsignedLong']['output']>;
  currentExtraUsageBalance?: Maybe<Scalars['UnsignedLong']['output']>;
  extraUsageCredits?: Maybe<Scalars['UnsignedLong']['output']>;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  promptTokens: Scalars['Long']['output'];
  successfulRequests: Scalars['Long']['output'];
  totalTokens: Scalars['Long']['output'];
  usagePerModel: Array<ModelUsageNoSpend>;
};

export type ApplicationInformation = {
  version: Scalars['String']['output'];
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

export enum AssetIngestStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Downloading = 'DOWNLOADING',
  Extracting = 'EXTRACTING',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Queued = 'QUEUED'
}

export type AssetMutations = {
  addLocation: Scalars['Boolean']['output'];
  grantPermission: Scalars['Boolean']['output'];
  moveToLocation: Scalars['Boolean']['output'];
  prepareUpload: UploadInfo;
  removeLocation: Scalars['Boolean']['output'];
};


export type AssetMutationsAddLocationArgs = {
  assetId: Scalars['String']['input'];
  location: Scalars['String']['input'];
  permission: AssetPermission;
  shareKey?: InputMaybe<Scalars['String']['input']>;
};


export type AssetMutationsGrantPermissionArgs = {
  assetId: Scalars['String']['input'];
  location: Scalars['String']['input'];
  permission: AssetPermission;
  shareKey?: InputMaybe<Scalars['String']['input']>;
};


export type AssetMutationsMoveToLocationArgs = {
  assetId: Scalars['String']['input'];
  destination: Scalars['String']['input'];
  permission: AssetPermission;
  shareKey?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
};


export type AssetMutationsPrepareUploadArgs = {
  backgroundIngest?: InputMaybe<Scalars['Boolean']['input']>;
  fileName: Scalars['String']['input'];
  intakeKey?: InputMaybe<Scalars['String']['input']>;
  locationDocumentTypedId?: InputMaybe<Scalars['String']['input']>;
  parentWhiteboardId?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<AssetPermission>;
  shareKey?: InputMaybe<Scalars['String']['input']>;
};


export type AssetMutationsRemoveLocationArgs = {
  assetId: Scalars['String']['input'];
  location: Scalars['String']['input'];
  shareKey?: InputMaybe<Scalars['String']['input']>;
};

export enum AssetPermission {
  Deny = 'DENY',
  LocationEditor = 'LOCATION_EDITOR',
  LocationViewer = 'LOCATION_VIEWER',
  Public = 'PUBLIC'
}

export type AssetQueries = {
  status?: Maybe<AssetStatusDto>;
};


export type AssetQueriesStatusArgs = {
  assetId: Scalars['String']['input'];
  shareKey?: InputMaybe<Scalars['String']['input']>;
};

export type AssetStatusDto = {
  fileName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ingestError?: Maybe<Scalars['String']['output']>;
  ingestId?: Maybe<Scalars['String']['output']>;
  ingestStatus: AssetIngestStatus;
  ingestedAt?: Maybe<Scalars['DateTime']['output']>;
  isIngested: Scalars['Boolean']['output'];
  isUploaded: Scalars['Boolean']['output'];
  jobId?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AudioBlock = {
  caption?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AudioContentPart = ContentPart & {
  caption?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type Auth0UserInfo = {
  email?: Maybe<Scalars['String']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type AuthorInfo = {
  anonymous?: Maybe<Scalars['Boolean']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  contributedAt: Scalars['DateTime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type BillingInfo = {
  currency: Scalars['String']['output'];
  freeMonthsInfo?: Maybe<FreeMonthsInfo>;
  nextChargeAmount: Scalars['Decimal']['output'];
  nextChargeDate: Scalars['DateTime']['output'];
};

export type BoardTreeItem = TreeItem & {
  collaboration?: Maybe<Collaboration>;
  hasChildren: Scalars['Boolean']['output'];
  icon?: Maybe<IconInfo>;
  intake?: Maybe<Intake>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentKey?: Maybe<Scalars['String']['output']>;
  publication?: Maybe<Publication>;
  rank: Scalars['String']['output'];
  status?: Maybe<WhiteboardStatus>;
  type: NavBarItemType;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BudgetSyncResult = {
  failedCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  updatedCount: Scalars['Int']['output'];
};

export type CardCollaboration = {
  collaborators: Array<CardCollaborator>;
  isShared: Scalars['Boolean']['output'];
};

export type CardCollaborationFilterInput = {
  and?: InputMaybe<Array<CardCollaborationFilterInput>>;
  collaborators?: InputMaybe<ListFilterInputTypeOfCardCollaboratorFilterInput>;
  isShared?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<CardCollaborationFilterInput>>;
};

export type CardCollaborationSortInput = {
  isShared?: InputMaybe<SortEnumType>;
};

export type CardCollaborator = {
  permission: CardPermission;
  userEmail: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type CardCollaboratorFilterInput = {
  and?: InputMaybe<Array<CardCollaboratorFilterInput>>;
  or?: InputMaybe<Array<CardCollaboratorFilterInput>>;
  permission?: InputMaybe<CardPermissionOperationFilterInput>;
  userEmail?: InputMaybe<StringOperationFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
};

export type CardCommandResult = {
  causationId?: Maybe<Scalars['String']['output']>;
  commandId: Scalars['String']['output'];
  correlationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  state?: Maybe<CardState>;
};

export type CardDestinationInput = {
  position?: InputMaybe<PositionInput>;
  whiteboardId: Scalars['String']['input'];
};

export type CardDetailsDocument = ProjectedDocument & {
  collaboration?: Maybe<CardCollaboration>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isPublished: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  ownerAvatarUrl?: Maybe<Scalars['String']['output']>;
  ownerEmail: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  ownerName?: Maybe<Scalars['String']['output']>;
  position: Scalars['UnsignedLong']['output'];
  publication?: Maybe<CardPublication>;
  ranking?: Maybe<Array<Ranking>>;
  shareKey?: Maybe<Scalars['String']['output']>;
  status: CardStatus;
  streamPosition: Scalars['UnsignedLong']['output'];
  trail: DocumentTrail;
  whiteboards: Array<CardWhiteboardOccurrence>;
};

export type CardDetailsDocumentFilterInput = {
  and?: InputMaybe<Array<CardDetailsDocumentFilterInput>>;
  collaboration?: InputMaybe<CardCollaborationFilterInput>;
  createdAt?: InputMaybe<ComparableDateTimeOffsetOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isPublished?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CardDetailsDocumentFilterInput>>;
  ownerAvatarUrl?: InputMaybe<StringOperationFilterInput>;
  ownerEmail?: InputMaybe<StringOperationFilterInput>;
  ownerId?: InputMaybe<StringOperationFilterInput>;
  ownerName?: InputMaybe<StringOperationFilterInput>;
  position?: InputMaybe<ComparableUInt64OperationFilterInput>;
  publication?: InputMaybe<CardPublicationFilterInput>;
  ranking?: InputMaybe<ListFilterInputTypeOfRankingFilterInput>;
  shareKey?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<CardStatusOperationFilterInput>;
  streamPosition?: InputMaybe<ComparableUInt64OperationFilterInput>;
  trail?: InputMaybe<DocumentTrailFilterInput>;
};

export type CardDetailsDocumentSortInput = {
  collaboration?: InputMaybe<CardCollaborationSortInput>;
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isPublished?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  ownerAvatarUrl?: InputMaybe<SortEnumType>;
  ownerEmail?: InputMaybe<SortEnumType>;
  ownerId?: InputMaybe<SortEnumType>;
  ownerName?: InputMaybe<SortEnumType>;
  position?: InputMaybe<SortEnumType>;
  publication?: InputMaybe<CardPublicationSortInput>;
  shareKey?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  streamPosition?: InputMaybe<SortEnumType>;
  trail?: InputMaybe<DocumentTrailSortInput>;
};

export type CardIdInput = {
  value: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};

export enum CardInitialContentFormat {
  BlockNoteJsonBlocks = 'BLOCK_NOTE_JSON_BLOCKS',
  Html = 'HTML',
  Markdown = 'MARKDOWN'
}

export type CardInitialContentInput = {
  content: Scalars['String']['input'];
  format: CardInitialContentFormat;
};

export type CardLocation = {
  cardId: Scalars['String']['output'];
  position: CardPosition;
  whiteboardId: Scalars['String']['output'];
};

export enum CardPermission {
  Deny = 'DENY',
  Owner = 'OWNER',
  Read = 'READ',
  Write = 'WRITE'
}

export type CardPermissionOperationFilterInput = {
  eq?: InputMaybe<CardPermission>;
  in?: InputMaybe<Array<CardPermission>>;
  neq?: InputMaybe<CardPermission>;
  nin?: InputMaybe<Array<CardPermission>>;
};

export type CardPosition = {
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

export type CardPublication = {
  isPublished: Scalars['Boolean']['output'];
  key?: Maybe<Scalars['String']['output']>;
  shareKeyPermission?: Maybe<CardPermission>;
};

export type CardPublicationFilterInput = {
  and?: InputMaybe<Array<CardPublicationFilterInput>>;
  isPublished?: InputMaybe<BooleanOperationFilterInput>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CardPublicationFilterInput>>;
  shareKeyPermission?: InputMaybe<NullableOfCardPermissionOperationFilterInput>;
};

export type CardPublicationSortInput = {
  isPublished?: InputMaybe<SortEnumType>;
  key?: InputMaybe<SortEnumType>;
  shareKeyPermission?: InputMaybe<SortEnumType>;
};

export type CardPublishResult = {
  cardId: Scalars['String']['output'];
  commandId: Scalars['String']['output'];
  shareKey?: Maybe<Scalars['String']['output']>;
};

export type CardShapeInput = {
  index?: InputMaybe<Scalars['String']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  opacity?: InputMaybe<Scalars['Float']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  props?: InputMaybe<CardShapePropsInput>;
  rotation?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
};

export type CardShapeLocation = {
  cardId: Scalars['String']['output'];
  shape: CardShapeOutput;
  whiteboardId: Scalars['String']['output'];
};

export type CardShapeOutput = {
  id?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['String']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  opacity?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  props?: Maybe<CardShapePropsOutput>;
  rotation?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

export type CardShapePropsInput = {
  cardType?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  h?: InputMaybe<Scalars['Float']['input']>;
  isFitToContent?: InputMaybe<Scalars['Boolean']['input']>;
  isLoading?: InputMaybe<Scalars['Boolean']['input']>;
  isSpotlighted?: InputMaybe<Scalars['Boolean']['input']>;
  w?: InputMaybe<Scalars['Float']['input']>;
};

export type CardShapePropsOutput = {
  author?: Maybe<Scalars['String']['output']>;
  authorId?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  h?: Maybe<Scalars['Float']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  w?: Maybe<Scalars['Float']['output']>;
};

export type CardSourceInput = {
  cardId: Scalars['String']['input'];
  shapeId?: InputMaybe<Scalars['String']['input']>;
  whiteboardId: Scalars['String']['input'];
};

export type CardState = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  permissions: Array<KeyValuePairOfStringAndCardPermission>;
  shareKey?: Maybe<Scalars['String']['output']>;
  status: CardStatus;
};

export enum CardStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Deleted = 'DELETED'
}

export type CardStatusOperationFilterInput = {
  eq?: InputMaybe<CardStatus>;
  in?: InputMaybe<Array<CardStatus>>;
  neq?: InputMaybe<CardStatus>;
  nin?: InputMaybe<Array<CardStatus>>;
};

export type CardWhiteboardOccurrence = {
  id: Scalars['String']['output'];
  knownRanklist?: Maybe<Scalars['String']['output']>;
  shapeIds: Array<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type CardsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<CardsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CardDetailsDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CardsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CardDetailsDocument;
};

export type CardsMutations = {
  addToLibrary: CardCommandResult;
  allowAnonymousEdit: CardCommandResult;
  archive: CardCommandResult;
  /** @deprecated Use copyDocument and handle shape on client side */
  copyToWhiteboard: CardLocation;
  createAtWhiteboard: CardShapeLocation;
  createInLibrary: CardCommandResult;
  delete: CardCommandResult;
  denyAnonymousEdit: CardCommandResult;
  generatePreprint: StreamingPreprint;
  grantPermission: CardCommandResult;
  leave: CardCommandResult;
  /** @deprecated Use copyDocument and handle shape on client side */
  moveToWhiteboard: CardLocation;
  permanentlyDelete: CardCommandResult;
  publish: CardPublishResult;
  rename: CardCommandResult;
  restore: CardCommandResult;
  revokePermission: CardCommandResult;
  transferOwnership: CardCommandResult;
  /** @deprecated Use Restore instead */
  unarchive: CardCommandResult;
  unpublish: CardCommandResult;
};


export type CardsMutationsAddToLibraryArgs = {
  cardId: Scalars['String']['input'];
  whiteboardId: Scalars['String']['input'];
};


export type CardsMutationsAllowAnonymousEditArgs = {
  cardId: Scalars['String']['input'];
};


export type CardsMutationsArchiveArgs = {
  cardId: Scalars['String']['input'];
};


export type CardsMutationsCopyToWhiteboardArgs = {
  from: CardSourceInput;
  synced?: InputMaybe<Scalars['Boolean']['input']>;
  to: CardDestinationInput;
};


export type CardsMutationsCreateAtWhiteboardArgs = {
  cardId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<CardInitialContentInput>;
  shape: CardShapeInput;
  whiteboardId: Scalars['String']['input'];
};


export type CardsMutationsCreateInLibraryArgs = {
  cardId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type CardsMutationsDeleteArgs = {
  cardId: Scalars['String']['input'];
};


export type CardsMutationsDenyAnonymousEditArgs = {
  cardId: Scalars['String']['input'];
};


export type CardsMutationsGeneratePreprintArgs = {
  agent?: InputMaybe<SupportedAgent>;
  contentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  expandReferences?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<SupportedModel>;
  parentWhiteboardId?: InputMaybe<Scalars['String']['input']>;
  preprintId: Scalars['String']['input'];
  promptId: Scalars['String']['input'];
  shareKey?: InputMaybe<Scalars['String']['input']>;
  useWebSearch?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CardsMutationsGrantPermissionArgs = {
  cardId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  initialize?: InputMaybe<Scalars['Boolean']['input']>;
  role: CardPermission;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type CardsMutationsLeaveArgs = {
  cardId: Scalars['String']['input'];
};


export type CardsMutationsMoveToWhiteboardArgs = {
  from: CardSourceInput;
  to: CardDestinationInput;
};


export type CardsMutationsPermanentlyDeleteArgs = {
  cardId: Scalars['String']['input'];
};


export type CardsMutationsPublishArgs = {
  cardId: Scalars['String']['input'];
  initialize?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CardsMutationsRenameArgs = {
  cardId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  whiteboardId?: InputMaybe<Scalars['String']['input']>;
};


export type CardsMutationsRestoreArgs = {
  cardId: Scalars['String']['input'];
};


export type CardsMutationsRevokePermissionArgs = {
  cardId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type CardsMutationsTransferOwnershipArgs = {
  cardId: Scalars['String']['input'];
  correlationId?: InputMaybe<Scalars['String']['input']>;
  newOwnerEmail: Scalars['String']['input'];
};


export type CardsMutationsUnarchiveArgs = {
  cardId: Scalars['String']['input'];
};


export type CardsMutationsUnpublishArgs = {
  cardId: Scalars['String']['input'];
};

export type CheckoutPriceIds = {
  /** @deprecated No longer supported. */
  believer?: Maybe<PlanPriceIds>;
  pro: PlanPriceIds;
  starter: PlanPriceIds;
};

export type CheckoutSession = {
  secret: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

export type CheckoutSessionStatus = {
  customerEmail?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ClockInfo = {
  isRunning: Scalars['Boolean']['output'];
  now: Scalars['DateTime']['output'];
  utcNow: Scalars['DateTime']['output'];
};

export type ClockMutations = {
  setLocal: ClockInfo;
  setUtc: ClockInfo;
  start: ClockInfo;
  stop: ClockInfo;
};


export type ClockMutationsSetLocalArgs = {
  localNow: Scalars['DateTime']['input'];
};


export type ClockMutationsSetUtcArgs = {
  utcNow: Scalars['DateTime']['input'];
};

export type ClockQuery = {
  current: ClockInfo;
};

export type ClosedBalance = {
  extraCreditsDraw: Scalars['UnsignedLong']['output'];
  extraCreditsUsed: Scalars['UnsignedLong']['output'];
  quotaCreditsUsed: Scalars['UnsignedLong']['output'];
  remainingExtraCredits: Scalars['UnsignedLong']['output'];
  totalUsedCredits: Scalars['UnsignedLong']['output'];
};

export type ClosedBalancePeriod = {
  budget: Scalars['UnsignedLong']['output'];
  extraUsageCredits: Scalars['UnsignedLong']['output'];
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  spendUsd: Scalars['Decimal']['output'];
  totalUsedCredits: Scalars['UnsignedLong']['output'];
  usagePerModel: Array<ModelPeriodUsage>;
};

export type Collaboration = {
  collaborators: Array<Collaborator>;
  isShared: Scalars['Boolean']['output'];
};

export type CollaborationFilterInput = {
  and?: InputMaybe<Array<CollaborationFilterInput>>;
  collaborators?: InputMaybe<ListFilterInputTypeOfCollaboratorFilterInput>;
  isShared?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<CollaborationFilterInput>>;
};

export type CollaborationSortInput = {
  isShared?: InputMaybe<SortEnumType>;
};

export type Collaborator = {
  details?: Maybe<UserDetails>;
  permission: WhiteboardPermission;
  userEmail: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type CollaboratorFilterInput = {
  and?: InputMaybe<Array<CollaboratorFilterInput>>;
  or?: InputMaybe<Array<CollaboratorFilterInput>>;
  permission?: InputMaybe<WhiteboardPermissionOperationFilterInput>;
  userEmail?: InputMaybe<StringOperationFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
};

/** Base interface for command results with global position tracking. Use the position to wait for projections to catch up. */
export type CommandResult = {
  /** Global position in the event store after command execution. Use this to wait for read model projections to catch up. */
  position: Scalars['UnsignedLong']['output'];
};

export type CommandResultOfUserPlanState = {
  causationId?: Maybe<Scalars['String']['output']>;
  commandId: Scalars['String']['output'];
  correlationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  state?: Maybe<UserPlanState>;
};

export type CommandSuccessResultOfAiProfileState = CommandResult & {
  position: Scalars['UnsignedLong']['output'];
  state: AiProfileState;
};

export type CommandSuccessResultOfUserPlanState = CommandResult & {
  position: Scalars['UnsignedLong']['output'];
  state: UserPlanState;
};

export type ComparableDateOnlyOperationFilterInput = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<Scalars['Date']['input']>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  neq?: InputMaybe<Scalars['Date']['input']>;
  ngt?: InputMaybe<Scalars['Date']['input']>;
  ngte?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<Scalars['Date']['input']>>;
  nlt?: InputMaybe<Scalars['Date']['input']>;
  nlte?: InputMaybe<Scalars['Date']['input']>;
};

export type ComparableDateTimeOffsetOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ComparableDateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ComparableNullableOfDateTimeOffsetOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ComparableNullableOfDateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ComparableNullableOfDecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ComparableUInt64OperationFilterInput = {
  eq?: InputMaybe<Scalars['UnsignedLong']['input']>;
  gt?: InputMaybe<Scalars['UnsignedLong']['input']>;
  gte?: InputMaybe<Scalars['UnsignedLong']['input']>;
  in?: InputMaybe<Array<Scalars['UnsignedLong']['input']>>;
  lt?: InputMaybe<Scalars['UnsignedLong']['input']>;
  lte?: InputMaybe<Scalars['UnsignedLong']['input']>;
  neq?: InputMaybe<Scalars['UnsignedLong']['input']>;
  ngt?: InputMaybe<Scalars['UnsignedLong']['input']>;
  ngte?: InputMaybe<Scalars['UnsignedLong']['input']>;
  nin?: InputMaybe<Array<Scalars['UnsignedLong']['input']>>;
  nlt?: InputMaybe<Scalars['UnsignedLong']['input']>;
  nlte?: InputMaybe<Scalars['UnsignedLong']['input']>;
};

export type CompletedOnboardingStep = {
  position?: Maybe<Scalars['UnsignedLong']['output']>;
  steps: Array<KeyValuePairOfOnboardingStepAndStepStatus>;
};

export type ContentPart = {
  type: Scalars['String']['output'];
};

export type ContextPart = {
  blockId?: Maybe<Scalars['String']['output']>;
  document?: Maybe<DocumentContext>;
  image?: Maybe<ImageContext>;
  role: MessageRole;
  text?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  webLink?: Maybe<WebLinkContext>;
};

export type ContextSource = {
  parts: Array<ContextPart>;
  role: MessageRole;
  sourceId: Scalars['String']['output'];
};

export type CreateDemoBoardResult = {
  demoSessionId: Scalars['String']['output'];
  shareKey: Scalars['String']['output'];
  whiteboardId: Scalars['String']['output'];
  whiteboardUrl: Scalars['String']['output'];
};

export type CreditBalanceData = {
  closedPeriods: Array<ClosedBalancePeriod>;
  confirmedDraw: Scalars['UnsignedLong']['output'];
  firstBalanceTopupAt?: Maybe<Scalars['DateTime']['output']>;
  hasOpeningBalance: Scalars['Boolean']['output'];
  periodStart?: Maybe<Scalars['DateTime']['output']>;
  processedIdempotencyKeys: Array<Scalars['String']['output']>;
  purchasedCredits: Scalars['UnsignedLong']['output'];
};

export type CustomerUrlsDto = {
  portal?: Maybe<Scalars['String']['output']>;
  updatePaymentMethod?: Maybe<Scalars['String']['output']>;
};

export type DemoMutations = {
  createBoard: CreateDemoBoardResult;
};


export type DemoMutationsCreateBoardArgs = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
};

export type DeveloperMutations = {
  issueTestToken: TestUserResult;
  personalAccessToken: PersonalAccessTokenMutations;
};


export type DeveloperMutationsIssueTestTokenArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type DeveloperQueries = {
  personalAccessToken: PersonalAccessTokenQueries;
};

export enum Dimension {
  Days = 'DAYS',
  Quantity = 'QUANTITY',
  Tokens = 'TOKENS'
}

export type DocumentContext = {
  caption?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DocumentCopy = {
  id: Scalars['String']['output'];
};

export type DocumentCurrentState = {
  authors: Array<AuthorInfo>;
  description?: Maybe<Scalars['String']['output']>;
  documentName: Scalars['String']['output'];
  inMemorySize: Scalars['Int']['output'];
  isSynced: Scalars['Boolean']['output'];
  persistedSize: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export type DocumentMutations = {
  copy: DocumentCopy;
};


export type DocumentMutationsCopyArgs = {
  allowOverride?: InputMaybe<Scalars['Boolean']['input']>;
  parentWhiteboardId?: InputMaybe<Scalars['String']['input']>;
  shareKey?: InputMaybe<Scalars['String']['input']>;
  sourceTypedId: Scalars['String']['input'];
  targetTypedId?: InputMaybe<Scalars['String']['input']>;
};

export enum DocumentPermission {
  Deny = 'DENY',
  Editor = 'EDITOR',
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

export type DocumentPermissions = {
  access: Array<KeyValuePairOfStringAndDocumentPermission>;
  email?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use access instead */
  permissions: Array<KeyValuePairOfStringAndYjsDocumentPermission>;
  shareKey?: Maybe<Scalars['String']['output']>;
};

export type DocumentTrail = {
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<EditorUserInfo>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<EditorUserInfo>;
};

export type DocumentTrailFilterInput = {
  and?: InputMaybe<Array<DocumentTrailFilterInput>>;
  createdAt?: InputMaybe<ComparableDateTimeOffsetOperationFilterInput>;
  createdBy?: InputMaybe<EditorUserInfoFilterInput>;
  or?: InputMaybe<Array<DocumentTrailFilterInput>>;
  updatedAt?: InputMaybe<ComparableDateTimeOffsetOperationFilterInput>;
  updatedBy?: InputMaybe<EditorUserInfoFilterInput>;
};

export type DocumentTrailSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<EditorUserInfoSortInput>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<EditorUserInfoSortInput>;
};

export type DocumentVersion = {
  authors: Array<AuthorInfo>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documentName: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  retentionClass: RetentionClass;
  size: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export type DraftDocument = ProjectedDocument & {
  date: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  position: Scalars['UnsignedLong']['output'];
  streamPosition: Scalars['UnsignedLong']['output'];
  userId: Scalars['String']['output'];
};

export type DraftDocumentFilterInput = {
  and?: InputMaybe<Array<DraftDocumentFilterInput>>;
  date?: InputMaybe<ComparableDateOnlyOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DraftDocumentFilterInput>>;
  position?: InputMaybe<ComparableUInt64OperationFilterInput>;
  streamPosition?: InputMaybe<ComparableUInt64OperationFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
};

export type DraftDocumentSortInput = {
  date?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  position?: InputMaybe<SortEnumType>;
  streamPosition?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type DraftIndexConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<DraftIndexEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DraftIndexDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DraftIndexDocument = {
  date: Scalars['Date']['output'];
  document?: Maybe<Scalars['Any']['output']>;
  hasContent: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  markdown?: Maybe<Scalars['String']['output']>;
  specialBlocks?: Maybe<SpecialBlocks>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type DraftIndexDocumentSortInput = {
  date?: InputMaybe<SortEnumType>;
  document?: InputMaybe<SortEnumType>;
  hasContent?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  markdown?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type DraftIndexEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DraftIndexDocument;
};

export type DraftQuery = {
  drafts?: Maybe<DraftsConnection>;
  index?: Maybe<DraftIndexConnection>;
};


export type DraftQueryDraftsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DraftDocumentSortInput>>;
  where?: InputMaybe<DraftDocumentFilterInput>;
};


export type DraftQueryIndexArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  hasAudios?: InputMaybe<Scalars['Boolean']['input']>;
  hasFiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasImages?: InputMaybe<Scalars['Boolean']['input']>;
  hasTasks?: InputMaybe<Scalars['Boolean']['input']>;
  hasVideos?: InputMaybe<Scalars['Boolean']['input']>;
  hasWhatsappMessages?: InputMaybe<Scalars['Boolean']['input']>;
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DraftIndexDocumentSortInput>>;
  query?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type DraftsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<DraftsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DraftDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DraftsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DraftDocument;
};

export type EditorUserInfo = {
  clientId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type EditorUserInfoFilterInput = {
  and?: InputMaybe<Array<EditorUserInfoFilterInput>>;
  clientId?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EditorUserInfoFilterInput>>;
  userId?: InputMaybe<StringOperationFilterInput>;
};

export type EditorUserInfoSortInput = {
  clientId?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

export type EntityIdInput = {
  id: Scalars['String']['input'];
  type: FeatureEntity;
};

export type EstablishedOpenBalance = {
  credits: Scalars['UnsignedLong']['output'];
  establishedAt: Scalars['DateTime']['output'];
  usd: Scalars['Decimal']['output'];
};

export type EventProjectedOfPlanDocument = {
  entityId: Scalars['String']['output'];
  event: ProjectedEventOfPlanDocument;
  handlerName: Scalars['String']['output'];
  isSuccess: Scalars['Boolean']['output'];
  projectedTime: Scalars['DateTime']['output'];
  sequence: Scalars['UnsignedLong']['output'];
  subscriptionName: Scalars['String']['output'];
};

export type EventProjectedOfString = {
  entityId: Scalars['String']['output'];
  event: ProjectedEventOfString;
  handlerName: Scalars['String']['output'];
  isSuccess: Scalars['Boolean']['output'];
  projectedTime: Scalars['DateTime']['output'];
  sequence: Scalars['UnsignedLong']['output'];
  subscriptionName: Scalars['String']['output'];
};

export type ExternalIdentity = {
  id: Scalars['String']['output'];
  provider: Scalars['String']['output'];
};

export type ExternalIdentityFilterInput = {
  and?: InputMaybe<Array<ExternalIdentityFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ExternalIdentityFilterInput>>;
  provider?: InputMaybe<StringOperationFilterInput>;
};

export type ExternalPlan = {
  id?: Maybe<Scalars['String']['output']>;
  scheduleId?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<ExternalTerms>;
  url?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ExternalPlanInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  scheduleId?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<ExternalTermsInput>;
  url?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalTerms = {
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ExternalTermsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ExtractedDocument = {
  createdAt?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type ExtractedMarkdown = {
  id: Scalars['String']['output'];
  markdown: Scalars['String']['output'];
};

export enum FeatureEntity {
  User = 'USER',
  Whiteboard = 'WHITEBOARD'
}

export type FeatureState = IFeatureState & {
  available: Scalars['Boolean']['output'];
  feature: SupportedFeature;
};

export type FeatureTerms = {
  available: Scalars['Boolean']['output'];
  feature: SupportedFeature;
};

export type FileBlock = {
  caption?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FileContentPart = ContentPart & {
  caption?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type FilesQuery = {
  /** @deprecated Use PrepareUpload instead */
  signedUploadUrl: Scalars['String']['output'];
};


export type FilesQuerySignedUploadUrlArgs = {
  cardTypedId?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
};

export type FolderTreeItem = TreeItem & {
  hasChildren: Scalars['Boolean']['output'];
  icon?: Maybe<IconInfo>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentKey?: Maybe<Scalars['String']['output']>;
  rank: Scalars['String']['output'];
  status?: Maybe<WhiteboardStatus>;
  type: NavBarItemType;
};

export type FreeMonthsInfo = {
  discountEndsAt?: Maybe<Scalars['DateTime']['output']>;
  freeMonthsRemaining: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  rewardCodes: Array<Scalars['String']['output']>;
  totalFreeMonths: Scalars['Int']['output'];
};

export type GenerateAnswerCardStreamingMutationResolver = {
  executePreprint: StreamingPreprint;
};


export type GenerateAnswerCardStreamingMutationResolverExecutePreprintArgs = {
  agent?: InputMaybe<SupportedAgent>;
  contentCardIds: Array<Scalars['String']['input']>;
  expandReferences: Scalars['Boolean']['input'];
  model: SupportedModel;
  preprintId: PreprintIdInput;
  promptCardId: CardIdInput;
  shareKey?: InputMaybe<Scalars['String']['input']>;
  useWebSearch: Scalars['Boolean']['input'];
  user: ImpliedUserInput;
};

export type GraduateFromBetaResult = {
  plan?: Maybe<CommandSuccessResultOfUserPlanState>;
  wasMigrated: Scalars['Boolean']['output'];
};

export type GuestWebSocketTokenPayload = {
  expiresAt: Scalars['DateTime']['output'];
  token: Scalars['String']['output'];
  whiteboardId: Scalars['String']['output'];
};

export type HistoryMutation = {
  restoreVersion?: Maybe<RestoreVersionResult>;
  saveVersion?: Maybe<SaveVersionResult>;
};


export type HistoryMutationRestoreVersionArgs = {
  deep?: InputMaybe<Scalars['Boolean']['input']>;
  shareKey?: InputMaybe<Scalars['String']['input']>;
  typedId: Scalars['String']['input'];
  versionNumber: Scalars['Int']['input'];
};


export type HistoryMutationSaveVersionArgs = {
  shareKey?: InputMaybe<Scalars['String']['input']>;
  typedId: Scalars['String']['input'];
  versionName?: InputMaybe<Scalars['String']['input']>;
};

export type HistoryQuery = {
  current?: Maybe<DocumentCurrentState>;
  versions?: Maybe<Array<DocumentVersion>>;
};


export type HistoryQueryCurrentArgs = {
  shareKey?: InputMaybe<Scalars['String']['input']>;
  typedId: Scalars['String']['input'];
};


export type HistoryQueryVersionsArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  shareKey?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  typedId: Scalars['String']['input'];
  versionName?: InputMaybe<Scalars['String']['input']>;
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type IFeatureState = {
  available: Scalars['Boolean']['output'];
  feature: SupportedFeature;
};

export type IconDocumentFilterInput = {
  and?: InputMaybe<Array<IconDocumentFilterInput>>;
  or?: InputMaybe<Array<IconDocumentFilterInput>>;
  type?: InputMaybe<StringOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type IconDocumentSortInput = {
  type?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

export type IconInfo = {
  type: IconType;
  value: Scalars['String']['output'];
};

export type IconInput = {
  type: IconType;
  value: Scalars['String']['input'];
};

export enum IconType {
  Emoji = 'EMOJI'
}

export type IllumiPlansCheckOutUrls = {
  /** @deprecated No longer supported. */
  believer?: Maybe<PlanVariant>;
  pro: PlanVariant;
  starter: PlanVariant;
};

export type ImageBlock = {
  caption?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ImageContentPart = ContentPart & {
  caption?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ImageContext = {
  caption?: Maybe<Scalars['String']['output']>;
  imageBytes: Scalars['Int']['output'];
  imageFormat: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type ImpliedUserInput = {
  email: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  id: UserIdInput;
};

export type IngestMutations = {
  extractMarkdown?: Maybe<ExtractedMarkdown>;
  retryIngest: Scalars['Boolean']['output'];
};


export type IngestMutationsExtractMarkdownArgs = {
  assetId?: InputMaybe<Scalars['String']['input']>;
  extractId?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  urlAuth?: InputMaybe<UrlAuthInput>;
};


export type IngestMutationsRetryIngestArgs = {
  assetId: Scalars['String']['input'];
  shareKey?: InputMaybe<Scalars['String']['input']>;
};

export type IngestQueries = {
  extractedMarkdown?: Maybe<ExtractedDocument>;
};


export type IngestQueriesExtractedMarkdownArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type InitialWhiteboardReadyNotification = {
  correlationId?: Maybe<Scalars['String']['output']>;
  preloadedWhiteboards: Array<WhiteboardPreload>;
  templateLibraryWhiteboards: Array<WhiteboardPreload>;
  userId: Scalars['String']['output'];
};

export type Intake = {
  isOpen: Scalars['Boolean']['output'];
  key?: Maybe<Scalars['String']['output']>;
};

export type IntakeCardResult = {
  cardId: Scalars['String']['output'];
  whiteboardId: Scalars['String']['output'];
};

export type IntakeFilterInput = {
  and?: InputMaybe<Array<IntakeFilterInput>>;
  isOpen?: InputMaybe<BooleanOperationFilterInput>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IntakeFilterInput>>;
};

export type IntakeSortInput = {
  isOpen?: InputMaybe<SortEnumType>;
  key?: InputMaybe<SortEnumType>;
};

export type IntakeState = {
  intakeKey?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
};

export type IntegrationsQuery = {
  /** @deprecated Use unfurl instead */
  siteMeta: UrlMeta;
  unfurl: UrlPreviewInfo;
  whatsAppPhoneNumber: Scalars['String']['output'];
};


export type IntegrationsQuerySiteMetaArgs = {
  url: Scalars['String']['input'];
};


export type IntegrationsQueryUnfurlArgs = {
  location?: InputMaybe<Scalars['String']['input']>;
  shareKey?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export enum InviteStatus {
  Accepted = 'ACCEPTED',
  Ignored = 'IGNORED',
  Waiting = 'WAITING'
}

export type InviteStatusOperationFilterInput = {
  eq?: InputMaybe<InviteStatus>;
  in?: InputMaybe<Array<InviteStatus>>;
  neq?: InputMaybe<InviteStatus>;
  nin?: InputMaybe<Array<InviteStatus>>;
};

export type IssuedPersonalAccessToken = {
  personalAccessToken: PersonalAccessTokenInfo;
  token: Scalars['String']['output'];
};

export type ItemToMoveInput = {
  afterKey?: InputMaybe<Scalars['String']['input']>;
  beforeKey?: InputMaybe<Scalars['String']['input']>;
  itemKey: Scalars['String']['input'];
  parentKey?: InputMaybe<Scalars['String']['input']>;
};

export type KeyValuePairOfOnboardingStepAndStepStatus = {
  key: OnboardingStep;
  value: StepStatus;
};

export type KeyValuePairOfStringAndCardPermission = {
  key: Scalars['String']['output'];
  value: CardPermission;
};

export type KeyValuePairOfStringAndDocumentPermission = {
  key: Scalars['String']['output'];
  value: DocumentPermission;
};

export type KeyValuePairOfStringAndIReadOnlyListOfString = {
  key: Scalars['String']['output'];
  value: Array<Scalars['String']['output']>;
};

export type KeyValuePairOfStringAndInt64 = {
  key: Scalars['String']['output'];
  value: Scalars['Long']['output'];
};

export type KeyValuePairOfStringAndRanklistItem = {
  key: Scalars['String']['output'];
  value: RanklistItem;
};

export type KeyValuePairOfStringAndRewardCode = {
  key: Scalars['String']['output'];
  value: Scalars['RewardCodeScalar']['output'];
};

export type KeyValuePairOfStringAndString = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type KeyValuePairOfStringAndStringInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type KeyValuePairOfStringAndWhiteboardPermission = {
  key: Scalars['String']['output'];
  value: WhiteboardPermission;
};

export type KeyValuePairOfStringAndYjsDocumentPermission = {
  key: Scalars['String']['output'];
  value: DocumentPermission;
};

export type KeyValuePairOfSupportedAgentAndListOfSupportedModel = {
  key: SupportedAgent;
  value: Array<SupportedModel>;
};

export type KeyValuePairOfUserAgreementAndAgreementStatus = {
  key: UserAgreement;
  value: AgreementStatus;
};

export enum KnownUserRanklists {
  Favourites = 'FAVOURITES',
  MyWhiteboards = 'MY_WHITEBOARDS',
  SharedWithMe = 'SHARED_WITH_ME'
}

/** A connection to a list of items. */
export type LibraryCardIndexConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<LibraryCardIndexEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LibraryCardIndexDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type LibraryCardIndexDocument = ProjectedDocument & {
  document?: Maybe<Scalars['Any']['output']>;
  hasContent: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  markdown?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ownerEmail: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  position: Scalars['UnsignedLong']['output'];
  specialBlocks?: Maybe<SpecialBlocks>;
  streamPosition: Scalars['UnsignedLong']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LibraryCardIndexDocumentSortInput = {
  document?: InputMaybe<SortEnumType>;
  hasContent?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  markdown?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  ownerEmail?: InputMaybe<SortEnumType>;
  ownerId?: InputMaybe<SortEnumType>;
  position?: InputMaybe<SortEnumType>;
  streamPosition?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type LibraryCardIndexEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LibraryCardIndexDocument;
};

export type LibraryQueries = {
  card?: Maybe<CardDetailsDocument>;
  cards?: Maybe<CardsConnection>;
  index?: Maybe<LibraryCardIndexConnection>;
};


export type LibraryQueriesCardArgs = {
  cardId: Scalars['String']['input'];
  shareKey?: InputMaybe<Scalars['String']['input']>;
};


export type LibraryQueriesCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CardDetailsDocumentSortInput>>;
  where?: InputMaybe<CardDetailsDocumentFilterInput>;
};


export type LibraryQueriesIndexArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasAudios?: InputMaybe<Scalars['Boolean']['input']>;
  hasFiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasImages?: InputMaybe<Scalars['Boolean']['input']>;
  hasTasks?: InputMaybe<Scalars['Boolean']['input']>;
  hasVideos?: InputMaybe<Scalars['Boolean']['input']>;
  hasWhatsappMessages?: InputMaybe<Scalars['Boolean']['input']>;
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LibraryCardIndexDocumentSortInput>>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type ListFilterInputTypeOfCardCollaboratorFilterInput = {
  all?: InputMaybe<CardCollaboratorFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CardCollaboratorFilterInput>;
  some?: InputMaybe<CardCollaboratorFilterInput>;
};

export type ListFilterInputTypeOfCollaboratorFilterInput = {
  all?: InputMaybe<CollaboratorFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CollaboratorFilterInput>;
  some?: InputMaybe<CollaboratorFilterInput>;
};

export type ListFilterInputTypeOfExternalIdentityFilterInput = {
  all?: InputMaybe<ExternalIdentityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ExternalIdentityFilterInput>;
  some?: InputMaybe<ExternalIdentityFilterInput>;
};

export type ListFilterInputTypeOfRankingFilterInput = {
  all?: InputMaybe<RankingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RankingFilterInput>;
  some?: InputMaybe<RankingFilterInput>;
};

export type ListFilterInputTypeOfRanklistItemFilterInput = {
  all?: InputMaybe<RanklistItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RanklistItemFilterInput>;
  some?: InputMaybe<RanklistItemFilterInput>;
};

export type ListFilterInputTypeOfUserAccessFilterInput = {
  all?: InputMaybe<UserAccessFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UserAccessFilterInput>;
  some?: InputMaybe<UserAccessFilterInput>;
};

export type ListItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  parentKey?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type MentionInboxConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<MentionInboxEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MentionInboxItem>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MentionInboxEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MentionInboxItem;
};

export enum MentionInboxEventType {
  AllMarkedRead = 'ALL_MARKED_READ',
  MentionMarkedRead = 'MENTION_MARKED_READ',
  MentionReceived = 'MENTION_RECEIVED'
}

export type MentionInboxItem = {
  anchorId?: Maybe<Scalars['String']['output']>;
  authorAvatarUrl?: Maybe<Scalars['String']['output']>;
  authorId: Scalars['String']['output'];
  authorName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deepLink: Scalars['String']['output'];
  id: Scalars['String']['output'];
  idempotencyId: Scalars['String']['output'];
  isRead: Scalars['Boolean']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  snippet: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
};

export type MentionInboxItemFilterInput = {
  anchorId?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<MentionInboxItemFilterInput>>;
  authorAvatarUrl?: InputMaybe<StringOperationFilterInput>;
  authorId?: InputMaybe<StringOperationFilterInput>;
  authorName?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<ComparableDateTimeOffsetOperationFilterInput>;
  deepLink?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  idempotencyId?: InputMaybe<StringOperationFilterInput>;
  isRead?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<MentionInboxItemFilterInput>>;
  readAt?: InputMaybe<ComparableNullableOfDateTimeOffsetOperationFilterInput>;
  snippet?: InputMaybe<StringOperationFilterInput>;
  sourceId?: InputMaybe<StringOperationFilterInput>;
};

export type MentionInboxItemSortInput = {
  anchorId?: InputMaybe<SortEnumType>;
  authorAvatarUrl?: InputMaybe<SortEnumType>;
  authorId?: InputMaybe<SortEnumType>;
  authorName?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  deepLink?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idempotencyId?: InputMaybe<SortEnumType>;
  isRead?: InputMaybe<SortEnumType>;
  readAt?: InputMaybe<SortEnumType>;
  snippet?: InputMaybe<SortEnumType>;
  sourceId?: InputMaybe<SortEnumType>;
};

export type MentionInboxUpdatePayload = {
  eventType: MentionInboxEventType;
  mention?: Maybe<MentionInboxItem>;
  mentionId?: Maybe<Scalars['String']['output']>;
  unreadCount: Scalars['Int']['output'];
};

export type MentionPayload = {
  mentionId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type MentionSuggestion = {
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  lastSelectedAt?: Maybe<Scalars['DateTime']['output']>;
  selectedTimes?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MentionSuggestions = {
  latestUpdated: Array<MentionSuggestion>;
  matches: Array<MentionSuggestion>;
  recentlySelected: Array<MentionSuggestion>;
  sessionId: Scalars['String']['output'];
};

export type MentionsMutations = {
  markAllAsRead: Scalars['Boolean']['output'];
  markAsRead: Scalars['Boolean']['output'];
  markSelected?: Maybe<MentionSuggestion>;
  mention: MentionPayload;
};


export type MentionsMutationsMarkAllAsReadArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MentionsMutationsMarkAsReadArgs = {
  mentionId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MentionsMutationsMarkSelectedArgs = {
  id: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MentionsMutationsMentionArgs = {
  anchorId?: InputMaybe<Scalars['String']['input']>;
  deepLink: Scalars['String']['input'];
  idempotencyId: Scalars['String']['input'];
  mentionedUserId: Scalars['String']['input'];
  snippet: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type MentionsQuery = {
  inbox?: Maybe<MentionInboxConnection>;
  labels: Array<MentionSuggestion>;
  suggest: MentionSuggestions;
  suggestPeople: Array<PersonSuggestion>;
  unreadCount: Scalars['Int']['output'];
};


export type MentionsQueryInboxArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MentionInboxItemSortInput>>;
  userId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<MentionInboxItemFilterInput>;
};


export type MentionsQueryLabelsArgs = {
  ids: Array<Scalars['String']['input']>;
  updatedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MentionsQuerySuggestArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MentionsQuerySuggestPeopleArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  targetDocumentId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MentionsQueryUnreadCountArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export enum MessageRole {
  Assistant = 'ASSISTANT',
  System = 'SYSTEM',
  User = 'USER'
}

export type MeteredFeatureState = IFeatureState & {
  available: Scalars['Boolean']['output'];
  current: Scalars['UnsignedLong']['output'];
  dimension: Dimension;
  feature: SupportedFeature;
  quota: Scalars['UnsignedLong']['output'];
};

export type MeteredPerEntityFeatureState = IFeatureState & {
  available: Scalars['Boolean']['output'];
  current: Scalars['UnsignedLong']['output'];
  dimension: Dimension;
  entity: FeatureEntity;
  entityId: Scalars['String']['output'];
  feature: SupportedFeature;
  quota: Scalars['UnsignedLong']['output'];
};

export type MeteredPerPeriodFeatureState = IFeatureState & {
  available: Scalars['Boolean']['output'];
  current: Scalars['UnsignedLong']['output'];
  feature: SupportedFeature;
  period: Scalars['Duration']['output'];
  periodReset: Scalars['DateTime']['output'];
  quota: Scalars['UnsignedLong']['output'];
};

export type MeteredPerPeriodWithBalanceFeatureState = IFeatureState & {
  available: Scalars['Boolean']['output'];
  balance: Scalars['UnsignedLong']['output'];
  balanceUsedThisPeriod: Scalars['UnsignedLong']['output'];
  current: Scalars['UnsignedLong']['output'];
  feature: SupportedFeature;
  featureAvailable: Scalars['Boolean']['output'];
  period: Scalars['Duration']['output'];
  periodReset: Scalars['DateTime']['output'];
  quota: Scalars['UnsignedLong']['output'];
};

export enum Modality {
  Image = 'IMAGE',
  Text = 'TEXT'
}

export type ModelPeriodUsage = {
  inputTokens: Scalars['UnsignedLong']['output'];
  modelId: Scalars['String']['output'];
  outputTokens: Scalars['UnsignedLong']['output'];
  spendUsd: Scalars['Decimal']['output'];
  usedCredits: Scalars['UnsignedLong']['output'];
};

export type ModelUsageNoSpend = {
  inputTokens: Scalars['UnsignedLong']['output'];
  modelId: Scalars['String']['output'];
  outputTokens: Scalars['UnsignedLong']['output'];
  usedCredits: Scalars['UnsignedLong']['output'];
};

export type Mutation = {
  ai: AiMutations;
  assets: AssetMutations;
  cards: CardsMutations;
  clock: ClockMutations;
  demo: DemoMutations;
  documents: DocumentMutations;
  history: HistoryMutation;
  ingest: IngestMutations;
  mentions: MentionsMutations;
  navbar: NavbarMutations;
  plans: PlansMutations;
  ranklists: RanklistMutations;
  referrals: ReferralsMutations;
  trash: TrashBinMutations;
  user: UserMutations;
  whiteboards: WhiteboardMutations;
};

export type MyAgentDescription = {
  agent: SupportedAgent;
  defaultModels: Array<SupportedModelAvailability>;
  hasCustomPreferences: Scalars['Boolean']['output'];
  models: Array<SupportedModelAvailability>;
};

export type MyReferralsInfo = {
  qualifiedReferralCount: Scalars['Int']['output'];
  referralCode?: Maybe<Scalars['String']['output']>;
  referrals?: Maybe<Array<ReferralInfo>>;
  referredBy?: Maybe<Scalars['String']['output']>;
  referredByEmail?: Maybe<Scalars['String']['output']>;
  rewards?: Maybe<Array<RewardSummary>>;
  totalRewardsGranted: Scalars['Int']['output'];
  totalRewardsRedeemed: Scalars['Int']['output'];
};

export type MyWhiteboardsDocument = ProjectedDocument & {
  id: Scalars['String']['output'];
  ownedWhiteboards?: Maybe<Array<WhiteboardInfo>>;
  position: Scalars['UnsignedLong']['output'];
  sharedWithMe?: Maybe<Array<WhiteboardAccess>>;
  streamPosition: Scalars['UnsignedLong']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export enum NavBarItemType {
  Board = 'BOARD',
  Card = 'CARD',
  Folder = 'FOLDER'
}

export type NavBarItemTypeOperationFilterInput = {
  eq?: InputMaybe<NavBarItemType>;
  in?: InputMaybe<Array<NavBarItemType>>;
  neq?: InputMaybe<NavBarItemType>;
  nin?: InputMaybe<Array<NavBarItemType>>;
};

export type NavbarCardResult = {
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentKey?: Maybe<Scalars['String']['output']>;
  rank: Scalars['String']['output'];
};

export type NavbarFolderResult = {
  icon?: Maybe<IconInfo>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentKey?: Maybe<Scalars['String']['output']>;
  rank: Scalars['String']['output'];
};

export type NavbarItem = ProjectedDocument & TreeItem & {
  collaboration?: Maybe<Collaboration>;
  hasChildren: Scalars['Boolean']['output'];
  icon?: Maybe<IconInfo>;
  /** The unique identifier for this document */
  id: Scalars['String']['output'];
  intake?: Maybe<Intake>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentKey?: Maybe<Scalars['String']['output']>;
  position: Scalars['UnsignedLong']['output'];
  publication?: Maybe<Publication>;
  rank: Scalars['String']['output'];
  sourceRanklistId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<WhiteboardStatus>;
  streamPosition: Scalars['UnsignedLong']['output'];
  type: NavBarItemType;
};

export type NavbarItemDocumentFilterInput = {
  and?: InputMaybe<Array<NavbarItemDocumentFilterInput>>;
  collaboration?: InputMaybe<CollaborationFilterInput>;
  icon?: InputMaybe<IconDocumentFilterInput>;
  intake?: InputMaybe<IntakeFilterInput>;
  itemKey?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<NavbarItemDocumentFilterInput>>;
  parentKey?: InputMaybe<StringOperationFilterInput>;
  position?: InputMaybe<ComparableUInt64OperationFilterInput>;
  publication?: InputMaybe<PublicationFilterInput>;
  rank?: InputMaybe<StringOperationFilterInput>;
  sourceRanklistId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<NullableOfWhiteboardStatusOperationFilterInput>;
  streamPosition?: InputMaybe<ComparableUInt64OperationFilterInput>;
  type?: InputMaybe<NavBarItemTypeOperationFilterInput>;
};

export type NavbarItemDocumentSortInput = {
  collaboration?: InputMaybe<CollaborationSortInput>;
  icon?: InputMaybe<IconDocumentSortInput>;
  intake?: InputMaybe<IntakeSortInput>;
  itemKey?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parentKey?: InputMaybe<SortEnumType>;
  position?: InputMaybe<SortEnumType>;
  publication?: InputMaybe<PublicationSortInput>;
  rank?: InputMaybe<SortEnumType>;
  sourceRanklistId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  streamPosition?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export type NavbarMutations = {
  addCard?: Maybe<NavbarCardResult>;
  /** @deprecated Use DeleteFolder instead */
  archiveFolder: Scalars['Boolean']['output'];
  createCard?: Maybe<NavbarCardResult>;
  createFolder?: Maybe<NavbarFolderResult>;
  deleteFolder: Scalars['Boolean']['output'];
  favourite: Scalars['Boolean']['output'];
  moveItems?: Maybe<Array<NavbarItem>>;
  removeCard: Scalars['Boolean']['output'];
  removeItemIcon?: Maybe<NavbarItem>;
  renameFolder?: Maybe<NavbarFolderResult>;
  reset?: Maybe<RanklistState>;
  setItemIcon?: Maybe<NavbarItem>;
  unfavourite: Scalars['Boolean']['output'];
};


export type NavbarMutationsAddCardArgs = {
  afterKey?: InputMaybe<Scalars['String']['input']>;
  beforeKey?: InputMaybe<Scalars['String']['input']>;
  cardId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  parentFolderKey?: InputMaybe<Scalars['String']['input']>;
  section: NavbarSection;
  waitForProjections?: Scalars['Boolean']['input'];
};


export type NavbarMutationsArchiveFolderArgs = {
  folderKey: Scalars['String']['input'];
  section: NavbarSection;
  waitForProjections?: Scalars['Boolean']['input'];
};


export type NavbarMutationsCreateCardArgs = {
  afterKey?: InputMaybe<Scalars['String']['input']>;
  beforeKey?: InputMaybe<Scalars['String']['input']>;
  cardId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentFolderKey?: InputMaybe<Scalars['String']['input']>;
  section: NavbarSection;
  waitForProjections?: Scalars['Boolean']['input'];
};


export type NavbarMutationsCreateFolderArgs = {
  afterKey?: InputMaybe<Scalars['String']['input']>;
  beforeKey?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<IconInput>;
  name: Scalars['String']['input'];
  parentFolderKey?: InputMaybe<Scalars['String']['input']>;
  section: NavbarSection;
  waitForProjections?: Scalars['Boolean']['input'];
};


export type NavbarMutationsDeleteFolderArgs = {
  folderKey: Scalars['String']['input'];
  section: NavbarSection;
  waitForProjections?: Scalars['Boolean']['input'];
};


export type NavbarMutationsFavouriteArgs = {
  itemKeys: Array<Scalars['String']['input']>;
  section: NavbarSection;
  waitForProjections?: Scalars['Boolean']['input'];
};


export type NavbarMutationsMoveItemsArgs = {
  fromSection: NavbarSection;
  items: Array<ItemToMoveInput>;
  toSection: NavbarSection;
  waitForProjections?: Scalars['Boolean']['input'];
};


export type NavbarMutationsRemoveCardArgs = {
  cardId: Scalars['String']['input'];
  section: NavbarSection;
  waitForProjections?: Scalars['Boolean']['input'];
};


export type NavbarMutationsRemoveItemIconArgs = {
  itemKey: Scalars['String']['input'];
  section: NavbarSection;
  waitForProjections?: Scalars['Boolean']['input'];
};


export type NavbarMutationsRenameFolderArgs = {
  folderKey: Scalars['String']['input'];
  newName: Scalars['String']['input'];
  section: NavbarSection;
};


export type NavbarMutationsResetArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type NavbarMutationsSetItemIconArgs = {
  icon: IconInput;
  itemKey: Scalars['String']['input'];
  section: NavbarSection;
  waitForProjections?: Scalars['Boolean']['input'];
};


export type NavbarMutationsUnfavouriteArgs = {
  itemKey: Scalars['String']['input'];
  waitForProjections?: Scalars['Boolean']['input'];
};

export type NavbarQueries = {
  branch: Array<NavbarItem>;
  sections: Array<NavbarSectionRanklistBinding>;
  tree: Array<NavbarItem>;
};


export type NavbarQueriesBranchArgs = {
  order?: InputMaybe<Array<NavbarItemDocumentSortInput>>;
  parentKey?: InputMaybe<Scalars['String']['input']>;
  section: NavbarSection;
  userId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<NavbarItemDocumentFilterInput>;
};


export type NavbarQueriesTreeArgs = {
  order?: InputMaybe<Array<NavbarItemDocumentSortInput>>;
  parentKey?: InputMaybe<Scalars['String']['input']>;
  section: NavbarSection;
  userId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Inmemory_NavbarNavbarItemDocumentFilterInput>;
};

export enum NavbarSection {
  Favourites = 'FAVOURITES',
  MyWhiteboards = 'MY_WHITEBOARDS',
  SharedWithMe = 'SHARED_WITH_ME'
}

export type NavbarSectionRanklistBinding = {
  ranklistId: Scalars['String']['output'];
  section: NavbarSection;
};

export type NewRanklist = {
  id: Scalars['String']['output'];
  ranklist: RanklistState;
};

export type NewRanklistItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  iconType?: InputMaybe<Scalars['String']['input']>;
  iconValue?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  sourceRanklistId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type NewUser = {
  id: Scalars['String']['output'];
  position?: Maybe<Scalars['UnsignedLong']['output']>;
  user: UserState;
};

export type NullableOfAgreementStatusOperationFilterInput = {
  eq?: InputMaybe<AgreementStatus>;
  in?: InputMaybe<Array<InputMaybe<AgreementStatus>>>;
  neq?: InputMaybe<AgreementStatus>;
  nin?: InputMaybe<Array<InputMaybe<AgreementStatus>>>;
};

export type NullableOfCardPermissionOperationFilterInput = {
  eq?: InputMaybe<CardPermission>;
  in?: InputMaybe<Array<InputMaybe<CardPermission>>>;
  neq?: InputMaybe<CardPermission>;
  nin?: InputMaybe<Array<InputMaybe<CardPermission>>>;
};

export type NullableOfUserAppearanceOperationFilterInput = {
  eq?: InputMaybe<UserAppearance>;
  in?: InputMaybe<Array<InputMaybe<UserAppearance>>>;
  neq?: InputMaybe<UserAppearance>;
  nin?: InputMaybe<Array<InputMaybe<UserAppearance>>>;
};

export type NullableOfWhiteboardPermissionOperationFilterInput = {
  eq?: InputMaybe<WhiteboardPermission>;
  in?: InputMaybe<Array<InputMaybe<WhiteboardPermission>>>;
  neq?: InputMaybe<WhiteboardPermission>;
  nin?: InputMaybe<Array<InputMaybe<WhiteboardPermission>>>;
};

export type NullableOfWhiteboardStatusOperationFilterInput = {
  eq?: InputMaybe<WhiteboardStatus>;
  in?: InputMaybe<Array<InputMaybe<WhiteboardStatus>>>;
  neq?: InputMaybe<WhiteboardStatus>;
  nin?: InputMaybe<Array<InputMaybe<WhiteboardStatus>>>;
};

export type OEmbedBase = {
  authorName?: Maybe<Scalars['String']['output']>;
  authorUrl?: Maybe<Scalars['String']['output']>;
  cacheAge?: Maybe<Scalars['Int']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  providerUrl?: Maybe<Scalars['String']['output']>;
  thumbnailHeight?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  thumbnailWidth?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export enum OnboardingStep {
  ClickThroughDemo = 'CLICK_THROUGH_DEMO',
  FirstTimeBoardCreated = 'FIRST_TIME_BOARD_CREATED',
  FirstTimeConnectionPopup = 'FIRST_TIME_CONNECTION_POPUP',
  IntroVideos = 'INTRO_VIDEOS'
}

export type OpenGraphAudio = {
  secureUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type OpenGraphDetails = {
  articleAuthor?: Maybe<Scalars['String']['output']>;
  articleExpirationTime?: Maybe<Scalars['String']['output']>;
  articleModifiedTime?: Maybe<Scalars['String']['output']>;
  articlePublishedTime?: Maybe<Scalars['String']['output']>;
  articleSection?: Maybe<Scalars['String']['output']>;
  articleTags?: Maybe<Scalars['String']['output']>;
  audio?: Maybe<Scalars['String']['output']>;
  audios?: Maybe<Array<OpenGraphAudio>>;
  bookAuthor?: Maybe<Scalars['String']['output']>;
  bookIsbn?: Maybe<Scalars['String']['output']>;
  bookReleaseDate?: Maybe<Scalars['String']['output']>;
  bookTags?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  determiner?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<OpenGraphImage>>;
  locale?: Maybe<Scalars['String']['output']>;
  localeAlternate?: Maybe<Scalars['String']['output']>;
  siteName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  video?: Maybe<Scalars['String']['output']>;
  videos?: Maybe<Array<OpenGraphVideo>>;
};

export type OpenGraphImage = {
  alt?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  secureUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};

export type OpenGraphVideo = {
  height?: Maybe<Scalars['String']['output']>;
  secureUrl?: Maybe<Scalars['String']['output']>;
  stream?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};

export type OpenIntakeResult = {
  createdSectionId?: Maybe<Scalars['String']['output']>;
  intakeKey?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  newSectionCreated: Scalars['Boolean']['output'];
};

/** A connection to a list of items. */
export type OwnersConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<OwnersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<WhiteboardOwnersDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OwnersEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: WhiteboardOwnersDocument;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum PaymentProvider {
  Illumi = 'ILLUMI',
  LemonSqueezy = 'LEMON_SQUEEZY',
  Stripe = 'STRIPE'
}

/** A connection to a list of items. */
export type PermissionsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<PermissionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<WhiteboardPermissionsDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PermissionsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: WhiteboardPermissionsDocument;
};

export type PersonSuggestion = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  permission?: Maybe<DocumentPermission>;
};

export type PersonalAccessTokenInfo = {
  displayHint: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isExpired: Scalars['Boolean']['output'];
  issuedAt: Scalars['DateTime']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  scopes: Array<PersonalAccessTokenScope>;
  status: PersonalAccessTokenStatus;
};

export type PersonalAccessTokenInfoSortInput = {
  displayHint?: InputMaybe<SortEnumType>;
  expiresAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isExpired?: InputMaybe<SortEnumType>;
  issuedAt?: InputMaybe<SortEnumType>;
  lastUsedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  revokedAt?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

export type PersonalAccessTokenMutations = {
  issue: IssuedPersonalAccessToken;
  revoke: PersonalAccessTokenInfo;
};


export type PersonalAccessTokenMutationsIssueArgs = {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  scopes: Array<PersonalAccessTokenScope>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type PersonalAccessTokenMutationsRevokeArgs = {
  tokenId: Scalars['String']['input'];
};

export type PersonalAccessTokenQueries = {
  tokens: Array<PersonalAccessTokenInfo>;
};


export type PersonalAccessTokenQueriesTokensArgs = {
  order?: InputMaybe<Array<PersonalAccessTokenInfoSortInput>>;
  where?: InputMaybe<Inmemory_NavbarPersonalAccessTokenInfoFilterInput>;
};

export enum PersonalAccessTokenScope {
  ApiRead = 'API_READ',
  ApiWrite = 'API_WRITE'
}

export enum PersonalAccessTokenStatus {
  Active = 'ACTIVE',
  Revoked = 'REVOKED'
}

export type PlanDocument = PlanState & ProjectedDocument & {
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  balancePeriodStart?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use ClosedBalance.ExtraCreditsUsed instead. This field is kept for backwards compatibility. */
  balanceTotalUsedCredits: Scalars['UnsignedLong']['output'];
  closedBalance?: Maybe<ClosedBalance>;
  /** @deprecated Use ClosedBalance.RemainingExtraCredits instead. This field is kept for backwards compatibility. */
  confirmedBalanceDraw: Scalars['UnsignedLong']['output'];
  /** @deprecated Use ClosedBalance.TotalUsedCredits instead. This field is kept for backwards compatibility. */
  confirmedTotalUsedCredits: Scalars['UnsignedLong']['output'];
  /** @deprecated Use ClosedBalance.RemainingExtraCredits instead. This field is kept for backwards compatibility. */
  currentPeriodAvailableExtraUsageCredits: Scalars['UnsignedLong']['output'];
  establishedOpenBalance?: Maybe<EstablishedOpenBalance>;
  external?: Maybe<ExternalPlan>;
  extraUsageCredits: Scalars['UnsignedLong']['output'];
  featureUsageCounts: Array<KeyValuePairOfStringAndInt64>;
  features?: Maybe<Array<IFeatureState>>;
  firstTopUpAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  internalUserId: Scalars['String']['output'];
  nextBalanceCloseAt?: Maybe<Scalars['DateTime']['output']>;
  plan: SupportedPlan;
  planFamily: PlanFamily;
  /** @deprecated Use ClosedBalance.QuotaCreditsUsed instead. This field is kept for backwards compatibility. */
  planQuotaTotalUsedCredits: Scalars['UnsignedLong']['output'];
  position: Scalars['UnsignedLong']['output'];
  provider: PaymentProvider;
  renewsAt?: Maybe<Scalars['DateTime']['output']>;
  status: PlanStatus;
  streamPosition: Scalars['UnsignedLong']['output'];
  trialEnd?: Maybe<Scalars['DateTime']['output']>;
  trialStartedAt?: Maybe<Scalars['DateTime']['output']>;
  userEmail: Scalars['String']['output'];
};

export enum PlanFamily {
  Pro = 'PRO',
  Starter = 'STARTER',
  Team = 'TEAM'
}

export type PlanPriceIds = {
  annually?: Maybe<PriceVariant>;
  lifetime?: Maybe<PriceVariant>;
  monthly?: Maybe<PriceVariant>;
};

export type PlanQuery = {
  aiUsage: AiUsagePerPeriod;
  billing?: Maybe<BillingInfo>;
  checkout: Plans;
  /** @deprecated use checkout instead */
  checkoutUrls?: Maybe<IllumiPlansCheckOutUrls>;
  /** @deprecated use customerUrls field instead */
  customerPortalUrl?: Maybe<Scalars['String']['output']>;
  customerUrls?: Maybe<CustomerUrlsDto>;
  featureState?: Maybe<IFeatureState>;
  myPlan?: Maybe<PlanDocument>;
  /** @deprecated use myPlan instead */
  myPlans?: Maybe<PlanDocument>;
  status: CheckoutSessionStatus;
};


export type PlanQueryAiUsageArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type PlanQueryCheckoutUrlsArgs = {
  discountCode?: InputMaybe<Scalars['String']['input']>;
};


export type PlanQueryFeatureStateArgs = {
  entityId?: InputMaybe<EntityIdInput>;
  feature: SupportedFeature;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type PlanQueryMyPlanArgs = {
  shareKey?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type PlanQueryStatusArgs = {
  sessionId: Scalars['String']['input'];
};

export type PlanState = {
  external?: Maybe<ExternalPlan>;
  features?: Maybe<Array<IFeatureState>>;
  plan: SupportedPlan;
  planFamily: PlanFamily;
  status: PlanStatus;
};

export enum PlanStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  InTrial = 'IN_TRIAL',
  Paused = 'PAUSED',
  TrialEnd = 'TRIAL_END'
}

export type PlanTerms = {
  features: Array<FeatureTerms>;
  plan: SupportedPlan;
};

export type PlanVariant = {
  annually?: Maybe<VariantDetails>;
  lifetime?: Maybe<VariantDetails>;
  monthly?: Maybe<VariantDetails>;
};

export type Plans = {
  pro: ProductVariants;
  starter: ProductVariants;
};

export type PlansMutations = {
  activate: CommandResultOfUserPlanState;
  activateStarter: CommandResultOfUserPlanState;
  addCreditBalance: CommandResultOfUserPlanState;
  attachStripeSubscription: SetupStripeSubscriptionResult;
  cancel: CommandResultOfUserPlanState;
  change: CommandResultOfUserPlanState;
  checkout: CheckoutSession;
  closeBalancePeriodNow?: Maybe<CommandResultOfUserPlanState>;
  create: CommandResultOfUserPlanState;
  createBillingPortalSession: Scalars['String']['output'];
  createStripeCheckout: CheckoutSession;
  createStripeExtraCreditsCheckout: CheckoutSession;
  endTrial: CommandResultOfUserPlanState;
  establishOpeningBalance?: Maybe<CommandResultOfUserPlanState>;
  expire: CommandResultOfUserPlanState;
  pause: CommandResultOfUserPlanState;
  refundCreditBalance: CommandResultOfUserPlanState;
  resume: CommandResultOfUserPlanState;
  startTrial: CommandResultOfUserPlanState;
  synchronizeLlmQuotas: BudgetSyncResult;
  unpause: CommandResultOfUserPlanState;
};


export type PlansMutationsActivateArgs = {
  planId: Scalars['String']['input'];
};


export type PlansMutationsAddCreditBalanceArgs = {
  credits: Scalars['UnsignedLong']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['String']['input'];
};


export type PlansMutationsAttachStripeSubscriptionArgs = {
  userId: Scalars['String']['input'];
};


export type PlansMutationsCancelArgs = {
  planId: Scalars['String']['input'];
};


export type PlansMutationsChangeArgs = {
  external?: InputMaybe<ExternalPlanInput>;
  plan: SupportedPlan;
  planId: Scalars['String']['input'];
  provider: PaymentProvider;
  renewsAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: PlanStatus;
  trialEnd?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type PlansMutationsCheckoutArgs = {
  discountCode?: InputMaybe<Scalars['String']['input']>;
  priceId: Scalars['String']['input'];
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};


export type PlansMutationsCloseBalancePeriodNowArgs = {
  manualUsedCredits?: InputMaybe<Scalars['UnsignedLong']['input']>;
  planId: Scalars['String']['input'];
};


export type PlansMutationsCreateArgs = {
  external?: InputMaybe<ExternalPlanInput>;
  plan: SupportedPlan;
  provider: PaymentProvider;
  renewsAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: PlanStatus;
  trialEnd?: InputMaybe<Scalars['DateTime']['input']>;
};


export type PlansMutationsCreateBillingPortalSessionArgs = {
  previewReturnUrl?: InputMaybe<Scalars['String']['input']>;
};


export type PlansMutationsCreateStripeCheckoutArgs = {
  discountCode?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Array<KeyValuePairOfStringAndStringInput>>;
  previewReturnUrl?: InputMaybe<Scalars['String']['input']>;
  priceId: Scalars['String']['input'];
};


export type PlansMutationsCreateStripeExtraCreditsCheckoutArgs = {
  creditThousands: Scalars['Int']['input'];
  previewReturnUrl?: InputMaybe<Scalars['String']['input']>;
};


export type PlansMutationsEndTrialArgs = {
  planId: Scalars['String']['input'];
};


export type PlansMutationsEstablishOpeningBalanceArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  manualUsedCredits?: InputMaybe<Scalars['UnsignedLong']['input']>;
  planId: Scalars['String']['input'];
};


export type PlansMutationsExpireArgs = {
  planId: Scalars['String']['input'];
};


export type PlansMutationsPauseArgs = {
  planId: Scalars['String']['input'];
};


export type PlansMutationsRefundCreditBalanceArgs = {
  credits: Scalars['UnsignedLong']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['String']['input'];
};


export type PlansMutationsResumeArgs = {
  planId: Scalars['String']['input'];
};


export type PlansMutationsStartTrialArgs = {
  planId: Scalars['String']['input'];
  trialEnd?: InputMaybe<Scalars['DateTime']['input']>;
};


export type PlansMutationsSynchronizeLlmQuotasArgs = {
  ignoreClosedBalance?: InputMaybe<Scalars['Boolean']['input']>;
  resetSpend?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type PlansMutationsUnpauseArgs = {
  planId: Scalars['String']['input'];
};

export type PositionInput = {
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
};

export type PreprintIdInput = {
  generation?: InputMaybe<Scalars['Int']['input']>;
  value: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type PriceVariant = {
  priceId?: Maybe<Scalars['String']['output']>;
};

export type PricesInfo = {
  id?: Maybe<Scalars['String']['output']>;
};

export type ProductVariants = {
  annual?: Maybe<PricesInfo>;
  monthly?: Maybe<PricesInfo>;
};

/** Base interface for all projected documents with event stream position tracking */
export type ProjectedDocument = {
  /** The unique identifier for this document */
  id: Scalars['String']['output'];
  /** Global position across all event streams. Use for cross-aggregate side effects. */
  position: Scalars['UnsignedLong']['output'];
  streamPosition: Scalars['UnsignedLong']['output'];
};

export type ProjectedEventOfPlanDocument = {
  causationId?: Maybe<Scalars['String']['output']>;
  correlationId?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  number: Scalars['UnsignedLong']['output'];
  payload?: Maybe<PlanDocument>;
};

export type ProjectedEventOfString = {
  causationId?: Maybe<Scalars['String']['output']>;
  correlationId?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  number: Scalars['UnsignedLong']['output'];
  payload?: Maybe<Scalars['String']['output']>;
};

export type Publication = {
  allowClone?: Maybe<Scalars['Boolean']['output']>;
  isPublished: Scalars['Boolean']['output'];
  /** @deprecated Use ShareKeyPermission instead. */
  isReadonly?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  shareKeyPermission?: Maybe<WhiteboardPermission>;
};

export type PublicationFilterInput = {
  allowClone?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<PublicationFilterInput>>;
  isPublished?: InputMaybe<BooleanOperationFilterInput>;
  /** @deprecated Use ShareKeyPermission instead. */
  isReadonly?: InputMaybe<BooleanOperationFilterInput>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PublicationFilterInput>>;
  shareKeyPermission?: InputMaybe<NullableOfWhiteboardPermissionOperationFilterInput>;
};

export type PublicationSortInput = {
  allowClone?: InputMaybe<SortEnumType>;
  isPublished?: InputMaybe<SortEnumType>;
  /** @deprecated Use ShareKeyPermission instead. */
  isReadonly?: InputMaybe<SortEnumType>;
  key?: InputMaybe<SortEnumType>;
  shareKeyPermission?: InputMaybe<SortEnumType>;
};

export type PublishedLink = {
  allowClone?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use ShareKeyPermission instead. */
  isReadonly?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  shareKeyPermission?: Maybe<WhiteboardPermission>;
};

export type Query = {
  ai: AiQuery;
  assets: AssetQueries;
  clock: ClockQuery;
  draft: DraftQuery;
  /** @deprecated Use draft.drafts and draft.index instead */
  drafts?: Maybe<DraftsConnection>;
  files: FilesQuery;
  graphqlMutation: Scalars['String']['output'];
  graphqlQuery: Scalars['String']['output'];
  guestWebSocketToken: GuestWebSocketTokenPayload;
  history: HistoryQuery;
  ingest: IngestQueries;
  integrations: IntegrationsQuery;
  library: LibraryQueries;
  me: User;
  mentions: MentionsQuery;
  navbar: NavbarQueries;
  permissions: DocumentPermissions;
  plans: PlanQuery;
  ranklists: RanklistQuery;
  referrals: ReferralsQuery;
  /** @deprecated Use AI.Models instead */
  supportedModels: Array<SupportedModel>;
  trash: TrashBinQuery;
  users: UsersQuery;
  version: ApplicationInformation;
  whiteboards: WhiteboardQuery;
};


export type QueryDraftsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DraftDocumentSortInput>>;
  where?: InputMaybe<DraftDocumentFilterInput>;
};


export type QueryGraphqlMutationArgs = {
  mutation: Scalars['String']['input'];
  variablesJson?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGraphqlQueryArgs = {
  query: Scalars['String']['input'];
  variablesJson?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGuestWebSocketTokenArgs = {
  shareKey: Scalars['String']['input'];
  whiteboardId: Scalars['String']['input'];
};


export type QueryPermissionsArgs = {
  documents: Array<Scalars['String']['input']>;
  shareKey?: InputMaybe<Scalars['String']['input']>;
  whiteboardId?: InputMaybe<Scalars['String']['input']>;
};

export type Ranking = {
  itemDescription?: Maybe<Scalars['String']['output']>;
  itemKey: Scalars['String']['output'];
  itemRank?: Maybe<Scalars['String']['output']>;
  listId: Scalars['String']['output'];
};

export type RankingFilterInput = {
  and?: InputMaybe<Array<RankingFilterInput>>;
  itemDescription?: InputMaybe<StringOperationFilterInput>;
  itemKey?: InputMaybe<StringOperationFilterInput>;
  itemRank?: InputMaybe<StringOperationFilterInput>;
  listId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RankingFilterInput>>;
};

/** A connection to a list of items. */
export type RanklistConnectionConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<RanklistConnectionEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RanklistDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RanklistConnectionEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RanklistDocument;
};

/** Represents a document containing a ranklist and its metadata. */
export type RanklistDocument = ProjectedDocument & {
  /** The timestamp when the ranklist document was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A detailed description of the ranklist. Can be null if no description is provided. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the ranklist document. */
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  /** The list of items in the ranklist. */
  items?: Maybe<Array<Maybe<RanklistItem>>>;
  /** The name of the ranklist. */
  name: Scalars['String']['output'];
  position: Scalars['UnsignedLong']['output'];
  /** The rank of the ranklist document within a larger collection. Can be null if not ranked. */
  seedLexoRank?: Maybe<Scalars['LexoRank']['output']>;
  streamPosition: Scalars['UnsignedLong']['output'];
  /** The timestamp when the ranklist document was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type RanklistDocumentFilterInput = {
  and?: InputMaybe<Array<RanklistDocumentFilterInput>>;
  createdAt?: InputMaybe<ComparableDateTimeOffsetOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  items?: InputMaybe<ListFilterInputTypeOfRanklistItemFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RanklistDocumentFilterInput>>;
  position?: InputMaybe<ComparableUInt64OperationFilterInput>;
  seedLexoRank?: InputMaybe<StringOperationFilterInput>;
  streamPosition?: InputMaybe<ComparableUInt64OperationFilterInput>;
  updatedAt?: InputMaybe<ComparableDateTimeOffsetOperationFilterInput>;
};

export type RanklistDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  position?: InputMaybe<SortEnumType>;
  seedLexoRank?: InputMaybe<SortEnumType>;
  streamPosition?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** Represents an item in a ranklist. */
export type RanklistItem = {
  /** A detailed description of the ranklist item. Can be null if no description is provided. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the ranklist item. */
  key: Scalars['String']['output'];
  /** The parent ID of the item, representing the folder it belongs to. Null means the item is at root level. */
  parentKey?: Maybe<Scalars['String']['output']>;
  /** The rank of the item within the ranklist. Can be null if the item is not yet ranked. */
  rank?: Maybe<Scalars['LexoRank']['output']>;
  /** The type of the ranklist item. Can be null if no type is specified. */
  type?: Maybe<Scalars['String']['output']>;
};

export type RanklistItemFilterInput = {
  and?: InputMaybe<Array<RanklistItemFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RanklistItemFilterInput>>;
  parentKey?: InputMaybe<StringOperationFilterInput>;
  rank?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type RanklistMutations = {
  addItems?: Maybe<RanklistState>;
  changeDescription?: Maybe<RanklistState>;
  changeName?: Maybe<RanklistState>;
  compact?: Maybe<RanklistState>;
  create?: Maybe<NewRanklist>;
  moveItem?: Maybe<RanklistState>;
  normalizeItemIds?: Maybe<RanklistState>;
  /** @deprecated use move Item for hierarchy support */
  rankItem?: Maybe<RanklistState>;
  removeItems?: Maybe<RanklistState>;
  syncItems?: Maybe<RanklistState>;
};


export type RanklistMutationsAddItemsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  items: Array<NewRanklistItemInput>;
  parentKey?: InputMaybe<Scalars['String']['input']>;
};


export type RanklistMutationsChangeDescriptionArgs = {
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type RanklistMutationsChangeNameArgs = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type RanklistMutationsCompactArgs = {
  id: Scalars['String']['input'];
};


export type RanklistMutationsCreateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  seedLexoRank?: InputMaybe<Scalars['String']['input']>;
};


export type RanklistMutationsMoveItemArgs = {
  afterKey?: InputMaybe<Scalars['String']['input']>;
  beforeKey?: InputMaybe<Scalars['String']['input']>;
  itemKey: Scalars['String']['input'];
  knownList?: InputMaybe<KnownUserRanklists>;
  parentKey?: InputMaybe<Scalars['String']['input']>;
  ranklistId?: InputMaybe<Scalars['String']['input']>;
};


export type RanklistMutationsNormalizeItemIdsArgs = {
  id: Scalars['String']['input'];
};


export type RanklistMutationsRankItemArgs = {
  afterKey?: InputMaybe<Scalars['String']['input']>;
  beforeKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  knownList?: InputMaybe<KnownUserRanklists>;
};


export type RanklistMutationsRemoveItemsArgs = {
  id: Scalars['String']['input'];
  keys: Array<Scalars['String']['input']>;
};


export type RanklistMutationsSyncItemsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  items: Array<ListItemInput>;
  knownList?: InputMaybe<KnownUserRanklists>;
};

export type RanklistQuery = {
  all?: Maybe<RanklistConnectionConnection>;
  knownRanklist?: Maybe<RanklistDocument>;
  myRanklists?: Maybe<Array<RanklistDocument>>;
};


export type RanklistQueryAllArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RanklistDocumentSortInput>>;
  where?: InputMaybe<RanklistDocumentFilterInput>;
};


export type RanklistQueryKnownRanklistArgs = {
  list: KnownUserRanklists;
};

/** Represents the state of a ranklist after command execution */
export type RanklistState = {
  /** A detailed description of the ranklist. */
  description?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  /** Items in the ranklist. */
  items: Array<KeyValuePairOfStringAndRanklistItem>;
  /** Max lexorank value across ranklist items, used to generate lexorank order. */
  maxRank?: Maybe<Scalars['LexoRank']['output']>;
  /** Min lexorank value across ranklist items, used to generate lexorank order. */
  minRank?: Maybe<Scalars['LexoRank']['output']>;
  /** The name of the ranklist. */
  name: Scalars['String']['output'];
  /** lexorank value of the ranklist, used to generate lexorank order. */
  rank?: Maybe<Scalars['LexoRank']['output']>;
};

export type RefereeInfo = {
  referredBy?: Maybe<Scalars['String']['output']>;
  status: ReferralStatus;
  wasReferred: Scalars['Boolean']['output'];
};

export type ReferralCodeInfo = {
  token?: Maybe<Scalars['String']['output']>;
};

export type ReferralInfo = {
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  refereeEmail: Scalars['String']['output'];
  refereeId: Scalars['String']['output'];
  registeredAt?: Maybe<Scalars['DateTime']['output']>;
  status: ReferralStatus;
};

export type ReferralProfileState = {
  referee: RefereeInfo;
  referralCode: ReferralCodeInfo;
  referrer: ReferrerInfo;
  rewards: RewardsInfo;
};

export type ReferralRewardResult = {
  needPaymentMethod: Scalars['Boolean']['output'];
  renewsAt?: Maybe<Scalars['DateTime']['output']>;
  scheduleId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
};

export enum ReferralStatus {
  Activated = 'ACTIVATED',
  Registered = 'REGISTERED'
}

export type ReferralsMutations = {
  createReferralProfile: Scalars['String']['output'];
  markAsReferred: Scalars['Boolean']['output'];
  redeemReward: RewardRedeemResult;
};


export type ReferralsMutationsCreateReferralProfileArgs = {
  campaignCode?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type ReferralsMutationsMarkAsReferredArgs = {
  referralCode: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type ReferralsMutationsRedeemRewardArgs = {
  rewardCode: Scalars['String']['input'];
};

export type ReferralsQuery = {
  profile: MyReferralsInfo;
};


export type ReferralsQueryProfileArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ReferrerInfo = {
  qualifiedReferees: Array<Scalars['String']['output']>;
  qualifiedReferralCount: Scalars['Int']['output'];
};

export type RemarkContentPart = ContentPart & {
  text?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type RestoreVersionResult = {
  newDocumentName?: Maybe<Scalars['String']['output']>;
  newVersion: Scalars['Int']['output'];
  restoredFromVersion: Scalars['Int']['output'];
};

export enum RetentionClass {
  Auto = 'AUTO',
  Important = 'IMPORTANT',
  Manual = 'MANUAL'
}

export type RewardRecord = {
  campaignCode: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  isRedeemed: Scalars['Boolean']['output'];
  refereeId: Scalars['String']['output'];
  rewardCode: Scalars['RewardCodeScalar']['output'];
  rewardType?: Maybe<Scalars['String']['output']>;
};

export type RewardRedeemResult = CommandResult & {
  globalPosition?: Maybe<Scalars['UnsignedLong']['output']>;
  needPaymentMethod: Scalars['Boolean']['output'];
  /** Global position in the event store after command execution. Use this to wait for read model projections to catch up. */
  position: Scalars['UnsignedLong']['output'];
  profile?: Maybe<ReferralProfileState>;
  stripe?: Maybe<ReferralRewardResult>;
};

export type RewardSummary = {
  expiresAt: Scalars['DateTime']['output'];
  grantedAt: Scalars['DateTime']['output'];
  isRedeemed: Scalars['Boolean']['output'];
  refereeId: Scalars['String']['output'];
  rewardCode: Scalars['String']['output'];
  rewardType?: Maybe<Scalars['String']['output']>;
};

export type RewardsInfo = {
  grantedRewards: Array<RewardRecord>;
  reservedRedemptions: Array<KeyValuePairOfStringAndRewardCode>;
};

export type SaveVersionResult = {
  createdAt: Scalars['DateTime']['output'];
  documentName: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  versionName?: Maybe<Scalars['String']['output']>;
};

export type Section = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  templateContent?: Maybe<Array<ContentPart>>;
};

export type SetupStripeSubscriptionResult = {
  customerId: Scalars['String']['output'];
  priceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptionId: Scalars['String']['output'];
  trialEnd?: Maybe<Scalars['DateTime']['output']>;
};

export type SharingLink = {
  allowClone: Scalars['Boolean']['output'];
  /** @deprecated Use ShareKeyPermission instead. */
  isReadonly: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  shareKeyPermission: WhiteboardPermission;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SpecialBlocks = {
  audios?: Maybe<Array<AudioBlock>>;
  files?: Maybe<Array<FileBlock>>;
  images?: Maybe<Array<ImageBlock>>;
  tasks?: Maybe<Array<TaskBlock>>;
  videos?: Maybe<Array<VideoBlock>>;
  whatsappMessages?: Maybe<Array<WhatsappMessageBlock>>;
};

export type StepStatus = {
  isCompleted: Scalars['Boolean']['output'];
  step: OnboardingStep;
};

export type StepStatusDocument = {
  isCompleted: Scalars['Boolean']['output'];
  step: OnboardingStep;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum StepsFilter {
  All = 'ALL',
  Completed = 'COMPLETED',
  Uncompleted = 'UNCOMPLETED'
}

export type StreamingAnswerPart = {
  errorMessage?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type StreamingPreprint = {
  id: Scalars['String']['output'];
  model: SupportedModel;
  subscriptionTopic: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  assetStatus: AssetStatusDto;
  assistantAnsweredPart: StreamingAnswerPart;
  initialWhiteboardsReady: InitialWhiteboardReadyNotification;
  myWhiteboardsProjected: EventProjectedOfString;
  onMentionInboxUpdated: MentionInboxUpdatePayload;
  planStatus: EventProjectedOfPlanDocument;
};


export type SubscriptionAssetStatusArgs = {
  assetId: Scalars['String']['input'];
  shareKey?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionAssistantAnsweredPartArgs = {
  cardId: Scalars['String']['input'];
};


export type SubscriptionInitialWhiteboardsReadyArgs = {
  correlationId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionMyWhiteboardsProjectedArgs = {
  correlationId?: InputMaybe<Scalars['String']['input']>;
  shareKey?: InputMaybe<Scalars['String']['input']>;
  whiteboardId?: InputMaybe<Scalars['String']['input']>;
};

export type Summary = {
  description?: Maybe<Scalars['String']['output']>;
  favicon?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  src: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export enum SupportedAgent {
  AiAssistant = 'AI_ASSISTANT',
  ImageMaker = 'IMAGE_MAKER',
  ThinkingPartner = 'THINKING_PARTNER'
}

export type SupportedAgentDescription = {
  agent: SupportedAgent;
  models: Array<SupportedModelAvailability>;
};

export enum SupportedFeature {
  AddBoardEditors = 'ADD_BOARD_EDITORS',
  AiCreditsBudget = 'AI_CREDITS_BUDGET',
  /** @deprecated Use CreditsBudget instead */
  AiPromptClicks = 'AI_PROMPT_CLICKS',
  /** @deprecated Use CreditsBudget instead */
  AiPromptClicksBasic = 'AI_PROMPT_CLICKS_BASIC',
  /** @deprecated Use CreditsBudget instead */
  AiPromptClicksPremium = 'AI_PROMPT_CLICKS_PREMIUM',
  /** @deprecated Use CreditsBudget instead */
  AiPromptClicksStandard = 'AI_PROMPT_CLICKS_STANDARD',
  ConvertToNote = 'CONVERT_TO_NOTE',
  CreateBoards = 'CREATE_BOARDS',
  CreateCardOnWhiteboards = 'CREATE_CARD_ON_WHITEBOARDS',
  CreditsBudget = 'CREDITS_BUDGET',
  DailyAssistant = 'DAILY_ASSISTANT',
  DownloadAsDocx = 'DOWNLOAD_AS_DOCX',
  DownloadAsMd = 'DOWNLOAD_AS_MD',
  DownloadAsPdf = 'DOWNLOAD_AS_PDF',
  HistoryRetention = 'HISTORY_RETENTION',
  ImageMaker = 'IMAGE_MAKER',
  ModelTierBasic = 'MODEL_TIER_BASIC',
  ModelTierPremium = 'MODEL_TIER_PREMIUM',
  ModelTierStandard = 'MODEL_TIER_STANDARD',
  PublishBoardForEdit = 'PUBLISH_BOARD_FOR_EDIT',
  SendAsEmail = 'SEND_AS_EMAIL',
  ThinkingPartner = 'THINKING_PARTNER'
}

export enum SupportedModel {
  AmazonNova2Lite = 'AMAZON_NOVA2_LITE',
  /** @deprecated Use StableImageCore instead */
  AmazonNovaCanvas = 'AMAZON_NOVA_CANVAS',
  AmazonNovaLite = 'AMAZON_NOVA_LITE',
  AmazonNovaMicro = 'AMAZON_NOVA_MICRO',
  AmazonNovaPro = 'AMAZON_NOVA_PRO',
  /** @deprecated Use StableImageCore instead */
  AmazonTitanImageGeneratorV2 = 'AMAZON_TITAN_IMAGE_GENERATOR_V2',
  /** @deprecated Use Claude45Sonnet instead */
  Claude4Sonnet = 'CLAUDE4_SONNET',
  /** @deprecated Use Claude45SonnetNative instead */
  Claude4SonnetNative = 'CLAUDE4_SONNET_NATIVE',
  Claude5Fable = 'CLAUDE5_FABLE',
  Claude5FableNative = 'CLAUDE5_FABLE_NATIVE',
  Claude5Opus = 'CLAUDE5_OPUS',
  Claude5OpusNative = 'CLAUDE5_OPUS_NATIVE',
  Claude5Sonnet = 'CLAUDE5_SONNET',
  Claude5SonnetNative = 'CLAUDE5_SONNET_NATIVE',
  /** @deprecated Use Claude45Sonnet instead */
  Claude37Sonnet = 'CLAUDE37_SONNET',
  /** @deprecated Use Claude45SonnetNative instead */
  Claude37SonnetNative = 'CLAUDE37_SONNET_NATIVE',
  Claude45Haiku = 'CLAUDE45_HAIKU',
  Claude45HaikuNative = 'CLAUDE45_HAIKU_NATIVE',
  Claude45Opus = 'CLAUDE45_OPUS',
  Claude45OpusNative = 'CLAUDE45_OPUS_NATIVE',
  Claude45Sonnet = 'CLAUDE45_SONNET',
  Claude45SonnetNative = 'CLAUDE45_SONNET_NATIVE',
  Claude46Opus = 'CLAUDE46_OPUS',
  Claude46OpusNative = 'CLAUDE46_OPUS_NATIVE',
  Claude46Sonnet = 'CLAUDE46_SONNET',
  Claude46SonnetNative = 'CLAUDE46_SONNET_NATIVE',
  Claude47Opus = 'CLAUDE47_OPUS',
  DallE3Native = 'DALL_E3_NATIVE',
  /** @deprecated Use DeepSeekV4Pro instead */
  DeepSeekR1 = 'DEEP_SEEK_R1',
  /** @deprecated Use DeepSeekV4Pro instead */
  DeepSeekR10528 = 'DEEP_SEEK_R10528',
  /** @deprecated Use DeepSeekV4Flash instead */
  DeepSeekV3 = 'DEEP_SEEK_V3',
  DeepSeekV4Flash = 'DEEP_SEEK_V4_FLASH',
  DeepSeekV4Pro = 'DEEP_SEEK_V4_PRO',
  /** @deprecated Use DeepSeekV4Pro instead */
  DeepSeekV32 = 'DEEP_SEEK_V32',
  /** @deprecated Use DeepSeekV4Flash instead */
  DeepSeekV30324 = 'DEEP_SEEK_V30324',
  /** @deprecated Use Gemini35Flash instead */
  Gemini3 = 'GEMINI3',
  Gemini3ProImage = 'GEMINI3_PRO_IMAGE',
  Gemini25FlashImage = 'GEMINI25_FLASH_IMAGE',
  Gemini31FlashImage = 'GEMINI31_FLASH_IMAGE',
  Gemini31FlashLight = 'GEMINI31_FLASH_LIGHT',
  /** @deprecated Use Gemini31FlashLight instead */
  Gemini31FlashLightPreview = 'GEMINI31_FLASH_LIGHT_PREVIEW',
  Gemini31FlashLiteImage = 'GEMINI31_FLASH_LITE_IMAGE',
  /** @deprecated Use Gemini35Flash instead */
  Gemini31ProPreview = 'GEMINI31_PRO_PREVIEW',
  Gemini35Flash = 'GEMINI35_FLASH',
  Gemini36Flash = 'GEMINI36_FLASH',
  Gemini37Flash = 'GEMINI37_FLASH',
  /** @deprecated Use Gemini37Flash instead */
  Gemini37Pro = 'GEMINI37_PRO',
  Gemma426BA4BItMaas = 'GEMMA426B_A4B_IT_MAAS',
  Glm4Plus = 'GLM4_PLUS',
  Glm5Maas = 'GLM5_MAAS',
  Glm5Turbo = 'GLM5_TURBO',
  Glm5VTurbo = 'GLM5_V_TURBO',
  Glm51 = 'GLM51',
  Glm52 = 'GLM52',
  /** @deprecated Use Gpt52 instead */
  Gpt5 = 'GPT5',
  Gpt5Native = 'GPT5_NATIVE',
  Gpt41 = 'GPT41',
  Gpt41Native = 'GPT41_NATIVE',
  Gpt52 = 'GPT52',
  Gpt52Native = 'GPT52_NATIVE',
  Gpt54 = 'GPT54',
  Gpt54Native = 'GPT54_NATIVE',
  Gpt55 = 'GPT55',
  Gpt55Native = 'GPT55_NATIVE',
  Gpt56 = 'GPT56',
  Gpt56Luna = 'GPT56_LUNA',
  Gpt56Native = 'GPT56_NATIVE',
  Gpt56Sol = 'GPT56_SOL',
  Gpt56Terra = 'GPT56_TERRA',
  GptImage15 = 'GPT_IMAGE15',
  GptImage15Native = 'GPT_IMAGE15_NATIVE',
  /** @deprecated Use Gpt41 instead */
  GptO1Mini = 'GPT_O1_MINI',
  /** @deprecated Use Gpt41 instead */
  GptO3Pro = 'GPT_O3_PRO',
  /** @deprecated Use Gpt41 instead */
  GptO3ProNative = 'GPT_O3_PRO_NATIVE',
  /** @deprecated Use Grok43 instead */
  Grok3 = 'GROK3',
  /** @deprecated Use Grok420NonReasoning instead */
  Grok4FastNonReasoning = 'GROK4_FAST_NON_REASONING',
  Grok41FastReasoning = 'GROK41_FAST_REASONING',
  /** @deprecated Use Grok41FastReasoning instead */
  Grok41FastReasoningNative = 'GROK41_FAST_REASONING_NATIVE',
  Grok43 = 'GROK43',
  /** @deprecated Use Grok43 instead */
  Grok43Native = 'GROK43_NATIVE',
  Grok45Native = 'GROK45_NATIVE',
  Grok46Native = 'GROK46_NATIVE',
  Grok420NonReasoning = 'GROK420_NON_REASONING',
  /** @deprecated Use Grok420NonReasoning instead */
  Grok420NonReasoningNative = 'GROK420_NON_REASONING_NATIVE',
  Grok420Reasoning = 'GROK420_REASONING',
  /** @deprecated Use Grok420Reasoning instead */
  Grok420ReasoningNative = 'GROK420_REASONING_NATIVE',
  /** @deprecated Use Gemini3ProImage instead */
  Imagen4 = 'IMAGEN4',
  /** @deprecated Use Gemini31FlashLiteImage instead */
  Imagen4Fast = 'IMAGEN4_FAST',
  /** @deprecated Use Gemini3ProImage instead */
  Imagen4UltraGenerate = 'IMAGEN4_ULTRA_GENERATE',
  /** @deprecated Use Gemini25FlashImage instead */
  Imagen30 = 'IMAGEN30',
  /** @deprecated Use Gemini25FlashImage instead */
  Imagen30Fast = 'IMAGEN30_FAST',
  /** @deprecated Use KimiK3 instead */
  Kimi27 = 'KIMI27',
  /** @deprecated Use KimiK3 instead */
  Kimi27Highspeed = 'KIMI27_HIGHSPEED',
  /** @deprecated Use KimiK3 instead */
  KimiK2Thinking = 'KIMI_K2_THINKING',
  KimiK3 = 'KIMI_K3',
  /** @deprecated Use KimiK3 instead */
  KimiK25 = 'KIMI_K25',
  /** @deprecated Use KimiK3 instead */
  KimiK25Native = 'KIMI_K25_NATIVE',
  /** @deprecated Use KimiK3 instead */
  KimiK26 = 'KIMI_K26',
  /** @deprecated Use KimiK3 instead */
  MoonshotV18K = 'MOONSHOT_V18K',
  /** @deprecated Use KimiK3 instead */
  MoonshotV132K = 'MOONSHOT_V132K',
  /** @deprecated Use KimiK3 instead */
  MoonshotV1128K = 'MOONSHOT_V1128K',
  NanoBanana = 'NANO_BANANA',
  StableDiffusion35Large = 'STABLE_DIFFUSION35_LARGE',
  StableImageCore = 'STABLE_IMAGE_CORE',
  StableImageUltra = 'STABLE_IMAGE_ULTRA'
}

export type SupportedModelAvailability = {
  capabilities: Array<SupportedModelCapability>;
  compatibleAgents: Array<SupportedAgent>;
  inputModalities?: Maybe<Array<Modality>>;
  /** @deprecated Use isRegionRestricted instead. */
  isAvailable: Scalars['Boolean']['output'];
  isRegionRestricted: Scalars['Boolean']['output'];
  isTierAvailable: Scalars['Boolean']['output'];
  maxImages?: Maybe<Scalars['Int']['output']>;
  maxInputTokens: Scalars['Int']['output'];
  model: SupportedModel;
  modelId: Scalars['String']['output'];
  outputModalities?: Maybe<Array<Modality>>;
  /** @deprecated use Capabilities instead */
  supportWebSearch: Scalars['Boolean']['output'];
  tier: SupportedFeature;
};

export enum SupportedModelCapability {
  Tools = 'TOOLS',
  WebSearch = 'WEB_SEARCH'
}

export enum SupportedPlan {
  Believer = 'BELIEVER',
  Pro = 'PRO',
  ProV2 = 'PRO_V2',
  ProV2Test = 'PRO_V2_TEST',
  Starter = 'STARTER',
  StarterV2 = 'STARTER_V2',
  Team = 'TEAM',
  WhiteboardAi = 'WHITEBOARD_AI'
}

export type TableContentPart = ContentPart & {
  text?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type TaskBlock = {
  checked?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Template = {
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  language?: Maybe<Scalars['String']['output']>;
  rank: Scalars['String']['output'];
  shareKey?: Maybe<Scalars['String']['output']>;
  whiteboardName: Scalars['String']['output'];
};

export type TestUserResult = {
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type TextContentPart = ContentPart & {
  text?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type TrashBinMutations = {
  empty: Scalars['Int']['output'];
  permanentlyDelete: Scalars['Boolean']['output'];
  restore: Scalars['Boolean']['output'];
  restoreAll: Scalars['Int']['output'];
};


export type TrashBinMutationsPermanentlyDeleteArgs = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  trashId?: InputMaybe<Scalars['String']['input']>;
};


export type TrashBinMutationsRestoreArgs = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  trashId?: InputMaybe<Scalars['String']['input']>;
};

export type TrashBinQuery = {
  items?: Maybe<TrashItemsConnection>;
};


export type TrashBinQueryItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TrashItemDocumentSortInput>>;
  where?: InputMaybe<TrashItemDocumentFilterInput>;
};

export type TrashItemDocument = ProjectedDocument & {
  deletedAt: Scalars['DateTime']['output'];
  deletedBy: Scalars['String']['output'];
  entityId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  location: TrashItemLocation;
  name: Scalars['String']['output'];
  ownerEmail: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  position: Scalars['UnsignedLong']['output'];
  streamPosition: Scalars['UnsignedLong']['output'];
};

export type TrashItemDocumentFilterInput = {
  and?: InputMaybe<Array<TrashItemDocumentFilterInput>>;
  deletedAt?: InputMaybe<ComparableDateTimeOffsetOperationFilterInput>;
  deletedBy?: InputMaybe<StringOperationFilterInput>;
  entityId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  location?: InputMaybe<TrashItemLocationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TrashItemDocumentFilterInput>>;
  ownerEmail?: InputMaybe<StringOperationFilterInput>;
  ownerId?: InputMaybe<StringOperationFilterInput>;
  position?: InputMaybe<ComparableUInt64OperationFilterInput>;
  streamPosition?: InputMaybe<ComparableUInt64OperationFilterInput>;
};

export type TrashItemDocumentSortInput = {
  deletedAt?: InputMaybe<SortEnumType>;
  deletedBy?: InputMaybe<SortEnumType>;
  entityId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  location?: InputMaybe<TrashItemLocationSortInput>;
  name?: InputMaybe<SortEnumType>;
  ownerEmail?: InputMaybe<SortEnumType>;
  ownerId?: InputMaybe<SortEnumType>;
  position?: InputMaybe<SortEnumType>;
  streamPosition?: InputMaybe<SortEnumType>;
};

export type TrashItemLocation = {
  containerId?: Maybe<Scalars['String']['output']>;
  containerName?: Maybe<Scalars['String']['output']>;
  locationType: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
};

export type TrashItemLocationFilterInput = {
  and?: InputMaybe<Array<TrashItemLocationFilterInput>>;
  containerId?: InputMaybe<StringOperationFilterInput>;
  containerName?: InputMaybe<StringOperationFilterInput>;
  locationType?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TrashItemLocationFilterInput>>;
  path?: InputMaybe<StringOperationFilterInput>;
};

export type TrashItemLocationSortInput = {
  containerId?: InputMaybe<SortEnumType>;
  containerName?: InputMaybe<SortEnumType>;
  locationType?: InputMaybe<SortEnumType>;
  path?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type TrashItemsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<TrashItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TrashItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TrashItemsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TrashItemDocument;
};

export type TreeItem = {
  hasChildren: Scalars['Boolean']['output'];
  icon?: Maybe<IconInfo>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentKey?: Maybe<Scalars['String']['output']>;
  rank: Scalars['String']['output'];
  status?: Maybe<WhiteboardStatus>;
  type: NavBarItemType;
};

export type UnfurlResult = {
  appleTouchIcon?: Maybe<Scalars['String']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  encoding?: Maybe<Scalars['String']['output']>;
  favIcon?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  license?: Maybe<Scalars['String']['output']>;
  oEmbed?: Maybe<OEmbedBase>;
  oEmbedLink?: Maybe<Scalars['String']['output']>;
  openGraph?: Maybe<OpenGraphDetails>;
  themeColor?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  xTwitter?: Maybe<XTwitterDetails>;
};

export type UnsupportedBlockStats = {
  blockId?: Maybe<Scalars['String']['output']>;
  index: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type UnsupportedCardStats = {
  blocks: Array<UnsupportedBlockStats>;
  cardId: Scalars['String']['output'];
};

export type UploadInfo = {
  assetId: Scalars['String']['output'];
  downloadUrl: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type UrlAuthInput = {
  headerName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<UrlAuthType>;
};

export enum UrlAuthType {
  Bearer = 'BEARER',
  None = 'NONE'
}

export type UrlMeta = {
  metaData: Array<KeyValuePairOfStringAndString>;
};

export type UrlPreviewInfo = {
  details: UnfurlResult;
  summary: Summary;
};

export type User = {
  claims: Array<UserClaim>;
  identity?: Maybe<UserIdentity>;
};

export type UserAccess = {
  details?: Maybe<UsersDocument>;
  permission: WhiteboardPermission;
  userId: Scalars['String']['output'];
};

export type UserAccessFilterInput = {
  and?: InputMaybe<Array<UserAccessFilterInput>>;
  or?: InputMaybe<Array<UserAccessFilterInput>>;
  permission?: InputMaybe<WhiteboardPermissionOperationFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
};

export enum UserActivationStatus {
  Deactivated = 'DEACTIVATED',
  Invited = 'INVITED',
  Registered = 'REGISTERED',
  Unknown = 'UNKNOWN'
}

export type UserActivationStatusOperationFilterInput = {
  eq?: InputMaybe<UserActivationStatus>;
  in?: InputMaybe<Array<UserActivationStatus>>;
  neq?: InputMaybe<UserActivationStatus>;
  nin?: InputMaybe<Array<UserActivationStatus>>;
};

export enum UserAgreement {
  BetaUserAgreement = 'BETA_USER_AGREEMENT'
}

export enum UserAppearance {
  Auto = 'AUTO',
  Dark = 'DARK',
  Light = 'LIGHT'
}

export type UserClaim = {
  issuer: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type UserDetails = {
  activationStatus: UserActivationStatus;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  language?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type UserIdInput = {
  value: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type UserIdentity = {
  authenticationType?: Maybe<Scalars['String']['output']>;
  isAuthenticated?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UserInvitesDocument = ProjectedDocument & {
  id: Scalars['String']['output'];
  invitationReferralCode?: Maybe<Scalars['String']['output']>;
  invitedAt: Scalars['DateTime']['output'];
  position: Scalars['UnsignedLong']['output'];
  recipientEmail: Scalars['String']['output'];
  recipientUserId: Scalars['String']['output'];
  registeredAt?: Maybe<Scalars['DateTime']['output']>;
  registrationReferralCode?: Maybe<Scalars['String']['output']>;
  senderEmail?: Maybe<Scalars['String']['output']>;
  senderReferralCode?: Maybe<Scalars['String']['output']>;
  senderUserId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status: InviteStatus;
  statusUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  streamPosition: Scalars['UnsignedLong']['output'];
};

export type UserInvitesDocumentFilterInput = {
  and?: InputMaybe<Array<UserInvitesDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  invitationReferralCode?: InputMaybe<StringOperationFilterInput>;
  invitedAt?: InputMaybe<ComparableDateTimeOffsetOperationFilterInput>;
  or?: InputMaybe<Array<UserInvitesDocumentFilterInput>>;
  position?: InputMaybe<ComparableUInt64OperationFilterInput>;
  recipientEmail?: InputMaybe<StringOperationFilterInput>;
  recipientUserId?: InputMaybe<StringOperationFilterInput>;
  registeredAt?: InputMaybe<ComparableNullableOfDateTimeOffsetOperationFilterInput>;
  registrationReferralCode?: InputMaybe<StringOperationFilterInput>;
  senderEmail?: InputMaybe<StringOperationFilterInput>;
  senderReferralCode?: InputMaybe<StringOperationFilterInput>;
  senderUserId?: InputMaybe<StringOperationFilterInput>;
  source?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<InviteStatusOperationFilterInput>;
  statusUpdatedAt?: InputMaybe<ComparableNullableOfDateTimeOffsetOperationFilterInput>;
  streamPosition?: InputMaybe<ComparableUInt64OperationFilterInput>;
};

export type UserInvitesDocumentSortInput = {
  id?: InputMaybe<SortEnumType>;
  invitationReferralCode?: InputMaybe<SortEnumType>;
  invitedAt?: InputMaybe<SortEnumType>;
  position?: InputMaybe<SortEnumType>;
  recipientEmail?: InputMaybe<SortEnumType>;
  recipientUserId?: InputMaybe<SortEnumType>;
  registeredAt?: InputMaybe<SortEnumType>;
  registrationReferralCode?: InputMaybe<SortEnumType>;
  senderEmail?: InputMaybe<SortEnumType>;
  senderReferralCode?: InputMaybe<SortEnumType>;
  senderUserId?: InputMaybe<SortEnumType>;
  source?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  statusUpdatedAt?: InputMaybe<SortEnumType>;
  streamPosition?: InputMaybe<SortEnumType>;
};

export type UserMutations = {
  acceptAgreement?: Maybe<UserState>;
  activatePhoneNumber?: Maybe<UserState>;
  changeAppearance?: Maybe<UserState>;
  changePresenceColor?: Maybe<UserState>;
  changeZoomSpeed?: Maybe<UserState>;
  declineAgreement?: Maybe<UserState>;
  developer: DeveloperMutations;
  generatePhoneActivationCode?: Maybe<UserState>;
  /** @deprecated Use auto-created referral profiles instead */
  generateReferralCode: UserState;
  graduateFromBeta: GraduateFromBetaResult;
  invite?: Maybe<NewUser>;
  onboarding: UserOnboardingMutation;
  register?: Maybe<NewUser>;
  resendVerificationEmail: Scalars['Boolean']['output'];
  updateProfile?: Maybe<UserState>;
};


export type UserMutationsAcceptAgreementArgs = {
  agreement: UserAgreement;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type UserMutationsActivatePhoneNumberArgs = {
  activationCode: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type UserMutationsChangeAppearanceArgs = {
  appearance: UserAppearance;
};


export type UserMutationsChangePresenceColorArgs = {
  presenceColor: Scalars['String']['input'];
};


export type UserMutationsChangeZoomSpeedArgs = {
  zoomSpeed: Scalars['Decimal']['input'];
};


export type UserMutationsDeclineAgreementArgs = {
  agreement: UserAgreement;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type UserMutationsGeneratePhoneActivationCodeArgs = {
  allowReuse?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type UserMutationsGenerateReferralCodeArgs = {
  campaignCode?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type UserMutationsGraduateFromBetaArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type UserMutationsInviteArgs = {
  email: Scalars['String']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
};


export type UserMutationsRegisterArgs = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  demoSessionId?: InputMaybe<Scalars['String']['input']>;
  demoWhiteboardId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  idProvider?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
};


export type UserMutationsResendVerificationEmailArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type UserMutationsUpdateProfileArgs = {
  appearance?: InputMaybe<UserAppearance>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  languageName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  presenceColor?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  zoomSpeed?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UserOnboardingMutation = {
  completeStep?: Maybe<CompletedOnboardingStep>;
  resetStep?: Maybe<UserOnboardingState>;
  start?: Maybe<UserOnboardingState>;
};


export type UserOnboardingMutationCompleteStepArgs = {
  step: OnboardingStep;
};


export type UserOnboardingMutationResetStepArgs = {
  step: OnboardingStep;
};

export type UserOnboardingQuery = {
  overview?: Maybe<UserOnboardingsDocument>;
};


export type UserOnboardingQueryOverviewArgs = {
  steps?: InputMaybe<StepsFilter>;
};

export type UserOnboardingState = {
  steps: Array<KeyValuePairOfOnboardingStepAndStepStatus>;
};

export type UserOnboardingsDocument = ProjectedDocument & {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  position: Scalars['UnsignedLong']['output'];
  steps: Array<StepStatusDocument>;
  streamPosition: Scalars['UnsignedLong']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UserPlanState = {
  creditBalance: CreditBalanceData;
  externalPlan?: Maybe<ExternalPlan>;
  graduatedFromBeta: Scalars['Boolean']['output'];
  internalUserId?: Maybe<Scalars['String']['output']>;
  provider: PaymentProvider;
  renewsAt?: Maybe<Scalars['DateTime']['output']>;
  status: PlanStatus;
  terms: PlanTerms;
  trialEndsAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UserReferral = {
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  registered?: Maybe<Scalars['DateTime']['output']>;
  status: UserActivationStatus;
};

export type UserState = {
  activationStatus: UserActivationStatus;
  agreements: Array<KeyValuePairOfUserAgreementAndAgreementStatus>;
  /** User's appearance setting */
  appearance?: Maybe<UserAppearance>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** User's display name */
  displayName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailActivationCode?: Maybe<Scalars['String']['output']>;
  emailToActivate?: Maybe<Scalars['String']['output']>;
  externalIdentities: Array<ExternalIdentity>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** ISO 639-1 two-letter language code */
  languageCode?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneActivationCode?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberToActivate?: Maybe<Scalars['String']['output']>;
  /** User's presence color */
  presenceColor?: Maybe<Scalars['String']['output']>;
  /** IANA time zone id: https://en.wikipedia.org/wiki/List_of_tz_database_time_zones */
  timeZoneId?: Maybe<Scalars['String']['output']>;
  /** User's zoom speed setting */
  zoomSpeed?: Maybe<Scalars['Decimal']['output']>;
};

/** A connection to a list of items. */
export type UsersConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<UsersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UsersDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type UsersDocument = ProjectedDocument & {
  activationStatus: UserActivationStatus;
  /** User's appearance setting */
  appearance?: Maybe<UserAppearance>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  betaAgreementAccepted?: Maybe<AgreementStatus>;
  created?: Maybe<Scalars['DateTime']['output']>;
  /** User's display name */
  displayName?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailConfirmationCode?: Maybe<Scalars['String']['output']>;
  externalIdentities?: Maybe<Array<ExternalIdentity>>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invited?: Maybe<Scalars['DateTime']['output']>;
  /** ISO 639-1 two-letter language code */
  language?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  newEmailToConfirm?: Maybe<Scalars['String']['output']>;
  phoneActivationCode?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  position: Scalars['UnsignedLong']['output'];
  presenceColor?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use referrals.profile query instead for better performance and more referral information */
  referralCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use referrals.profile query instead for better performance and more referral information */
  referredByCode?: Maybe<Scalars['String']['output']>;
  streamPosition: Scalars['UnsignedLong']['output'];
  team?: Maybe<Scalars['String']['output']>;
  /** IANA time zone id: https://en.wikipedia.org/wiki/List_of_tz_database_time_zones */
  timezone?: Maybe<Scalars['String']['output']>;
  /** User's zoom speed setting */
  zoomSpeed?: Maybe<Scalars['Decimal']['output']>;
};

export type UsersDocumentFilterInput = {
  activationStatus?: InputMaybe<UserActivationStatusOperationFilterInput>;
  and?: InputMaybe<Array<UsersDocumentFilterInput>>;
  appearance?: InputMaybe<NullableOfUserAppearanceOperationFilterInput>;
  avatarUrl?: InputMaybe<StringOperationFilterInput>;
  betaAgreementAccepted?: InputMaybe<NullableOfAgreementStatusOperationFilterInput>;
  created?: InputMaybe<ComparableNullableOfDateTimeOffsetOperationFilterInput>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  domain?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  emailConfirmationCode?: InputMaybe<StringOperationFilterInput>;
  externalIdentities?: InputMaybe<ListFilterInputTypeOfExternalIdentityFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  invited?: InputMaybe<ComparableNullableOfDateTimeOffsetOperationFilterInput>;
  language?: InputMaybe<StringOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  newEmailToConfirm?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UsersDocumentFilterInput>>;
  phoneActivationCode?: InputMaybe<StringOperationFilterInput>;
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  position?: InputMaybe<ComparableUInt64OperationFilterInput>;
  presenceColor?: InputMaybe<StringOperationFilterInput>;
  streamPosition?: InputMaybe<ComparableUInt64OperationFilterInput>;
  team?: InputMaybe<StringOperationFilterInput>;
  timezone?: InputMaybe<StringOperationFilterInput>;
  zoomSpeed?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
};

export type UsersDocumentSortInput = {
  activationStatus?: InputMaybe<SortEnumType>;
  appearance?: InputMaybe<SortEnumType>;
  avatarUrl?: InputMaybe<SortEnumType>;
  betaAgreementAccepted?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  displayName?: InputMaybe<SortEnumType>;
  domain?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  emailConfirmationCode?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  invited?: InputMaybe<SortEnumType>;
  language?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  newEmailToConfirm?: InputMaybe<SortEnumType>;
  phoneActivationCode?: InputMaybe<SortEnumType>;
  phoneNumber?: InputMaybe<SortEnumType>;
  position?: InputMaybe<SortEnumType>;
  presenceColor?: InputMaybe<SortEnumType>;
  streamPosition?: InputMaybe<SortEnumType>;
  team?: InputMaybe<SortEnumType>;
  timezone?: InputMaybe<SortEnumType>;
  zoomSpeed?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type UsersEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UsersDocument;
};

export type CurrentCountry = {
  code: Scalars['String']['output'];
  flagEmoji: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type UsersQuery = {
  auth0User: Auth0UserInfo;
  currentCountry?: Maybe<CurrentCountry>;
  developer: DeveloperQueries;
  invites: Array<UserInvitesDocument>;
  myProfile?: Maybe<UsersDocument>;
  onboarding: UserOnboardingQuery;
  /** @deprecated This query reads from User projection. Consider using referrals.my query for better performance. */
  referrals: Array<UserReferral>;
  users?: Maybe<UsersConnection>;
};


export type UsersQueryAuth0UserArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type UsersQueryInvitesArgs = {
  order?: InputMaybe<Array<UserInvitesDocumentSortInput>>;
  userId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<UserInvitesDocumentFilterInput>;
};


export type UsersQueryReferralsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type UsersQueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UsersDocumentSortInput>>;
  where?: InputMaybe<UsersDocumentFilterInput>;
};

export type VariantDetails = {
  id?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type VideoBlock = {
  caption?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type VideoContentPart = ContentPart & {
  caption?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type WebLinkContentPart = ContentPart & {
  caption?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type WebLinkContext = {
  caption?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type WhatsappMessageBlock = {
  caption?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type WhiteboardAccess = {
  allowClone: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permission: WhiteboardPermission;
  trail: YTrailsDocument;
  whiteboardId: Scalars['String']['output'];
};

export type WhiteboardCommandResult = {
  causationId?: Maybe<Scalars['String']['output']>;
  commandId: Scalars['String']['output'];
  correlationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** @deprecated Use state.name field instead */
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use state.ownerId field instead */
  ownerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use state.permissions field instead */
  permissions?: Maybe<WhiteboardPermissions>;
  state?: Maybe<WhiteboardState>;
  /** @deprecated Use state.status field instead */
  status?: Maybe<WhiteboardStatus>;
  /** @deprecated Use state field instead */
  whiteboard?: Maybe<WhiteboardState>;
};

/** A connection to a list of items. */
export type WhiteboardConnectionConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<WhiteboardConnectionEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<WhiteboardDetails>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type WhiteboardConnectionEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: WhiteboardDetails;
};

export type WhiteboardDetails = ProjectedDocument & {
  collaboration?: Maybe<Collaboration>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  intake?: Maybe<Intake>;
  name: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  permission: WhiteboardPermission;
  position: Scalars['UnsignedLong']['output'];
  publication?: Maybe<Publication>;
  ranking?: Maybe<Array<Ranking>>;
  sourceWhiteboardId?: Maybe<Scalars['String']['output']>;
  status: WhiteboardStatus;
  streamPosition: Scalars['UnsignedLong']['output'];
  trail: DocumentTrail;
};


export type WhiteboardDetailsPermissionArgs = {
  shareKey?: InputMaybe<Scalars['String']['input']>;
};

export type WhiteboardDetailsFilterInput = {
  and?: InputMaybe<Array<WhiteboardDetailsFilterInput>>;
  collaboration?: InputMaybe<CollaborationFilterInput>;
  createdAt?: InputMaybe<ComparableDateTimeOffsetOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  intake?: InputMaybe<IntakeFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WhiteboardDetailsFilterInput>>;
  ownerId?: InputMaybe<StringOperationFilterInput>;
  position?: InputMaybe<ComparableUInt64OperationFilterInput>;
  publication?: InputMaybe<PublicationFilterInput>;
  ranking?: InputMaybe<ListFilterInputTypeOfRankingFilterInput>;
  sourceWhiteboardId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<WhiteboardStatusOperationFilterInput>;
  streamPosition?: InputMaybe<ComparableUInt64OperationFilterInput>;
  trail?: InputMaybe<DocumentTrailFilterInput>;
};

export type WhiteboardDetailsSortInput = {
  collaboration?: InputMaybe<CollaborationSortInput>;
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  intake?: InputMaybe<IntakeSortInput>;
  name?: InputMaybe<SortEnumType>;
  ownerId?: InputMaybe<SortEnumType>;
  position?: InputMaybe<SortEnumType>;
  publication?: InputMaybe<PublicationSortInput>;
  sourceWhiteboardId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  streamPosition?: InputMaybe<SortEnumType>;
  trail?: InputMaybe<DocumentTrailSortInput>;
};

export type WhiteboardInfo = {
  collaborators: Array<UserAccess>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publishedLink?: Maybe<PublishedLink>;
  status: WhiteboardStatus;
  trail: YTrailsDocument;
};

export type WhiteboardMutations = {
  allowAnonymousEdit?: Maybe<WhiteboardCommandResult>;
  allowClone?: Maybe<WhiteboardCommandResult>;
  /** @deprecated Use Delete instead */
  archive?: Maybe<WhiteboardCommandResult>;
  clone?: Maybe<WhiteboardCommandResult>;
  closeIntake: IntakeState;
  create?: Maybe<WhiteboardCommandResult>;
  delete?: Maybe<WhiteboardCommandResult>;
  deleteMany: Array<WhiteboardCommandResult>;
  denyAnonymousEdit?: Maybe<WhiteboardCommandResult>;
  denyClone?: Maybe<WhiteboardCommandResult>;
  /** @deprecated Use WhiteboardMutations.GrantPermissions instead, this one will be deleted */
  grantPermission?: Maybe<WhiteboardCommandResult>;
  grantPermissions?: Maybe<WhiteboardCommandResult>;
  intakeCardForSection: IntakeCardResult;
  leave?: Maybe<WhiteboardCommandResult>;
  openIntake: OpenIntakeResult;
  permanentlyDelete?: Maybe<WhiteboardCommandResult>;
  publish?: Maybe<WhiteboardCommandResult>;
  rename?: Maybe<WhiteboardCommandResult>;
  restore?: Maybe<WhiteboardCommandResult>;
  revokePermission?: Maybe<WhiteboardCommandResult>;
  transferOwnership?: Maybe<WhiteboardCommandResult>;
  unpublish?: Maybe<WhiteboardCommandResult>;
};


export type WhiteboardMutationsAllowAnonymousEditArgs = {
  whiteboardId: Scalars['String']['input'];
};


export type WhiteboardMutationsAllowCloneArgs = {
  whiteboardId: Scalars['String']['input'];
};


export type WhiteboardMutationsArchiveArgs = {
  correlationId?: InputMaybe<Scalars['String']['input']>;
  whiteboardId: Scalars['String']['input'];
};


export type WhiteboardMutationsCloneArgs = {
  correlationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  shareKey?: InputMaybe<Scalars['String']['input']>;
  whiteboardId: Scalars['String']['input'];
};


export type WhiteboardMutationsCloseIntakeArgs = {
  whiteboardId: Scalars['String']['input'];
};


export type WhiteboardMutationsCreateArgs = {
  correlationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  waitForProjections?: Scalars['Boolean']['input'];
  whiteboardId?: InputMaybe<Scalars['String']['input']>;
};


export type WhiteboardMutationsDeleteArgs = {
  correlationId?: InputMaybe<Scalars['String']['input']>;
  whiteboardId: Scalars['String']['input'];
};


export type WhiteboardMutationsDeleteManyArgs = {
  correlationId?: InputMaybe<Scalars['String']['input']>;
  whiteboardIds: Array<Scalars['String']['input']>;
};


export type WhiteboardMutationsDenyAnonymousEditArgs = {
  whiteboardId: Scalars['String']['input'];
};


export type WhiteboardMutationsDenyCloneArgs = {
  whiteboardId: Scalars['String']['input'];
};


export type WhiteboardMutationsGrantPermissionArgs = {
  correlationId?: InputMaybe<Scalars['String']['input']>;
  permission: WhiteboardPermission;
  userEmail: Scalars['String']['input'];
  whiteboardId: Scalars['String']['input'];
};


export type WhiteboardMutationsGrantPermissionsArgs = {
  correlationId?: InputMaybe<Scalars['String']['input']>;
  permission: WhiteboardPermission;
  userEmails: Array<Scalars['String']['input']>;
  whiteboardId: Scalars['String']['input'];
};


export type WhiteboardMutationsIntakeCardForSectionArgs = {
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  authorAvatarUrl?: InputMaybe<Scalars['String']['input']>;
  authorEmail?: InputMaybe<Scalars['String']['input']>;
  authorName?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<CardInitialContentInput>;
  intakeKey: Scalars['String']['input'];
  sectionId: Scalars['String']['input'];
};


export type WhiteboardMutationsLeaveArgs = {
  correlationId?: InputMaybe<Scalars['String']['input']>;
  whiteboardId: Scalars['String']['input'];
};


export type WhiteboardMutationsOpenIntakeArgs = {
  sectionName?: InputMaybe<Scalars['String']['input']>;
  whiteboardId: Scalars['String']['input'];
};


export type WhiteboardMutationsPermanentlyDeleteArgs = {
  correlationId?: InputMaybe<Scalars['String']['input']>;
  whiteboardId: Scalars['String']['input'];
};


export type WhiteboardMutationsPublishArgs = {
  allowClone?: InputMaybe<Scalars['Boolean']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  shareKeyPermission?: InputMaybe<WhiteboardPermission>;
  whiteboardId: Scalars['String']['input'];
};


export type WhiteboardMutationsRenameArgs = {
  correlationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  whiteboardId: Scalars['String']['input'];
};


export type WhiteboardMutationsRestoreArgs = {
  correlationId?: InputMaybe<Scalars['String']['input']>;
  whiteboardId: Scalars['String']['input'];
};


export type WhiteboardMutationsRevokePermissionArgs = {
  correlationId?: InputMaybe<Scalars['String']['input']>;
  userEmail: Scalars['String']['input'];
  whiteboardId: Scalars['String']['input'];
};


export type WhiteboardMutationsTransferOwnershipArgs = {
  correlationId?: InputMaybe<Scalars['String']['input']>;
  newOwnerEmail: Scalars['String']['input'];
  whiteboardId: Scalars['String']['input'];
};


export type WhiteboardMutationsUnpublishArgs = {
  correlationId?: InputMaybe<Scalars['String']['input']>;
  sharingKey?: InputMaybe<Scalars['String']['input']>;
  whiteboardId: Scalars['String']['input'];
};

export type WhiteboardOwnersDocument = ProjectedDocument & {
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<EditorUserInfo>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  position: Scalars['UnsignedLong']['output'];
  status: WhiteboardStatus;
  streamPosition: Scalars['UnsignedLong']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<EditorUserInfo>;
  whiteboardId: Scalars['String']['output'];
};

export type WhiteboardOwnersDocumentFilterInput = {
  and?: InputMaybe<Array<WhiteboardOwnersDocumentFilterInput>>;
  createdAt?: InputMaybe<ComparableDateTimeOffsetOperationFilterInput>;
  createdBy?: InputMaybe<EditorUserInfoFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WhiteboardOwnersDocumentFilterInput>>;
  ownerId?: InputMaybe<StringOperationFilterInput>;
  position?: InputMaybe<ComparableUInt64OperationFilterInput>;
  status?: InputMaybe<WhiteboardStatusOperationFilterInput>;
  streamPosition?: InputMaybe<ComparableUInt64OperationFilterInput>;
  updatedAt?: InputMaybe<ComparableDateTimeOffsetOperationFilterInput>;
  updatedBy?: InputMaybe<EditorUserInfoFilterInput>;
  whiteboardId?: InputMaybe<StringOperationFilterInput>;
};

export type WhiteboardOwnersDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<EditorUserInfoSortInput>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  ownerId?: InputMaybe<SortEnumType>;
  position?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  streamPosition?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<EditorUserInfoSortInput>;
  whiteboardId?: InputMaybe<SortEnumType>;
};

export enum WhiteboardPermission {
  Deny = 'DENY',
  InvokeAi = 'INVOKE_AI',
  Owner = 'OWNER',
  Read = 'READ',
  Write = 'WRITE'
}

export type WhiteboardPermissionOperationFilterInput = {
  eq?: InputMaybe<WhiteboardPermission>;
  in?: InputMaybe<Array<WhiteboardPermission>>;
  neq?: InputMaybe<WhiteboardPermission>;
  nin?: InputMaybe<Array<WhiteboardPermission>>;
};

export type WhiteboardPermissions = {
  publishedLink?: Maybe<SharingLink>;
  userPermissions: Array<KeyValuePairOfStringAndWhiteboardPermission>;
};

export type WhiteboardPermissionsDocument = ProjectedDocument & {
  allowClone?: Maybe<Scalars['Boolean']['output']>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  collaborators?: Maybe<Array<UserAccess>>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  intakeKey?: Maybe<Scalars['String']['output']>;
  isPublished: Scalars['Boolean']['output'];
  /** @deprecated Use ShareKeyPermission instead. */
  isReadonly: Scalars['Boolean']['output'];
  ownerId: Scalars['String']['output'];
  position: Scalars['UnsignedLong']['output'];
  publishedOn?: Maybe<Scalars['DateTime']['output']>;
  restoredAt?: Maybe<Scalars['DateTime']['output']>;
  shareKeyPermission: WhiteboardPermission;
  sharingKey?: Maybe<Scalars['String']['output']>;
  status: WhiteboardStatus;
  streamPosition: Scalars['UnsignedLong']['output'];
  unPublishedOn?: Maybe<Scalars['DateTime']['output']>;
  whiteboardId: Scalars['String']['output'];
};

export type WhiteboardPermissionsDocumentFilterInput = {
  allowClone?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<WhiteboardPermissionsDocumentFilterInput>>;
  archivedAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  collaborators?: InputMaybe<ListFilterInputTypeOfUserAccessFilterInput>;
  createdAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  intakeKey?: InputMaybe<StringOperationFilterInput>;
  isPublished?: InputMaybe<BooleanOperationFilterInput>;
  /** @deprecated Use ShareKeyPermission instead. */
  isReadonly?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<WhiteboardPermissionsDocumentFilterInput>>;
  ownerId?: InputMaybe<StringOperationFilterInput>;
  position?: InputMaybe<ComparableUInt64OperationFilterInput>;
  publishedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  restoredAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  shareKeyPermission?: InputMaybe<WhiteboardPermissionOperationFilterInput>;
  sharingKey?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<WhiteboardStatusOperationFilterInput>;
  streamPosition?: InputMaybe<ComparableUInt64OperationFilterInput>;
  unPublishedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  whiteboardId?: InputMaybe<StringOperationFilterInput>;
};

export type WhiteboardPermissionsDocumentSortInput = {
  allowClone?: InputMaybe<SortEnumType>;
  archivedAt?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  intakeKey?: InputMaybe<SortEnumType>;
  isPublished?: InputMaybe<SortEnumType>;
  /** @deprecated Use ShareKeyPermission instead. */
  isReadonly?: InputMaybe<SortEnumType>;
  ownerId?: InputMaybe<SortEnumType>;
  position?: InputMaybe<SortEnumType>;
  publishedOn?: InputMaybe<SortEnumType>;
  restoredAt?: InputMaybe<SortEnumType>;
  shareKeyPermission?: InputMaybe<SortEnumType>;
  sharingKey?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  streamPosition?: InputMaybe<SortEnumType>;
  unPublishedOn?: InputMaybe<SortEnumType>;
  whiteboardId?: InputMaybe<SortEnumType>;
};

export type WhiteboardPreload = {
  id: Scalars['String']['output'];
  language?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ownerEmail: Scalars['String']['output'];
  shareKey?: Maybe<Scalars['String']['output']>;
  whiteboardName: Scalars['String']['output'];
};

export type WhiteboardQuery = {
  all?: Maybe<WhiteboardConnectionConnection>;
  /** @deprecated Use the `permissions` root field instead */
  checkPermission?: Maybe<WhiteboardPermission>;
  intake: WhiteboardSections;
  intakeKey?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `all` instead */
  list: Array<WhiteboardDetails>;
  /** @deprecated Use `all` instead */
  myWhiteboards: MyWhiteboardsDocument;
  owners?: Maybe<OwnersConnection>;
  /** @deprecated Use the `permissions` root field instead */
  permissions?: Maybe<PermissionsConnection>;
  published?: Maybe<MyWhiteboardsDocument>;
  templates?: Maybe<Array<Template>>;
};


export type WhiteboardQueryAllArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<WhiteboardDetailsSortInput>>;
  orderByRankList?: InputMaybe<KnownUserRanklists>;
  shareKey?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<WhiteboardDetailsFilterInput>;
};


export type WhiteboardQueryCheckPermissionArgs = {
  sharingKey?: InputMaybe<Scalars['String']['input']>;
  whiteboardId: Scalars['String']['input'];
};


export type WhiteboardQueryIntakeArgs = {
  intakeKey: Scalars['String']['input'];
};


export type WhiteboardQueryIntakeKeyArgs = {
  whiteboardId: Scalars['String']['input'];
};


export type WhiteboardQueryListArgs = {
  order?: InputMaybe<Array<WhiteboardDetailsSortInput>>;
  orderByRankList?: InputMaybe<KnownUserRanklists>;
  shareKey?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<WhiteboardDetailsFilterInput>;
};


export type WhiteboardQueryMyWhiteboardsArgs = {
  status?: InputMaybe<WhiteboardStatus>;
};


export type WhiteboardQueryOwnersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<WhiteboardOwnersDocumentSortInput>>;
  where?: InputMaybe<WhiteboardOwnersDocumentFilterInput>;
};


export type WhiteboardQueryPermissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<WhiteboardPermissionsDocumentSortInput>>;
  where?: InputMaybe<WhiteboardPermissionsDocumentFilterInput>;
};


export type WhiteboardQueryPublishedArgs = {
  shareKey: Scalars['String']['input'];
};


export type WhiteboardQueryTemplatesArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
};

export type WhiteboardSections = {
  ownerEmail?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  sections: Array<Section>;
  whiteboardId?: Maybe<Scalars['String']['output']>;
  whiteboardName?: Maybe<Scalars['String']['output']>;
};

export type WhiteboardState = {
  intakeKey?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  permissions: WhiteboardPermissions;
  status: WhiteboardStatus;
};

export enum WhiteboardStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Deleted = 'DELETED'
}

export type WhiteboardStatusOperationFilterInput = {
  eq?: InputMaybe<WhiteboardStatus>;
  in?: InputMaybe<Array<WhiteboardStatus>>;
  neq?: InputMaybe<WhiteboardStatus>;
  nin?: InputMaybe<Array<WhiteboardStatus>>;
};

export type XTwitterDetails = {
  card?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  imageAlt?: Maybe<Scalars['String']['output']>;
  player?: Maybe<Scalars['String']['output']>;
  playerHeight?: Maybe<Scalars['String']['output']>;
  playerStream?: Maybe<Scalars['String']['output']>;
  playerWidth?: Maybe<Scalars['String']['output']>;
  site?: Maybe<Scalars['String']['output']>;
  siteId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type YTrailsDocument = ProjectedDocument & {
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<EditorUserInfo>;
  id: Scalars['String']['output'];
  position: Scalars['UnsignedLong']['output'];
  streamPosition: Scalars['UnsignedLong']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<EditorUserInfo>;
};

export type Inmemory_DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Inmemory_NavbarBooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Inmemory_NavbarCollaborationFilterInput = {
  and?: InputMaybe<Array<Inmemory_NavbarCollaborationFilterInput>>;
  collaborators?: InputMaybe<Inmemory_NavbarListNavbarFilterInputTypeOfCollaboratorFilterInput>;
  isShared?: InputMaybe<Inmemory_NavbarBooleanOperationFilterInput>;
  or?: InputMaybe<Array<Inmemory_NavbarCollaborationFilterInput>>;
};

export type Inmemory_NavbarCollaboratorFilterInput = {
  and?: InputMaybe<Array<Inmemory_NavbarCollaboratorFilterInput>>;
  or?: InputMaybe<Array<Inmemory_NavbarCollaboratorFilterInput>>;
  permission?: InputMaybe<Inmemory_NavbarWhiteboardPermissionOperationFilterInput>;
  userEmail?: InputMaybe<Inmemory_NavbarStringOperationFilterInput>;
  userId?: InputMaybe<Inmemory_NavbarStringOperationFilterInput>;
};

export type Inmemory_NavbarIconDocumentFilterInput = {
  and?: InputMaybe<Array<Inmemory_NavbarIconDocumentFilterInput>>;
  or?: InputMaybe<Array<Inmemory_NavbarIconDocumentFilterInput>>;
  type?: InputMaybe<Inmemory_NavbarStringOperationFilterInput>;
  value?: InputMaybe<Inmemory_NavbarStringOperationFilterInput>;
};

export type Inmemory_NavbarIntakeFilterInput = {
  and?: InputMaybe<Array<Inmemory_NavbarIntakeFilterInput>>;
  isOpen?: InputMaybe<Inmemory_NavbarBooleanOperationFilterInput>;
  key?: InputMaybe<Inmemory_NavbarStringOperationFilterInput>;
  or?: InputMaybe<Array<Inmemory_NavbarIntakeFilterInput>>;
};

export type Inmemory_NavbarListNavbarFilterInputTypeOfCollaboratorFilterInput = {
  all?: InputMaybe<Inmemory_NavbarCollaboratorFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Inmemory_NavbarCollaboratorFilterInput>;
  some?: InputMaybe<Inmemory_NavbarCollaboratorFilterInput>;
};

export type Inmemory_NavbarListNavbarPersonalAccessTokenScopeOperationFilterInput = {
  all?: InputMaybe<Inmemory_NavbarPersonalAccessTokenScopeOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Inmemory_NavbarPersonalAccessTokenScopeOperationFilterInput>;
  some?: InputMaybe<Inmemory_NavbarPersonalAccessTokenScopeOperationFilterInput>;
};

export type Inmemory_NavbarNavBarItemTypeOperationFilterInput = {
  eq?: InputMaybe<NavBarItemType>;
  in?: InputMaybe<Array<NavBarItemType>>;
  neq?: InputMaybe<NavBarItemType>;
  nin?: InputMaybe<Array<NavBarItemType>>;
};

export type Inmemory_NavbarNavbarItemDocumentFilterInput = {
  and?: InputMaybe<Array<Inmemory_NavbarNavbarItemDocumentFilterInput>>;
  collaboration?: InputMaybe<Inmemory_NavbarCollaborationFilterInput>;
  icon?: InputMaybe<Inmemory_NavbarIconDocumentFilterInput>;
  intake?: InputMaybe<Inmemory_NavbarIntakeFilterInput>;
  itemKey?: InputMaybe<Inmemory_NavbarStringOperationFilterInput>;
  name?: InputMaybe<Inmemory_NavbarStringOperationFilterInput>;
  or?: InputMaybe<Array<Inmemory_NavbarNavbarItemDocumentFilterInput>>;
  parentKey?: InputMaybe<Inmemory_NavbarStringOperationFilterInput>;
  position?: InputMaybe<Inmemory_UnsignedLongOperationFilterInput>;
  publication?: InputMaybe<Inmemory_NavbarPublicationFilterInput>;
  rank?: InputMaybe<Inmemory_NavbarStringOperationFilterInput>;
  sourceRanklistId?: InputMaybe<Inmemory_NavbarStringOperationFilterInput>;
  status?: InputMaybe<Inmemory_NavbarNullableOfWhiteboardStatusOperationFilterInput>;
  streamPosition?: InputMaybe<Inmemory_UnsignedLongOperationFilterInput>;
  type?: InputMaybe<Inmemory_NavbarNavBarItemTypeOperationFilterInput>;
};

export type Inmemory_NavbarNullableOfWhiteboardPermissionOperationFilterInput = {
  eq?: InputMaybe<WhiteboardPermission>;
  in?: InputMaybe<Array<InputMaybe<WhiteboardPermission>>>;
  neq?: InputMaybe<WhiteboardPermission>;
  nin?: InputMaybe<Array<InputMaybe<WhiteboardPermission>>>;
};

export type Inmemory_NavbarNullableOfWhiteboardStatusOperationFilterInput = {
  eq?: InputMaybe<WhiteboardStatus>;
  in?: InputMaybe<Array<InputMaybe<WhiteboardStatus>>>;
  neq?: InputMaybe<WhiteboardStatus>;
  nin?: InputMaybe<Array<InputMaybe<WhiteboardStatus>>>;
};

export type Inmemory_NavbarPersonalAccessTokenInfoFilterInput = {
  and?: InputMaybe<Array<Inmemory_NavbarPersonalAccessTokenInfoFilterInput>>;
  displayHint?: InputMaybe<Inmemory_NavbarStringOperationFilterInput>;
  expiresAt?: InputMaybe<Inmemory_DateTimeOperationFilterInput>;
  id?: InputMaybe<Inmemory_NavbarStringOperationFilterInput>;
  isExpired?: InputMaybe<Inmemory_NavbarBooleanOperationFilterInput>;
  issuedAt?: InputMaybe<Inmemory_DateTimeOperationFilterInput>;
  lastUsedAt?: InputMaybe<Inmemory_DateTimeOperationFilterInput>;
  name?: InputMaybe<Inmemory_NavbarStringOperationFilterInput>;
  or?: InputMaybe<Array<Inmemory_NavbarPersonalAccessTokenInfoFilterInput>>;
  revokedAt?: InputMaybe<Inmemory_DateTimeOperationFilterInput>;
  scopes?: InputMaybe<Inmemory_NavbarListNavbarPersonalAccessTokenScopeOperationFilterInput>;
  status?: InputMaybe<Inmemory_NavbarPersonalAccessTokenStatusOperationFilterInput>;
};

export type Inmemory_NavbarPersonalAccessTokenScopeOperationFilterInput = {
  eq?: InputMaybe<PersonalAccessTokenScope>;
  in?: InputMaybe<Array<PersonalAccessTokenScope>>;
  neq?: InputMaybe<PersonalAccessTokenScope>;
  nin?: InputMaybe<Array<PersonalAccessTokenScope>>;
};

export type Inmemory_NavbarPersonalAccessTokenStatusOperationFilterInput = {
  eq?: InputMaybe<PersonalAccessTokenStatus>;
  in?: InputMaybe<Array<PersonalAccessTokenStatus>>;
  neq?: InputMaybe<PersonalAccessTokenStatus>;
  nin?: InputMaybe<Array<PersonalAccessTokenStatus>>;
};

export type Inmemory_NavbarPublicationFilterInput = {
  allowClone?: InputMaybe<Inmemory_NavbarBooleanOperationFilterInput>;
  and?: InputMaybe<Array<Inmemory_NavbarPublicationFilterInput>>;
  isPublished?: InputMaybe<Inmemory_NavbarBooleanOperationFilterInput>;
  /** @deprecated Use ShareKeyPermission instead. */
  isReadonly?: InputMaybe<Inmemory_NavbarBooleanOperationFilterInput>;
  key?: InputMaybe<Inmemory_NavbarStringOperationFilterInput>;
  or?: InputMaybe<Array<Inmemory_NavbarPublicationFilterInput>>;
  shareKeyPermission?: InputMaybe<Inmemory_NavbarNullableOfWhiteboardPermissionOperationFilterInput>;
};

export type Inmemory_NavbarStringOperationFilterInput = {
  and?: InputMaybe<Array<Inmemory_NavbarStringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<Inmemory_NavbarStringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Inmemory_NavbarWhiteboardPermissionOperationFilterInput = {
  eq?: InputMaybe<WhiteboardPermission>;
  in?: InputMaybe<Array<WhiteboardPermission>>;
  neq?: InputMaybe<WhiteboardPermission>;
  nin?: InputMaybe<Array<WhiteboardPermission>>;
};

export type Inmemory_UnsignedLongOperationFilterInput = {
  eq?: InputMaybe<Scalars['UnsignedLong']['input']>;
  gt?: InputMaybe<Scalars['UnsignedLong']['input']>;
  gte?: InputMaybe<Scalars['UnsignedLong']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedLong']['input']>>>;
  lt?: InputMaybe<Scalars['UnsignedLong']['input']>;
  lte?: InputMaybe<Scalars['UnsignedLong']['input']>;
  neq?: InputMaybe<Scalars['UnsignedLong']['input']>;
  ngt?: InputMaybe<Scalars['UnsignedLong']['input']>;
  ngte?: InputMaybe<Scalars['UnsignedLong']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UnsignedLong']['input']>>>;
  nlt?: InputMaybe<Scalars['UnsignedLong']['input']>;
  nlte?: InputMaybe<Scalars['UnsignedLong']['input']>;
};

export type GuestWebSocketTokenQueryVariables = Exact<{
  whiteboardId: Scalars['String']['input'];
  shareKey: Scalars['String']['input'];
}>;


export type GuestWebSocketTokenQuery = { guestWebSocketToken: { token: string, expiresAt: string, whiteboardId: string } };

export type RetryIngestMutationMutationVariables = Exact<{
  assetId: Scalars['String']['input'];
  shareKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type RetryIngestMutationMutation = { ingest: { retryIngest: boolean } };

export type AssetStatusSubscriptionSubscriptionVariables = Exact<{
  assetId: Scalars['String']['input'];
  shareKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type AssetStatusSubscriptionSubscription = { assetStatus: { fileName: string, id: string, ingestedAt?: string | null, ingestError?: string | null, ingestId?: string | null, ingestStatus: AssetIngestStatus, isIngested: boolean, isUploaded: boolean, progress?: number | null, uploadedAt?: string | null } };

export type UserDetailsFragmentFragment = { activationStatus: UserActivationStatus, avatarUrl?: string | null, created?: string | null, displayName?: string | null, domain?: string | null, email: string, firstName?: string | null, language?: string | null, lastName?: string | null, team?: string | null, timezone?: string | null } & { ' $fragmentName'?: 'UserDetailsFragmentFragment' };

export type SimpleCollaborationFragmentFragment = { isShared: boolean, collaborators: Array<{ permission: WhiteboardPermission, userId?: string | null, userEmail: string }> } & { ' $fragmentName'?: 'SimpleCollaborationFragmentFragment' };

export type DetailedCollboarationFragmentFragment = { isShared: boolean, collaborators: Array<{ permission: WhiteboardPermission, userId?: string | null, userEmail: string, details?: { ' $fragmentRefs'?: { 'UserDetailsFragmentFragment': UserDetailsFragmentFragment } } | null }> } & { ' $fragmentName'?: 'DetailedCollboarationFragmentFragment' };

export type PublicationFragmentFragment = { allowClone?: boolean | null, isPublished: boolean, isReadonly?: boolean | null, key?: string | null, shareKeyPermission?: WhiteboardPermission | null } & { ' $fragmentName'?: 'PublicationFragmentFragment' };

export type TrailFragmentFragment = { createdAt: string, updatedAt: string, createdBy?: { clientId: string, email: string, userId: string } | null, updatedBy?: { clientId: string, email: string, userId: string } | null } & { ' $fragmentName'?: 'TrailFragmentFragment' };

export type WhiteboardBasicInformationFragmentFragment = { id: string, name: string, ownerId: string, position: number, status: WhiteboardStatus, permission: WhiteboardPermission, streamPosition: number, intake?: { isOpen: boolean, key?: string | null } | null } & { ' $fragmentName'?: 'WhiteboardBasicInformationFragmentFragment' };

export type WhiteboardDetailsWithUsersFragmentFragment = (
  { collaboration?: { ' $fragmentRefs'?: { 'DetailedCollboarationFragmentFragment': DetailedCollboarationFragmentFragment } } | null, publication?: { ' $fragmentRefs'?: { 'PublicationFragmentFragment': PublicationFragmentFragment } } | null, trail: { ' $fragmentRefs'?: { 'TrailFragmentFragment': TrailFragmentFragment } } }
  & { ' $fragmentRefs'?: { 'WhiteboardBasicInformationFragmentFragment': WhiteboardBasicInformationFragmentFragment } }
) & { ' $fragmentName'?: 'WhiteboardDetailsWithUsersFragmentFragment' };

export type WhiteboardDetailsFragmentFragment = (
  { collaboration?: { ' $fragmentRefs'?: { 'SimpleCollaborationFragmentFragment': SimpleCollaborationFragmentFragment } } | null, publication?: { ' $fragmentRefs'?: { 'PublicationFragmentFragment': PublicationFragmentFragment } } | null, trail: { ' $fragmentRefs'?: { 'TrailFragmentFragment': TrailFragmentFragment } }, ranking?: Array<{ ' $fragmentRefs'?: { 'WhiteboardRankingFragmentFragment': WhiteboardRankingFragmentFragment } }> | null }
  & { ' $fragmentRefs'?: { 'WhiteboardBasicInformationFragmentFragment': WhiteboardBasicInformationFragmentFragment } }
) & { ' $fragmentName'?: 'WhiteboardDetailsFragmentFragment' };

export type WhiteboardRankingFragmentFragment = { listId: string, itemKey: string, itemRank?: string | null, itemDescription?: string | null } & { ' $fragmentName'?: 'WhiteboardRankingFragmentFragment' };

export type AddCardMutationVariables = Exact<{
  section: NavbarSection;
  name: Scalars['String']['input'];
  cardId: Scalars['String']['input'];
  parentFolderKey?: InputMaybe<Scalars['String']['input']>;
  beforeKey?: InputMaybe<Scalars['String']['input']>;
  afterKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddCardMutation = { navbar: { addCard?: { key: string, name: string, parentKey?: string | null, rank: string } | null } };

export type AllowAnonymousEditMutationVariables = Exact<{
  whiteboardId: Scalars['String']['input'];
}>;


export type AllowAnonymousEditMutation = { whiteboards: { allowAnonymousEdit?: { causationId?: string | null, commandId: string, correlationId?: string | null, id: string, state?: { name: string, ownerId: string, status: WhiteboardStatus, permissions: { publishedLink?: { allowClone: boolean, isReadonly: boolean, key: string } | null, userPermissions: Array<{ key: string, value: WhiteboardPermission }> } } | null } | null } };

export type AllowCloneMutationVariables = Exact<{
  whiteboardId: Scalars['String']['input'];
}>;


export type AllowCloneMutation = { whiteboards: { allowClone?: { causationId?: string | null, commandId: string, correlationId?: string | null, id: string, state?: { name: string, ownerId: string, status: WhiteboardStatus, permissions: { publishedLink?: { allowClone: boolean, isReadonly: boolean, key: string } | null, userPermissions: Array<{ key: string, value: WhiteboardPermission }> } } | null } | null } };

export type ArchiveWhiteboardMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ArchiveWhiteboardMutation = { whiteboards: { archive?: { status?: WhiteboardStatus | null, name?: string | null, ownerId?: string | null } | null } };

export type CloneWhiteboardMutationVariables = Exact<{
  whiteboardId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  shareKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type CloneWhiteboardMutation = { whiteboards: { clone?: { id: string, state?: { name: string, ownerId: string, status: WhiteboardStatus, permissions: { publishedLink?: { allowClone: boolean, isReadonly: boolean, key: string } | null, userPermissions: Array<{ key: string, value: WhiteboardPermission }> } } | null } | null } };

export type CloseIntakeMutationVariables = Exact<{
  whiteboardId: Scalars['String']['input'];
}>;


export type CloseIntakeMutation = { whiteboards: { closeIntake: { intakeKey?: string | null, isActive: boolean } } };

export type CopyDocumentMutationVariables = Exact<{
  sourceTypedId: Scalars['String']['input'];
  targetTypedId?: InputMaybe<Scalars['String']['input']>;
  parentWhiteboardId?: InputMaybe<Scalars['String']['input']>;
  shareKey?: InputMaybe<Scalars['String']['input']>;
  allowOverride?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CopyDocumentMutation = { documents: { copy: { id: string } } };

export type CreateCardAtWhiteboardMutationVariables = Exact<{
  whiteboardId: Scalars['String']['input'];
  cardId: Scalars['String']['input'];
  shape: CardShapeInput;
  content?: InputMaybe<CardInitialContentInput>;
}>;


export type CreateCardAtWhiteboardMutation = { cards: { createAtWhiteboard: { cardId: string, whiteboardId: string, shape: { id?: string | null } } } };

export type CreateCardInWorkspaceMutationVariables = Exact<{
  section: NavbarSection;
  name: Scalars['String']['input'];
  cardId?: InputMaybe<Scalars['String']['input']>;
  parentFolderKey?: InputMaybe<Scalars['String']['input']>;
  beforeKey?: InputMaybe<Scalars['String']['input']>;
  afterKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCardInWorkspaceMutation = { navbar: { createCard?: { key: string, name: string, parentKey?: string | null, rank: string } | null } };

export type CreateDemoBoardMutationVariables = Exact<{
  sessionId?: InputMaybe<Scalars['String']['input']>;
  campaign?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateDemoBoardMutation = { demo: { createBoard: { demoSessionId: string, shareKey: string, whiteboardId: string, whiteboardUrl: string } } };

export type CreateFolderMutationVariables = Exact<{
  section: NavbarSection;
  name: Scalars['String']['input'];
  parentFolderKey?: InputMaybe<Scalars['String']['input']>;
  beforeKey?: InputMaybe<Scalars['String']['input']>;
  afterKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateFolderMutation = { navbar: { createFolder?: { key: string, name: string, parentKey?: string | null, rank: string } | null } };

export type CreateWhiteboardMutationVariables = Exact<{
  name: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateWhiteboardMutation = { whiteboards: { create?: { id: string, whiteboard?: { name: string, ownerId: string, status: WhiteboardStatus } | null } | null } };

export type DeleteFolderMutationVariables = Exact<{
  section: NavbarSection;
  key: Scalars['String']['input'];
}>;


export type DeleteFolderMutation = { navbar: { deleteFolder: boolean } };

export type DeleteWhiteboardMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteWhiteboardMutation = { whiteboards: { delete?: { name?: string | null, ownerId?: string | null } | null } };

export type DenyAnonymousEditMutationVariables = Exact<{
  whiteboardId: Scalars['String']['input'];
}>;


export type DenyAnonymousEditMutation = { whiteboards: { denyAnonymousEdit?: { causationId?: string | null, commandId: string, correlationId?: string | null, id: string, state?: { name: string, ownerId: string, status: WhiteboardStatus, permissions: { publishedLink?: { allowClone: boolean, isReadonly: boolean, key: string } | null, userPermissions: Array<{ key: string, value: WhiteboardPermission }> } } | null } | null } };

export type DenyCloneMutationVariables = Exact<{
  whiteboardId: Scalars['String']['input'];
}>;


export type DenyCloneMutation = { whiteboards: { denyClone?: { causationId?: string | null, commandId: string, correlationId?: string | null, id: string, state?: { name: string, ownerId: string, status: WhiteboardStatus, permissions: { publishedLink?: { allowClone: boolean, isReadonly: boolean, key: string } | null, userPermissions: Array<{ key: string, value: WhiteboardPermission }> } } | null } | null } };

export type NavbarFavouriteMutationVariables = Exact<{
  section: NavbarSection;
  itemKeys: Array<Scalars['String']['input']> | Scalars['String']['input'];
  waitForProjections: Scalars['Boolean']['input'];
}>;


export type NavbarFavouriteMutation = { navbar: { favourite: boolean } };

export type WhiteboardMutationsMutationVariables = Exact<{
  whiteboardId: Scalars['String']['input'];
  userEmails: Array<Scalars['String']['input']> | Scalars['String']['input'];
  permission: WhiteboardPermission;
}>;


export type WhiteboardMutationsMutation = { whiteboards: { grantPermissions?: { name?: string | null, ownerId?: string | null, status?: WhiteboardStatus | null, permissions?: { publishedLink?: { isReadonly: boolean, key: string } | null, userPermissions: Array<{ key: string, value: WhiteboardPermission }> } | null } | null } };

export type LeaveCardMutationVariables = Exact<{
  cardId: Scalars['String']['input'];
}>;


export type LeaveCardMutation = { cards: { leave: { id: string, commandId: string, correlationId?: string | null, causationId?: string | null } } };

export type LeaveWhiteboardMutationVariables = Exact<{
  whiteboardId: Scalars['String']['input'];
}>;


export type LeaveWhiteboardMutation = { whiteboards: { leave?: { causationId?: string | null, commandId: string, correlationId?: string | null, id: string, name?: string | null, ownerId?: string | null, status?: WhiteboardStatus | null } | null } };

export type MoveRanklistItemMutationVariables = Exact<{
  fromSection: NavbarSection;
  toSection: NavbarSection;
  items: Array<ItemToMoveInput> | ItemToMoveInput;
  waitForProjections?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MoveRanklistItemMutation = { navbar: { moveItems?: Array<{ key: string, name: string, parentKey?: string | null, rank: string, type: NavBarItemType }> | null } };

export type OpenIntakeMutationVariables = Exact<{
  whiteboardId: Scalars['String']['input'];
}>;


export type OpenIntakeMutation = { whiteboards: { openIntake: { intakeKey?: string | null, isActive: boolean } } };

export type PublishWhiteboardMutationVariables = Exact<{
  whiteboardId: Scalars['String']['input'];
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  allowClone?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PublishWhiteboardMutation = { whiteboards: { publish?: { state?: { name: string, ownerId: string, status: WhiteboardStatus, permissions: { publishedLink?: { allowClone: boolean, isReadonly: boolean, key: string } | null, userPermissions: Array<{ key: string, value: WhiteboardPermission }> } } | null } | null } };

export type RankWhiteboardItemMutationVariables = Exact<{
  knownList: KnownUserRanklists;
  key: Scalars['String']['input'];
  beforeKey?: InputMaybe<Scalars['String']['input']>;
  afterKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type RankWhiteboardItemMutation = { ranklists: { rankItem?: { name: string } | null } };

export type NavbarRemoveCardMutationVariables = Exact<{
  section: NavbarSection;
  cardId: Scalars['String']['input'];
  waitForProjections: Scalars['Boolean']['input'];
}>;


export type NavbarRemoveCardMutation = { navbar: { removeCard: boolean } };

export type RenameFolderMutationVariables = Exact<{
  section: NavbarSection;
  folderKey: Scalars['String']['input'];
  newName: Scalars['String']['input'];
}>;


export type RenameFolderMutation = { navbar: { renameFolder?: { key: string, name: string, parentKey?: string | null, rank: string } | null } };

export type RenameWhiteboardMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type RenameWhiteboardMutation = { whiteboards: { rename?: { status?: WhiteboardStatus | null, name?: string | null, ownerId?: string | null } | null } };

export type RestoreWhiteboardMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RestoreWhiteboardMutation = { whiteboards: { restore?: { status?: WhiteboardStatus | null, name?: string | null, ownerId?: string | null } | null } };

export type RevokePermissionsMutationVariables = Exact<{
  whiteboardId: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
}>;


export type RevokePermissionsMutation = { whiteboards: { revokePermission?: { status?: WhiteboardStatus | null, name?: string | null, ownerId?: string | null } | null } };

export type SetNavbarItemIconMutationVariables = Exact<{
  section: NavbarSection;
  itemKey: Scalars['String']['input'];
  icon: IconInput;
  waitForProjections?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetNavbarItemIconMutation = { navbar: { setItemIcon?: { id: string, key: string, name: string, type: NavBarItemType, icon?: { type: IconType, value: string } | null } | null } };

export type RemoveNavbarItemIconMutationVariables = Exact<{
  section: NavbarSection;
  itemKey: Scalars['String']['input'];
  waitForProjections?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RemoveNavbarItemIconMutation = { navbar: { removeItemIcon?: { id: string, key: string, name: string, type: NavBarItemType, icon?: { type: IconType, value: string } | null } | null } };

export type TransferWhiteboardMutationVariables = Exact<{
  whiteboardId: Scalars['String']['input'];
  newOwnerEmail: Scalars['String']['input'];
}>;


export type TransferWhiteboardMutation = { whiteboards: { transferOwnership?: { name?: string | null, ownerId?: string | null, status?: WhiteboardStatus | null, permissions?: { publishedLink?: { isReadonly: boolean, key: string } | null, userPermissions: Array<{ key: string, value: WhiteboardPermission }> } | null } | null } };

export type RestoreItemMutationVariables = Exact<{
  trashId: Scalars['String']['input'];
}>;


export type RestoreItemMutation = { trash: { restore: boolean } };

export type PermanentlyDeleteTrashItemMutationVariables = Exact<{
  trashId: Scalars['String']['input'];
}>;


export type PermanentlyDeleteTrashItemMutation = { trash: { permanentlyDelete: boolean } };

export type EmptyTrashBinMutationVariables = Exact<{ [key: string]: never; }>;


export type EmptyTrashBinMutation = { trash: { empty: number } };

export type RestoreAllMutationVariables = Exact<{ [key: string]: never; }>;


export type RestoreAllMutation = { trash: { restoreAll: number } };

export type NavbarUnfavouriteMutationVariables = Exact<{
  itemKey: Scalars['String']['input'];
}>;


export type NavbarUnfavouriteMutation = { navbar: { unfavourite: boolean } };

export type UnpublishWhiteboardMutationVariables = Exact<{
  whiteboardId: Scalars['String']['input'];
  sharingKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnpublishWhiteboardMutation = { whiteboards: { unpublish?: { status?: WhiteboardStatus | null, name?: string | null, ownerId?: string | null, permissions?: { publishedLink?: { isReadonly: boolean, key: string } | null } | null } | null } };

export type ActiveWhiteboardWithSharePanelQueryVariables = Exact<{
  whiteboardId: Scalars['String']['input'];
  shareKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type ActiveWhiteboardWithSharePanelQuery = { whiteboards: { list: Array<(
      { collaboration?: { ' $fragmentRefs'?: { 'DetailedCollboarationFragmentFragment': DetailedCollboarationFragmentFragment } } | null, publication?: { ' $fragmentRefs'?: { 'PublicationFragmentFragment': PublicationFragmentFragment } } | null, trail: { ' $fragmentRefs'?: { 'TrailFragmentFragment': TrailFragmentFragment } } }
      & { ' $fragmentRefs'?: { 'WhiteboardDetailsFragmentFragment': WhiteboardDetailsFragmentFragment } }
    )> } };

export type FetchActiveWhiteboardsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  shareKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type FetchActiveWhiteboardsQuery = { whiteboards: { list: Array<{ ' $fragmentRefs'?: { 'WhiteboardDetailsFragmentFragment': WhiteboardDetailsFragmentFragment } }> } };

export type FetchAllNonArchivedWhiteboardsQueryVariables = Exact<{
  shareKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type FetchAllNonArchivedWhiteboardsQuery = { whiteboards: { list: Array<{ ' $fragmentRefs'?: { 'WhiteboardDetailsFragmentFragment': WhiteboardDetailsFragmentFragment } }> } };

export type OwnedWhiteboardsListQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  shareKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type OwnedWhiteboardsListQuery = { whiteboards: { list: Array<{ ' $fragmentRefs'?: { 'WhiteboardDetailsFragmentFragment': WhiteboardDetailsFragmentFragment } }> } };

export type FetchNavbarBranchQueryVariables = Exact<{
  section: NavbarSection;
  parentKey?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WhiteboardStatus>;
}>;


export type FetchNavbarBranchQuery = { navbar: { branch: Array<{ key: string, name: string, type: NavBarItemType, parentKey?: string | null, rank: string, hasChildren: boolean, status?: WhiteboardStatus | null, icon?: { type: IconType, value: string } | null, collaboration?: { isShared: boolean, collaborators: Array<{ userId?: string | null, permission: WhiteboardPermission }> } | null, publication?: { isPublished: boolean } | null }> } };

export type FetchNavbarTreeQueryVariables = Exact<{
  section: NavbarSection;
  status?: InputMaybe<WhiteboardStatus>;
}>;


export type FetchNavbarTreeQuery = { navbar: { tree: Array<{ key: string, name: string, type: NavBarItemType, parentKey?: string | null, rank: string, hasChildren: boolean, status?: WhiteboardStatus | null, icon?: { type: IconType, value: string } | null, collaboration?: { isShared: boolean, collaborators: Array<{ userId?: string | null, permission: WhiteboardPermission }> } | null, publication?: { isPublished: boolean } | null }> } };

export type FetchSharedWhiteboardsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  shareKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type FetchSharedWhiteboardsQuery = { whiteboards: { list: Array<{ ' $fragmentRefs'?: { 'WhiteboardDetailsFragmentFragment': WhiteboardDetailsFragmentFragment } }> } };

export type FetchTemplateWhiteboardsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchTemplateWhiteboardsQuery = { whiteboards: { templates?: Array<{ displayName: string, id: string, rank: string, whiteboardName: string, shareKey?: string | null }> | null } };

export type FetchTrashItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchTrashItemsQuery = { trash: { items?: { nodes?: Array<{ deletedAt: string, deletedBy: string, entityId: string, id: string, name: string, ownerEmail: string, ownerId: string, position: number, streamPosition: number, location: { containerId?: string | null, containerName?: string | null, locationType: string, path?: string | null } }> | null } | null } };

export type PublishedWhiteboardQueryVariables = Exact<{
  shareKey: Scalars['String']['input'];
}>;


export type PublishedWhiteboardQuery = { whiteboards: { published?: { id: string, position: number, streamPosition: number, sharedWithMe?: Array<{ name: string, permission: WhiteboardPermission, whiteboardId: string, allowClone: boolean }> | null } | null } };

export type UnfurlQueryVariables = Exact<{
  url: Scalars['String']['input'];
  locationDocumentTypedId?: InputMaybe<Scalars['String']['input']>;
  shareKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnfurlQuery = { integrations: { unfurl: { summary: { description?: string | null, favicon?: string | null, image?: string | null, src: string, title?: string | null } } } };

export type MyWhiteboardsProjectedSubscriptionSubscriptionVariables = Exact<{
  whiteboardId?: InputMaybe<Scalars['String']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
  shareKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type MyWhiteboardsProjectedSubscriptionSubscription = { myWhiteboardsProjected: { entityId: string, isSuccess: boolean, projectedTime: string, sequence: number, subscriptionName: string, event: { causationId?: string | null, correlationId?: string | null, id: string, number: number, eventType?: string | null } } };

export type GeneratePreprintMutationVariables = Exact<{
  preprintId: Scalars['String']['input'];
  promptId: Scalars['String']['input'];
  contentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  model?: InputMaybe<SupportedModel>;
  parentWhiteboardId?: InputMaybe<Scalars['String']['input']>;
  shareKey?: InputMaybe<Scalars['String']['input']>;
  useWebSearch?: InputMaybe<Scalars['Boolean']['input']>;
  expandReferences?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GeneratePreprintMutation = { cards: { generatePreprint: { subscriptionTopic: string, id: string, model: SupportedModel, version: number } } };

export type GetContextStatsQueryVariables = Exact<{
  promptCardId: Scalars['String']['input'];
  contentCardIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  parentWhiteboardId?: InputMaybe<Scalars['String']['input']>;
  agent?: InputMaybe<SupportedAgent>;
  shareKey?: InputMaybe<Scalars['String']['input']>;
  expandReferences?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetContextStatsQuery = { ai: { contextStats: { totalTokens: number, images: number, files: number, cards: number, others: number, models: Array<{ model: SupportedModel, modelId: string, maxInputTokens: number, maxImages?: number | null, tier: SupportedFeature, isTierAvailable: boolean, isRegionRestricted: boolean, capabilities: Array<SupportedModelCapability>, inputModalities: Array<Modality>, outputModalities: Array<Modality>, compatibleAgents: Array<SupportedAgent> }> } } };

export type GetSupportedAgentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSupportedAgentsQuery = { ai: { allAgents: Array<{ agent: SupportedAgent, models: Array<{ model: SupportedModel, modelId: string, isRegionRestricted: boolean, isTierAvailable: boolean, tier: SupportedFeature, compatibleAgents: Array<SupportedAgent>, capabilities: Array<SupportedModelCapability>, maxInputTokens: number, maxImages?: number | null, inputModalities?: Array<Modality> | null, outputModalities?: Array<Modality> | null }> }>, myAgents: Array<{ agent: SupportedAgent, hasCustomPreferences: boolean, models: Array<{ model: SupportedModel, modelId: string, isRegionRestricted: boolean, isTierAvailable: boolean, tier: SupportedFeature, compatibleAgents: Array<SupportedAgent>, capabilities: Array<SupportedModelCapability>, maxInputTokens: number, maxImages?: number | null, inputModalities?: Array<Modality> | null, outputModalities?: Array<Modality> | null }>, defaultModels: Array<{ isRegionRestricted: boolean, model: SupportedModel, modelId: string, isTierAvailable: boolean, tier: SupportedFeature, compatibleAgents: Array<SupportedAgent>, capabilities: Array<SupportedModelCapability>, maxInputTokens: number, maxImages?: number | null, inputModalities?: Array<Modality> | null, outputModalities?: Array<Modality> | null }> }> } };

export type DraftsIndexQueryVariables = Exact<{
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<DraftIndexDocumentSortInput> | DraftIndexDocumentSortInput>;
}>;


export type DraftsIndexQuery = { draft: { index?: { nodes?: Array<{ id: string, hasContent: boolean, markdown?: string | null, updatedAt: string, specialBlocks?: { tasks?: Array<{ id?: string | null, text?: string | null, checked?: boolean | null }> | null, images?: Array<{ id?: string | null, url?: string | null, filename?: string | null, caption?: string | null }> | null, whatsappMessages?: Array<{ id?: string | null, text?: string | null, type?: string | null, url?: string | null, name?: string | null, caption?: string | null }> | null, audios?: Array<{ id?: string | null, url?: string | null, name?: string | null, caption?: string | null }> | null, videos?: Array<{ id?: string | null, url?: string | null, name?: string | null, caption?: string | null }> | null, files?: Array<{ id?: string | null, url?: string | null, filename?: string | null, name?: string | null, caption?: string | null }> | null } | null }> | null, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null } };

export type RestoreHistoryVersionMutationVariables = Exact<{
  typedId: Scalars['String']['input'];
  versionNumber: Scalars['Int']['input'];
  shareKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type RestoreHistoryVersionMutation = { history: { restoreVersion?: { newDocumentName?: string | null, newVersion: number, restoredFromVersion: number } | null } };

export type SaveCurrentVersionMutationVariables = Exact<{
  typedId: Scalars['String']['input'];
  shareKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type SaveCurrentVersionMutation = { history: { saveVersion?: { createdAt: string, documentName: string, size: number, version: number, versionName?: string | null } | null } };

export type GetVersionHistoryQueryVariables = Exact<{
  typedId: Scalars['String']['input'];
  shareKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVersionHistoryQuery = { history: { versions?: Array<{ version: number, createdAt: string, documentName: string, description?: string | null, size: number, authors: Array<{ id?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, email?: string | null, contributedAt: string, anonymous?: boolean | null }> }> | null } };

export type GetVersionStatusQueryVariables = Exact<{
  typedId: Scalars['String']['input'];
  shareKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVersionStatusQuery = { history: { current?: { isSynced: boolean } | null } };

export type ArchiveCardMutationVariables = Exact<{
  cardId: Scalars['String']['input'];
}>;


export type ArchiveCardMutation = { cards: { archive: { id: string, commandId: string, correlationId?: string | null, causationId?: string | null } } };

export type DeleteCardMutationVariables = Exact<{
  cardId: Scalars['String']['input'];
}>;


export type DeleteCardMutation = { cards: { delete: { id: string, commandId: string, correlationId?: string | null, causationId?: string | null } } };

export type UnarchiveCardMutationVariables = Exact<{
  cardId: Scalars['String']['input'];
}>;


export type UnarchiveCardMutation = { cards: { unarchive: { id: string, commandId: string, correlationId?: string | null, causationId?: string | null } } };

export type PublishCardMutationVariables = Exact<{
  cardId: Scalars['String']['input'];
  initialize?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PublishCardMutation = { cards: { publish: { cardId: string, shareKey?: string | null, commandId: string } } };

export type UnpublishCardMutationVariables = Exact<{
  cardId: Scalars['String']['input'];
}>;


export type UnpublishCardMutation = { cards: { unpublish: { id: string, commandId: string, correlationId?: string | null, causationId?: string | null } } };

export type GrantCardPermissionMutationVariables = Exact<{
  cardId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  role: CardPermission;
  initialize?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GrantCardPermissionMutation = { cards: { grantPermission: { id: string, commandId: string, correlationId?: string | null, causationId?: string | null } } };

export type RevokeCardPermissionMutationVariables = Exact<{
  cardId: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type RevokeCardPermissionMutation = { cards: { revokePermission: { id: string, commandId: string, correlationId?: string | null, causationId?: string | null } } };

export type AllowAnonymousEditCardMutationVariables = Exact<{
  cardId: Scalars['String']['input'];
}>;


export type AllowAnonymousEditCardMutation = { cards: { allowAnonymousEdit: { id: string, commandId: string } } };

export type DenyAnonymousEditCardMutationVariables = Exact<{
  cardId: Scalars['String']['input'];
}>;


export type DenyAnonymousEditCardMutation = { cards: { denyAnonymousEdit: { id: string, commandId: string } } };

export type TransferCardOwnershipMutationVariables = Exact<{
  cardId: Scalars['String']['input'];
  newOwnerEmail: Scalars['String']['input'];
}>;


export type TransferCardOwnershipMutation = { cards: { transferOwnership: { id: string, commandId: string } } };

export type RenameCardMutationVariables = Exact<{
  cardId: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type RenameCardMutation = { cards: { rename: { id: string, commandId: string } } };

export type PutToLibraryMutationVariables = Exact<{
  cardId: Scalars['String']['input'];
  whiteboardId: Scalars['String']['input'];
}>;


export type PutToLibraryMutation = { cards: { addToLibrary: { causationId?: string | null, commandId: string, correlationId?: string | null, id: string } } };

export type MyCardLibraryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type MyCardLibraryQuery = { library: { cards?: { nodes?: Array<{ createdAt: string, id: string, isPublished: boolean, name: string, ownerId: string, position: number, shareKey?: string | null, status: CardStatus, streamPosition: number }> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } };

export type MyCardQueryVariables = Exact<{
  cardId: Scalars['String']['input'];
  shareKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type MyCardQuery = { library: { card?: { createdAt: string, id: string, isPublished: boolean, name: string, ownerId: string, ownerName?: string | null, ownerAvatarUrl?: string | null, position: number, shareKey?: string | null, status: CardStatus, streamPosition: number, whiteboards: Array<{ id: string, knownRanklist?: string | null, shapeIds: Array<string> }>, collaboration?: { isShared: boolean, collaborators: Array<{ userId?: string | null, userEmail: string, permission: CardPermission }> } | null, publication?: { isPublished: boolean, key?: string | null, shareKeyPermission?: CardPermission | null } | null } | null } };

export type MarkMentionAsReadMutationVariables = Exact<{
  mentionId: Scalars['String']['input'];
}>;


export type MarkMentionAsReadMutation = { mentions: { markAsRead: boolean } };

export type MarkAllMentionsAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllMentionsAsReadMutation = { mentions: { markAllAsRead: boolean } };

export type MarkMentionSelectedMutationVariables = Exact<{
  id: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MarkMentionSelectedMutation = { mentions: { markSelected?: { id: string, label: string } | null } };

export type RecordMentionMutationVariables = Exact<{
  sourceId: Scalars['String']['input'];
  idempotencyId: Scalars['String']['input'];
  mentionedUserId: Scalars['String']['input'];
  snippet: Scalars['String']['input'];
  deepLink: Scalars['String']['input'];
  anchorId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecordMentionMutation = { mentions: { mention: { mentionId?: string | null, success: boolean } } };

export type MentionInboxQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<MentionInboxItemFilterInput>;
  order?: InputMaybe<Array<MentionInboxItemSortInput> | MentionInboxItemSortInput>;
}>;


export type MentionInboxQuery = { mentions: { inbox?: { pageInfo: { hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ id: string, idempotencyId: string, authorId: string, authorName: string, authorAvatarUrl?: string | null, sourceId: string, anchorId?: string | null, snippet: string, deepLink: string, createdAt: string, isRead: boolean, readAt?: string | null }> | null } | null } };

export type MentionUnreadCountQueryVariables = Exact<{ [key: string]: never; }>;


export type MentionUnreadCountQuery = { mentions: { unreadCount: number } };

export type MentionSuggestionsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MentionSuggestionsQuery = { mentions: { suggest: { sessionId: string, matches: Array<{ id: string, label: string }>, recentlySelected: Array<{ id: string, label: string }>, latestUpdated: Array<{ id: string, label: string }> } } };

export type SuggestPeopleQueryVariables = Exact<{
  query: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SuggestPeopleQuery = { mentions: { suggestPeople: Array<{ id: string, displayName: string, email: string, avatarUrl?: string | null }> } };

export type OnMentionInboxUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnMentionInboxUpdatedSubscription = { onMentionInboxUpdated: { eventType: MentionInboxEventType, mentionId?: string | null, unreadCount: number, mention?: { id: string, idempotencyId: string, authorId: string, authorName: string, authorAvatarUrl?: string | null, sourceId: string, anchorId?: string | null, snippet: string, deepLink: string, createdAt: string, isRead: boolean, readAt?: string | null } | null } };

export type CompleteOnboardingStepMutationVariables = Exact<{
  step: OnboardingStep;
}>;


export type CompleteOnboardingStepMutation = { user: { onboarding: { completeStep?: { steps: Array<{ key: OnboardingStep, value: { isCompleted: boolean } }> } | null } } };

export type GetOnboardingStatusQueryVariables = Exact<{
  steps?: InputMaybe<StepsFilter>;
}>;


export type GetOnboardingStatusQuery = { users: { onboarding: { overview?: { createdAt?: string | null, id: string, position: number, streamPosition: number, updatedAt?: string | null, steps: Array<{ isCompleted: boolean, step: OnboardingStep, updatedAt?: string | null }> } | null } } };

type FeatureStateFragment_FeatureState_Fragment = { available: boolean, feature: SupportedFeature } & { ' $fragmentName'?: 'FeatureStateFragment_FeatureState_Fragment' };

type FeatureStateFragment_MeteredFeatureState_Fragment = { available: boolean, current: number, dimension: Dimension, feature: SupportedFeature, quota: number } & { ' $fragmentName'?: 'FeatureStateFragment_MeteredFeatureState_Fragment' };

type FeatureStateFragment_MeteredPerEntityFeatureState_Fragment = { available: boolean, current: number, dimension: Dimension, entity: FeatureEntity, entityId: string, feature: SupportedFeature, quota: number } & { ' $fragmentName'?: 'FeatureStateFragment_MeteredPerEntityFeatureState_Fragment' };

type FeatureStateFragment_MeteredPerPeriodFeatureState_Fragment = { available: boolean, current: number, feature: SupportedFeature, quota: number, period: any, periodReset: string } & { ' $fragmentName'?: 'FeatureStateFragment_MeteredPerPeriodFeatureState_Fragment' };

type FeatureStateFragment_MeteredPerPeriodWithBalanceFeatureState_Fragment = { available: boolean, current: number, feature: SupportedFeature, quota: number, period: any, periodReset: string, balance: number, balanceUsedThisPeriod: number, featureAvailable: boolean } & { ' $fragmentName'?: 'FeatureStateFragment_MeteredPerPeriodWithBalanceFeatureState_Fragment' };

export type FeatureStateFragmentFragment = FeatureStateFragment_FeatureState_Fragment | FeatureStateFragment_MeteredFeatureState_Fragment | FeatureStateFragment_MeteredPerEntityFeatureState_Fragment | FeatureStateFragment_MeteredPerPeriodFeatureState_Fragment | FeatureStateFragment_MeteredPerPeriodWithBalanceFeatureState_Fragment;

export type ExternalStateFramgentFragment = { id?: string | null, url?: string | null, userId?: string | null, terms?: { id?: string | null, name?: string | null, type?: string | null, url?: string | null } | null } & { ' $fragmentName'?: 'ExternalStateFramgentFragment' };

export type PlanDocumentFragmentFragment = { id: string, internalUserId: string, plan: SupportedPlan, planFamily: PlanFamily, position: number, provider: PaymentProvider, renewsAt?: string | null, status: PlanStatus, streamPosition: number, trialEnd?: string | null, userEmail: string, currentPeriodAvailableExtraUsageCredits: number, extraUsageCredits: number, confirmedTotalUsedCredits: number, nextBalanceCloseAt?: string | null, external?: { ' $fragmentRefs'?: { 'ExternalStateFramgentFragment': ExternalStateFramgentFragment } } | null, features?: Array<{ ' $fragmentRefs'?: { 'FeatureStateFragment_FeatureState_Fragment': FeatureStateFragment_FeatureState_Fragment } } | { ' $fragmentRefs'?: { 'FeatureStateFragment_MeteredFeatureState_Fragment': FeatureStateFragment_MeteredFeatureState_Fragment } } | { ' $fragmentRefs'?: { 'FeatureStateFragment_MeteredPerEntityFeatureState_Fragment': FeatureStateFragment_MeteredPerEntityFeatureState_Fragment } } | { ' $fragmentRefs'?: { 'FeatureStateFragment_MeteredPerPeriodFeatureState_Fragment': FeatureStateFragment_MeteredPerPeriodFeatureState_Fragment } } | { ' $fragmentRefs'?: { 'FeatureStateFragment_MeteredPerPeriodWithBalanceFeatureState_Fragment': FeatureStateFragment_MeteredPerPeriodWithBalanceFeatureState_Fragment } }> | null } & { ' $fragmentName'?: 'PlanDocumentFragmentFragment' };

export type ActivateStarterMutationVariables = Exact<{ [key: string]: never; }>;


export type ActivateStarterMutation = { plans: { activateStarter: { causationId?: string | null, commandId: string, correlationId?: string | null, id: string, state?: { internalUserId?: string | null, provider: PaymentProvider, renewsAt?: string | null, status: PlanStatus } | null } } };

export type CreateBillingPortalSessionMutationVariables = Exact<{
  previewReturnUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateBillingPortalSessionMutation = { plans: { createBillingPortalSession: string } };

export type CreateCheckoutMutationVariables = Exact<{
  priceId: Scalars['String']['input'];
  discountCode?: InputMaybe<Scalars['String']['input']>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCheckoutMutation = { plans: { checkout: { secret: string } } };

export type CreateStripeExtraCreditsCheckoutMutationVariables = Exact<{
  creditThousands: Scalars['Int']['input'];
  previewReturnUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateStripeExtraCreditsCheckoutMutation = { plans: { createStripeExtraCreditsCheckout: { secret: string, sessionId: string } } };

export type GraduateFromBetaMutationVariables = Exact<{ [key: string]: never; }>;


export type GraduateFromBetaMutation = { user: { graduateFromBeta: { wasMigrated: boolean, plan?: { position: number, state: { internalUserId?: string | null, provider: PaymentProvider, renewsAt?: string | null, status: PlanStatus, trialEndsAt?: string | null } } | null } } };

export type MyPlanMeteredQueryVariables = Exact<{
  whiteboardId: Scalars['String']['input'];
  entityType: FeatureEntity;
  supportedFeature: SupportedFeature;
}>;


export type MyPlanMeteredQuery = { plans: { featureState?: { ' $fragmentRefs'?: { 'FeatureStateFragment_FeatureState_Fragment': FeatureStateFragment_FeatureState_Fragment } } | { ' $fragmentRefs'?: { 'FeatureStateFragment_MeteredFeatureState_Fragment': FeatureStateFragment_MeteredFeatureState_Fragment } } | { ' $fragmentRefs'?: { 'FeatureStateFragment_MeteredPerEntityFeatureState_Fragment': FeatureStateFragment_MeteredPerEntityFeatureState_Fragment } } | { ' $fragmentRefs'?: { 'FeatureStateFragment_MeteredPerPeriodFeatureState_Fragment': FeatureStateFragment_MeteredPerPeriodFeatureState_Fragment } } | { ' $fragmentRefs'?: { 'FeatureStateFragment_MeteredPerPeriodWithBalanceFeatureState_Fragment': FeatureStateFragment_MeteredPerPeriodWithBalanceFeatureState_Fragment } } | null } };

export type MyPlansQueryVariables = Exact<{
  shareKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type MyPlansQuery = { plans: { myPlan?: { ' $fragmentRefs'?: { 'PlanDocumentFragmentFragment': PlanDocumentFragmentFragment } } | null } };

export type ProductInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductInformationQuery = { plans: { checkout: { pro: { annual?: { id?: string | null } | null, monthly?: { id?: string | null } | null }, starter: { annual?: { id?: string | null } | null, monthly?: { id?: string | null } | null } } } };

export type PlanStatusSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type PlanStatusSubscriptionSubscription = { planStatus: { event: { payload?: { ' $fragmentRefs'?: { 'PlanDocumentFragmentFragment': PlanDocumentFragmentFragment } } | null } } };

export type ClaimReferralRewardMutationVariables = Exact<{
  rewardCode: Scalars['String']['input'];
}>;


export type ClaimReferralRewardMutation = { referrals: { redeemReward: { globalPosition?: number | null, needPaymentMethod: boolean, profile?: { rewards: { grantedRewards: Array<{ campaignCode: string, expiresAt: string, isRedeemed: boolean, refereeId: string, rewardCode: any }> } } | null, stripe?: { renewsAt?: string | null, status?: string | null, subscriptionId?: string | null, needPaymentMethod: boolean } | null } } };

export type GetMyReferralProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyReferralProfileQuery = { referrals: { profile: { qualifiedReferralCount: number, totalRewardsGranted: number, totalRewardsRedeemed: number, referralCode?: string | null, referredBy?: string | null, referredByEmail?: string | null, rewards?: Array<{ expiresAt: string, grantedAt: string, isRedeemed: boolean, rewardCode: string, refereeId: string, rewardType?: string | null }> | null, referrals?: Array<{ activatedAt?: string | null, registeredAt?: string | null, refereeEmail: string, refereeId: string, status: ReferralStatus }> | null } } };

export type IssuePersonalAccessTokenMutationVariables = Exact<{
  name: Scalars['String']['input'];
  scopes: Array<PersonalAccessTokenScope> | PersonalAccessTokenScope;
}>;


export type IssuePersonalAccessTokenMutation = { user: { developer: { personalAccessToken: { issue: { token: string, personalAccessToken: { id: string, name: string, displayHint: string, issuedAt: string, lastUsedAt?: string | null, expiresAt?: string | null, revokedAt?: string | null, scopes: Array<PersonalAccessTokenScope>, status: PersonalAccessTokenStatus } } } } } };

export type RevokePersonalAccessTokenMutationVariables = Exact<{
  tokenId: Scalars['String']['input'];
}>;


export type RevokePersonalAccessTokenMutation = { user: { developer: { personalAccessToken: { revoke: { id: string, status: PersonalAccessTokenStatus, revokedAt?: string | null } } } } };

export type RegisterUserMutationMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  idProvider: Scalars['String']['input'];
  avatarUrl: Scalars['String']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
  demoSessionId?: InputMaybe<Scalars['String']['input']>;
  demoWhiteboardId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterUserMutationMutation = { user: { register?: { id: string, position?: number | null, user: { activationStatus: UserActivationStatus, avatarUrl?: string | null, email: string, firstName?: string | null, lastName?: string | null, phoneActivationCode?: string | null, phoneNumber?: string | null, externalIdentities: Array<{ id: string, provider: string }> } } | null } };

export type ResendVerificationEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type ResendVerificationEmailMutation = { user: { resendVerificationEmail: boolean } };

export type ResetPreferredModelsMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetPreferredModelsMutation = { ai: { resetPreferredModels: { state: { modelPreferences: Array<{ key: string, value: Array<string> }> } } } };

export type SetPreferredModelsMutationVariables = Exact<{
  agent: SupportedAgent;
  models: Array<SupportedModel> | SupportedModel;
}>;


export type SetPreferredModelsMutation = { ai: { setPreferredModels: { state: { modelPreferences: Array<{ key: string, value: Array<string> }> } } } };

export type UpdateUserProfileMutationVariables = Exact<{
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  zoomSpeed?: InputMaybe<Scalars['Decimal']['input']>;
  appearance?: InputMaybe<UserAppearance>;
}>;


export type UpdateUserProfileMutation = { user: { updateProfile?: { email: string, zoomSpeed?: any | null, appearance?: UserAppearance | null } | null } };

export type UpdateUserPresenceColorMutationVariables = Exact<{
  presenceColor?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserPresenceColorMutation = { user: { updateProfile?: { presenceColor?: string | null } | null } };

export type ChangeZoomSpeedMutationVariables = Exact<{
  zoomSpeed: Scalars['Decimal']['input'];
}>;


export type ChangeZoomSpeedMutation = { user: { changeZoomSpeed?: { zoomSpeed?: any | null } | null } };

export type ChangeAppearanceMutationVariables = Exact<{
  appearance: UserAppearance;
}>;


export type ChangeAppearanceMutation = { user: { changeAppearance?: { appearance?: UserAppearance | null } | null } };

export type FindByEmailQueryQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type FindByEmailQueryQuery = { users: { users?: { nodes?: Array<{ activationStatus: UserActivationStatus, avatarUrl?: string | null, displayName?: string | null, email: string, firstName?: string | null, id: string, language?: string | null, lastName?: string | null, newEmailToConfirm?: string | null, phoneNumber?: string | null, presenceColor?: string | null, timezone?: string | null, zoomSpeed?: any | null, appearance?: UserAppearance | null, externalIdentities?: Array<{ id: string, provider: string }> | null }> | null } | null } };

export type GetAuth0UserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuth0UserQuery = { users: { auth0User: { email?: string | null, emailVerified: boolean, name?: string | null, picture?: string | null, userId: string } } };

export type GetCurrentCountryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentCountryQuery = { users: { currentCountry?: { code: string, name: string, flagEmoji: string } | null } };

export type GetPersonalAccessTokensQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPersonalAccessTokensQuery = { users: { developer: { personalAccessToken: { tokens: Array<{ id: string, name: string, displayHint: string, issuedAt: string, lastUsedAt?: string | null, expiresAt?: string | null, revokedAt?: string | null, scopes: Array<PersonalAccessTokenScope>, status: PersonalAccessTokenStatus, isExpired: boolean }> } } } };

export type MoveToLocationMutationMutationVariables = Exact<{
  assetId: Scalars['String']['input'];
  destination: Scalars['String']['input'];
  source: Scalars['String']['input'];
  permission: AssetPermission;
  shareKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type MoveToLocationMutationMutation = { assets: { moveToLocation: boolean } };

export type PrepareAssetUploadMutationMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  locationDocumentTypedId?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<AssetPermission>;
  shareKey?: InputMaybe<Scalars['String']['input']>;
  parentWhiteboardId?: InputMaybe<Scalars['String']['input']>;
  backgroundIngest?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PrepareAssetUploadMutationMutation = { assets: { prepareUpload: { uploadUrl: string, downloadUrl: string, assetId: string } } };

export type AssistantAnsweredPartSubscriptionVariables = Exact<{
  cardId: Scalars['String']['input'];
}>;


export type AssistantAnsweredPartSubscription = { assistantAnsweredPart: { errorMessage?: string | null, text: string } };

export type GetWhatsAppPhoneNumberQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWhatsAppPhoneNumberQuery = { integrations: { whatsAppPhoneNumber: string } };

export type GeneratePhoneActivationCodeMutationVariables = Exact<{ [key: string]: never; }>;


export type GeneratePhoneActivationCodeMutation = { user: { generatePhoneActivationCode?: { activationStatus: UserActivationStatus, avatarUrl?: string | null, email: string, emailActivationCode?: string | null, emailToActivate?: string | null, firstName?: string | null, lastName?: string | null, phoneActivationCode?: string | null, phoneNumber?: string | null, externalIdentities: Array<{ id: string, provider: string }> } | null } };

export type UpdateUserProfileFieldsMutationVariables = Exact<{
  avatarUrl: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  language: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
}>;


export type UpdateUserProfileFieldsMutation = { user: { updateProfile?: { avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, displayName?: string | null, languageCode?: string | null, timeZoneId?: string | null } | null } };

export const WhiteboardBasicInformationFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WhiteboardBasicInformationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WhiteboardDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"permission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}}]},{"kind":"Field","name":{"kind":"Name","value":"streamPosition"}},{"kind":"Field","name":{"kind":"Name","value":"intake"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isOpen"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]} as unknown as DocumentNode<WhiteboardBasicInformationFragmentFragment, unknown>;
export const UserDetailsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"team"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]} as unknown as DocumentNode<UserDetailsFragmentFragment, unknown>;
export const DetailedCollboarationFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DetailedCollboarationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collaboration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isShared"}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserDetailsFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"team"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]} as unknown as DocumentNode<DetailedCollboarationFragmentFragment, unknown>;
export const PublicationFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Publication"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowClone"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isReadonly"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"shareKeyPermission"}}]}}]} as unknown as DocumentNode<PublicationFragmentFragment, unknown>;
export const TrailFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TrailFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentTrail"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<TrailFragmentFragment, unknown>;
export const WhiteboardDetailsWithUsersFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WhiteboardDetailsWithUsersFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WhiteboardDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WhiteboardBasicInformationFragment"}},{"kind":"Field","name":{"kind":"Name","value":"collaboration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DetailedCollboarationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrailFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"team"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WhiteboardBasicInformationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WhiteboardDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"permission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}}]},{"kind":"Field","name":{"kind":"Name","value":"streamPosition"}},{"kind":"Field","name":{"kind":"Name","value":"intake"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isOpen"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DetailedCollboarationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collaboration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isShared"}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserDetailsFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Publication"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowClone"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isReadonly"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"shareKeyPermission"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TrailFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentTrail"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<WhiteboardDetailsWithUsersFragmentFragment, unknown>;
export const SimpleCollaborationFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimpleCollaborationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collaboration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isShared"}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}}]}}]} as unknown as DocumentNode<SimpleCollaborationFragmentFragment, unknown>;
export const WhiteboardRankingFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WhiteboardRankingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Ranking"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listId"}},{"kind":"Field","name":{"kind":"Name","value":"itemKey"}},{"kind":"Field","name":{"kind":"Name","value":"itemRank"}},{"kind":"Field","name":{"kind":"Name","value":"itemDescription"}}]}}]} as unknown as DocumentNode<WhiteboardRankingFragmentFragment, unknown>;
export const WhiteboardDetailsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WhiteboardDetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WhiteboardDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WhiteboardBasicInformationFragment"}},{"kind":"Field","name":{"kind":"Name","value":"collaboration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimpleCollaborationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrailFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ranking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WhiteboardRankingFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WhiteboardBasicInformationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WhiteboardDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"permission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}}]},{"kind":"Field","name":{"kind":"Name","value":"streamPosition"}},{"kind":"Field","name":{"kind":"Name","value":"intake"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isOpen"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimpleCollaborationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collaboration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isShared"}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Publication"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowClone"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isReadonly"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"shareKeyPermission"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TrailFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentTrail"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WhiteboardRankingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Ranking"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listId"}},{"kind":"Field","name":{"kind":"Name","value":"itemKey"}},{"kind":"Field","name":{"kind":"Name","value":"itemRank"}},{"kind":"Field","name":{"kind":"Name","value":"itemDescription"}}]}}]} as unknown as DocumentNode<WhiteboardDetailsFragmentFragment, unknown>;
export const ExternalStateFramgentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalStateFramgent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"terms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<ExternalStateFramgentFragment, unknown>;
export const FeatureStateFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureStateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeteredFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"dimension"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeteredPerEntityFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"dimension"}},{"kind":"Field","name":{"kind":"Name","value":"entity"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeteredPerPeriodFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"periodReset"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeteredPerPeriodWithBalanceFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"periodReset"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"balanceUsedThisPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"featureAvailable"}}]}}]}}]} as unknown as DocumentNode<FeatureStateFragmentFragment, unknown>;
export const PlanDocumentFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanDocumentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PlanDocument"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalUserId"}},{"kind":"Field","name":{"kind":"Name","value":"plan"}},{"kind":"Field","name":{"kind":"Name","value":"planFamily"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"renewsAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"streamPosition"}},{"kind":"Field","name":{"kind":"Name","value":"trialEnd"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"currentPeriodAvailableExtraUsageCredits"}},{"kind":"Field","name":{"kind":"Name","value":"extraUsageCredits"}},{"kind":"Field","name":{"kind":"Name","value":"confirmedTotalUsedCredits"}},{"kind":"Field","name":{"kind":"Name","value":"nextBalanceCloseAt"}},{"kind":"Field","name":{"kind":"Name","value":"external"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalStateFramgent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureStateFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalStateFramgent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"terms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureStateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeteredFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"dimension"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeteredPerEntityFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"dimension"}},{"kind":"Field","name":{"kind":"Name","value":"entity"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeteredPerPeriodFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"periodReset"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeteredPerPeriodWithBalanceFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"periodReset"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"balanceUsedThisPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"featureAvailable"}}]}}]}}]} as unknown as DocumentNode<PlanDocumentFragmentFragment, unknown>;
export const GuestWebSocketTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GuestWebSocketToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guestWebSocketToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"whiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"whiteboardId"}}]}}]}}]} as unknown as DocumentNode<GuestWebSocketTokenQuery, GuestWebSocketTokenQueryVariables>;
export const RetryIngestMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RetryIngestMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ingest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retryIngest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}}]}]}}]}}]} as unknown as DocumentNode<RetryIngestMutationMutation, RetryIngestMutationMutationVariables>;
export const AssetStatusSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"AssetStatusSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ingestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ingestError"}},{"kind":"Field","name":{"kind":"Name","value":"ingestId"}},{"kind":"Field","name":{"kind":"Name","value":"ingestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isIngested"}},{"kind":"Field","name":{"kind":"Name","value":"isUploaded"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedAt"}}]}}]}}]} as unknown as DocumentNode<AssetStatusSubscriptionSubscription, AssetStatusSubscriptionSubscriptionVariables>;
export const AddCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"section"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NavbarSection"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentFolderKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"beforeKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"afterKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navbar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"cardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"parentFolderKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentFolderKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"beforeKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"beforeKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"afterKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"afterKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentKey"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}}]}}]}}]}}]} as unknown as DocumentNode<AddCardMutation, AddCardMutationVariables>;
export const AllowAnonymousEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"allowAnonymousEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowAnonymousEdit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"whiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"causationId"}},{"kind":"Field","name":{"kind":"Name","value":"commandId"}},{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishedLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowClone"}},{"kind":"Field","name":{"kind":"Name","value":"isReadonly"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllowAnonymousEditMutation, AllowAnonymousEditMutationVariables>;
export const AllowCloneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"allowClone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowClone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"whiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"causationId"}},{"kind":"Field","name":{"kind":"Name","value":"commandId"}},{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishedLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowClone"}},{"kind":"Field","name":{"kind":"Name","value":"isReadonly"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllowCloneMutation, AllowCloneMutationVariables>;
export const ArchiveWhiteboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"archiveWhiteboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archive"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"whiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}}]}}]}}]}}]} as unknown as DocumentNode<ArchiveWhiteboardMutation, ArchiveWhiteboardMutationVariables>;
export const CloneWhiteboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cloneWhiteboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"whiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishedLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowClone"}},{"kind":"Field","name":{"kind":"Name","value":"isReadonly"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CloneWhiteboardMutation, CloneWhiteboardMutationVariables>;
export const CloseIntakeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"closeIntake"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"closeIntake"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"whiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intakeKey"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}}]} as unknown as DocumentNode<CloseIntakeMutation, CloseIntakeMutationVariables>;
export const CopyDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"copyDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceTypedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetTypedId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentWhiteboardId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allowOverride"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sourceTypedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceTypedId"}}},{"kind":"Argument","name":{"kind":"Name","value":"targetTypedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetTypedId"}}},{"kind":"Argument","name":{"kind":"Name","value":"parentWhiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentWhiteboardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"allowOverride"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allowOverride"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CopyDocumentMutation, CopyDocumentMutationVariables>;
export const CreateCardAtWhiteboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCardAtWhiteboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shape"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CardShapeInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"content"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CardInitialContentInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAtWhiteboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"whiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"cardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shape"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shape"}}},{"kind":"Argument","name":{"kind":"Name","value":"content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"content"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardId"}},{"kind":"Field","name":{"kind":"Name","value":"whiteboardId"}},{"kind":"Field","name":{"kind":"Name","value":"shape"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateCardAtWhiteboardMutation, CreateCardAtWhiteboardMutationVariables>;
export const CreateCardInWorkspaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCardInWorkspace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"section"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NavbarSection"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentFolderKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"beforeKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"afterKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navbar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"cardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"parentFolderKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentFolderKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"beforeKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"beforeKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"afterKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"afterKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentKey"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCardInWorkspaceMutation, CreateCardInWorkspaceMutationVariables>;
export const CreateDemoBoardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDemoBoard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaign"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBoard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"campaign"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaign"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demoSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"shareKey"}},{"kind":"Field","name":{"kind":"Name","value":"whiteboardId"}},{"kind":"Field","name":{"kind":"Name","value":"whiteboardUrl"}}]}}]}}]}}]} as unknown as DocumentNode<CreateDemoBoardMutation, CreateDemoBoardMutationVariables>;
export const CreateFolderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createFolder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"section"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NavbarSection"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentFolderKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"beforeKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"afterKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navbar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFolder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"parentFolderKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentFolderKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"beforeKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"beforeKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"afterKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"afterKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentKey"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}}]}}]}}]}}]} as unknown as DocumentNode<CreateFolderMutation, CreateFolderMutationVariables>;
export const CreateWhiteboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createWhiteboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"correlationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"whiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"correlationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"correlationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateWhiteboardMutation, CreateWhiteboardMutationVariables>;
export const DeleteFolderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteFolder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"section"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NavbarSection"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navbar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFolder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section"}}},{"kind":"Argument","name":{"kind":"Name","value":"folderKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}]}]}}]}}]} as unknown as DocumentNode<DeleteFolderMutation, DeleteFolderMutationVariables>;
export const DeleteWhiteboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteWhiteboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"whiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteWhiteboardMutation, DeleteWhiteboardMutationVariables>;
export const DenyAnonymousEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"denyAnonymousEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"denyAnonymousEdit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"whiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"causationId"}},{"kind":"Field","name":{"kind":"Name","value":"commandId"}},{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishedLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowClone"}},{"kind":"Field","name":{"kind":"Name","value":"isReadonly"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DenyAnonymousEditMutation, DenyAnonymousEditMutationVariables>;
export const DenyCloneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"denyClone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"denyClone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"whiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"causationId"}},{"kind":"Field","name":{"kind":"Name","value":"commandId"}},{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishedLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowClone"}},{"kind":"Field","name":{"kind":"Name","value":"isReadonly"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DenyCloneMutation, DenyCloneMutationVariables>;
export const NavbarFavouriteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"navbarFavourite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"section"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NavbarSection"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itemKeys"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"waitForProjections"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navbar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"favourite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section"}}},{"kind":"Argument","name":{"kind":"Name","value":"itemKeys"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itemKeys"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitForProjections"},"value":{"kind":"Variable","name":{"kind":"Name","value":"waitForProjections"}}}]}]}}]}}]} as unknown as DocumentNode<NavbarFavouriteMutation, NavbarFavouriteMutationVariables>;
export const WhiteboardMutationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"whiteboardMutations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userEmails"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"permission"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WhiteboardPermission"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grantPermissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"whiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userEmails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userEmails"}}},{"kind":"Argument","name":{"kind":"Name","value":"permission"},"value":{"kind":"Variable","name":{"kind":"Name","value":"permission"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishedLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isReadonly"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<WhiteboardMutationsMutation, WhiteboardMutationsMutationVariables>;
export const LeaveCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"leaveCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leave"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commandId"}},{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"causationId"}}]}}]}}]}}]} as unknown as DocumentNode<LeaveCardMutation, LeaveCardMutationVariables>;
export const LeaveWhiteboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"leaveWhiteboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leave"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"whiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"causationId"}},{"kind":"Field","name":{"kind":"Name","value":"commandId"}},{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<LeaveWhiteboardMutation, LeaveWhiteboardMutationVariables>;
export const MoveRanklistItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"moveRanklistItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromSection"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NavbarSection"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toSection"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NavbarSection"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"items"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ItemToMoveInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"waitForProjections"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navbar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"moveItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fromSection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromSection"}}},{"kind":"Argument","name":{"kind":"Name","value":"toSection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toSection"}}},{"kind":"Argument","name":{"kind":"Name","value":"items"},"value":{"kind":"Variable","name":{"kind":"Name","value":"items"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitForProjections"},"value":{"kind":"Variable","name":{"kind":"Name","value":"waitForProjections"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentKey"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<MoveRanklistItemMutation, MoveRanklistItemMutationVariables>;
export const OpenIntakeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"openIntake"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openIntake"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"whiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intakeKey"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}}]} as unknown as DocumentNode<OpenIntakeMutation, OpenIntakeMutationVariables>;
export const PublishWhiteboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"publishWhiteboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isReadonly"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allowClone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publish"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"whiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"isReadonly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isReadonly"}}},{"kind":"Argument","name":{"kind":"Name","value":"allowClone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allowClone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishedLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowClone"}},{"kind":"Field","name":{"kind":"Name","value":"isReadonly"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PublishWhiteboardMutation, PublishWhiteboardMutationVariables>;
export const RankWhiteboardItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"rankWhiteboardItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"knownList"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"KnownUserRanklists"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"beforeKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"afterKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ranklists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rankItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"knownList"},"value":{"kind":"Variable","name":{"kind":"Name","value":"knownList"}}},{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}},{"kind":"Argument","name":{"kind":"Name","value":"beforeKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"beforeKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"afterKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"afterKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<RankWhiteboardItemMutation, RankWhiteboardItemMutationVariables>;
export const NavbarRemoveCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"navbarRemoveCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"section"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NavbarSection"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"waitForProjections"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navbar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section"}}},{"kind":"Argument","name":{"kind":"Name","value":"cardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitForProjections"},"value":{"kind":"Variable","name":{"kind":"Name","value":"waitForProjections"}}}]}]}}]}}]} as unknown as DocumentNode<NavbarRemoveCardMutation, NavbarRemoveCardMutationVariables>;
export const RenameFolderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"renameFolder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"section"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NavbarSection"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folderKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navbar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renameFolder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section"}}},{"kind":"Argument","name":{"kind":"Name","value":"folderKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folderKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"newName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentKey"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}}]}}]}}]}}]} as unknown as DocumentNode<RenameFolderMutation, RenameFolderMutationVariables>;
export const RenameWhiteboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"renameWhiteboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rename"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"whiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}}]}}]}}]}}]} as unknown as DocumentNode<RenameWhiteboardMutation, RenameWhiteboardMutationVariables>;
export const RestoreWhiteboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"restoreWhiteboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restore"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"whiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}}]}}]}}]}}]} as unknown as DocumentNode<RestoreWhiteboardMutation, RestoreWhiteboardMutationVariables>;
export const RevokePermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"revokePermissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokePermission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"whiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}}]}}]}}]}}]} as unknown as DocumentNode<RevokePermissionsMutation, RevokePermissionsMutationVariables>;
export const SetNavbarItemIconDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setNavbarItemIcon"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"section"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NavbarSection"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itemKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"icon"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IconInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"waitForProjections"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navbar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setItemIcon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section"}}},{"kind":"Argument","name":{"kind":"Name","value":"itemKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itemKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"icon"},"value":{"kind":"Variable","name":{"kind":"Name","value":"icon"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitForProjections"},"value":{"kind":"Variable","name":{"kind":"Name","value":"waitForProjections"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SetNavbarItemIconMutation, SetNavbarItemIconMutationVariables>;
export const RemoveNavbarItemIconDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeNavbarItemIcon"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"section"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NavbarSection"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itemKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"waitForProjections"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navbar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeItemIcon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section"}}},{"kind":"Argument","name":{"kind":"Name","value":"itemKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itemKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitForProjections"},"value":{"kind":"Variable","name":{"kind":"Name","value":"waitForProjections"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RemoveNavbarItemIconMutation, RemoveNavbarItemIconMutationVariables>;
export const TransferWhiteboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"transferWhiteboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newOwnerEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transferOwnership"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"whiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"newOwnerEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newOwnerEmail"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishedLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isReadonly"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TransferWhiteboardMutation, TransferWhiteboardMutationVariables>;
export const RestoreItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"restoreItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trashId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trash"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restore"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"trashId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trashId"}}}]}]}}]}}]} as unknown as DocumentNode<RestoreItemMutation, RestoreItemMutationVariables>;
export const PermanentlyDeleteTrashItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"permanentlyDeleteTrashItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trashId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trash"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permanentlyDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"trashId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trashId"}}}]}]}}]}}]} as unknown as DocumentNode<PermanentlyDeleteTrashItemMutation, PermanentlyDeleteTrashItemMutationVariables>;
export const EmptyTrashBinDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"emptyTrashBin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trash"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"empty"}}]}}]}}]} as unknown as DocumentNode<EmptyTrashBinMutation, EmptyTrashBinMutationVariables>;
export const RestoreAllDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"restoreAll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trash"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restoreAll"}}]}}]}}]} as unknown as DocumentNode<RestoreAllMutation, RestoreAllMutationVariables>;
export const NavbarUnfavouriteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"navbarUnfavourite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itemKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navbar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unfavourite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"itemKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itemKey"}}}]}]}}]}}]} as unknown as DocumentNode<NavbarUnfavouriteMutation, NavbarUnfavouriteMutationVariables>;
export const UnpublishWhiteboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"unpublishWhiteboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sharingKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unpublish"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"whiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sharingKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sharingKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishedLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isReadonly"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UnpublishWhiteboardMutation, UnpublishWhiteboardMutationVariables>;
export const ActiveWhiteboardWithSharePanelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"activeWhiteboardWithSharePanel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"list"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WhiteboardDetailsFragment"}},{"kind":"Field","name":{"kind":"Name","value":"collaboration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DetailedCollboarationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrailFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WhiteboardBasicInformationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WhiteboardDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"permission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}}]},{"kind":"Field","name":{"kind":"Name","value":"streamPosition"}},{"kind":"Field","name":{"kind":"Name","value":"intake"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isOpen"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimpleCollaborationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collaboration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isShared"}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Publication"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowClone"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isReadonly"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"shareKeyPermission"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TrailFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentTrail"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WhiteboardRankingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Ranking"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listId"}},{"kind":"Field","name":{"kind":"Name","value":"itemKey"}},{"kind":"Field","name":{"kind":"Name","value":"itemRank"}},{"kind":"Field","name":{"kind":"Name","value":"itemDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"team"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WhiteboardDetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WhiteboardDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WhiteboardBasicInformationFragment"}},{"kind":"Field","name":{"kind":"Name","value":"collaboration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimpleCollaborationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrailFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ranking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WhiteboardRankingFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DetailedCollboarationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collaboration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isShared"}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserDetailsFragment"}}]}}]}}]}}]} as unknown as DocumentNode<ActiveWhiteboardWithSharePanelQuery, ActiveWhiteboardWithSharePanelQueryVariables>;
export const FetchActiveWhiteboardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchActiveWhiteboards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"list"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderByRankList"},"value":{"kind":"EnumValue","value":"MY_WHITEBOARDS"}},{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ownerId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"ACTIVE"}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WhiteboardDetailsFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WhiteboardBasicInformationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WhiteboardDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"permission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}}]},{"kind":"Field","name":{"kind":"Name","value":"streamPosition"}},{"kind":"Field","name":{"kind":"Name","value":"intake"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isOpen"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimpleCollaborationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collaboration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isShared"}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Publication"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowClone"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isReadonly"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"shareKeyPermission"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TrailFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentTrail"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WhiteboardRankingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Ranking"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listId"}},{"kind":"Field","name":{"kind":"Name","value":"itemKey"}},{"kind":"Field","name":{"kind":"Name","value":"itemRank"}},{"kind":"Field","name":{"kind":"Name","value":"itemDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WhiteboardDetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WhiteboardDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WhiteboardBasicInformationFragment"}},{"kind":"Field","name":{"kind":"Name","value":"collaboration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimpleCollaborationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrailFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ranking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WhiteboardRankingFragment"}}]}}]}}]} as unknown as DocumentNode<FetchActiveWhiteboardsQuery, FetchActiveWhiteboardsQueryVariables>;
export const FetchAllNonArchivedWhiteboardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchAllNonArchivedWhiteboards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"list"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"neq"},"value":{"kind":"EnumValue","value":"DELETED"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"neq"},"value":{"kind":"EnumValue","value":"ARCHIVED"}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WhiteboardDetailsFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WhiteboardBasicInformationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WhiteboardDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"permission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}}]},{"kind":"Field","name":{"kind":"Name","value":"streamPosition"}},{"kind":"Field","name":{"kind":"Name","value":"intake"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isOpen"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimpleCollaborationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collaboration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isShared"}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Publication"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowClone"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isReadonly"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"shareKeyPermission"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TrailFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentTrail"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WhiteboardRankingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Ranking"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listId"}},{"kind":"Field","name":{"kind":"Name","value":"itemKey"}},{"kind":"Field","name":{"kind":"Name","value":"itemRank"}},{"kind":"Field","name":{"kind":"Name","value":"itemDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WhiteboardDetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WhiteboardDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WhiteboardBasicInformationFragment"}},{"kind":"Field","name":{"kind":"Name","value":"collaboration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimpleCollaborationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrailFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ranking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WhiteboardRankingFragment"}}]}}]}}]} as unknown as DocumentNode<FetchAllNonArchivedWhiteboardsQuery, FetchAllNonArchivedWhiteboardsQueryVariables>;
export const OwnedWhiteboardsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ownedWhiteboardsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"list"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderByRankList"},"value":{"kind":"EnumValue","value":"MY_WHITEBOARDS"}},{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ownerId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"ACTIVE"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WhiteboardDetailsFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WhiteboardBasicInformationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WhiteboardDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"permission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}}]},{"kind":"Field","name":{"kind":"Name","value":"streamPosition"}},{"kind":"Field","name":{"kind":"Name","value":"intake"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isOpen"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimpleCollaborationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collaboration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isShared"}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Publication"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowClone"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isReadonly"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"shareKeyPermission"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TrailFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentTrail"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WhiteboardRankingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Ranking"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listId"}},{"kind":"Field","name":{"kind":"Name","value":"itemKey"}},{"kind":"Field","name":{"kind":"Name","value":"itemRank"}},{"kind":"Field","name":{"kind":"Name","value":"itemDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WhiteboardDetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WhiteboardDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WhiteboardBasicInformationFragment"}},{"kind":"Field","name":{"kind":"Name","value":"collaboration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimpleCollaborationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrailFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ranking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WhiteboardRankingFragment"}}]}}]}}]} as unknown as DocumentNode<OwnedWhiteboardsListQuery, OwnedWhiteboardsListQueryVariables>;
export const FetchNavbarBranchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchNavbarBranch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"section"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NavbarSection"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WhiteboardStatus"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navbar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"branch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section"}}},{"kind":"Argument","name":{"kind":"Name","value":"parentKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"parentKey"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collaboration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isShared"}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"permission"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"publication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPublished"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchNavbarBranchQuery, FetchNavbarBranchQueryVariables>;
export const FetchNavbarTreeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchNavbarTree"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"section"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NavbarSection"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WhiteboardStatus"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navbar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tree"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"parentKey"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collaboration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isShared"}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"permission"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"publication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPublished"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchNavbarTreeQuery, FetchNavbarTreeQueryVariables>;
export const FetchSharedWhiteboardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchSharedWhiteboards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"list"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderByRankList"},"value":{"kind":"EnumValue","value":"SHARED_WITH_ME"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ownerId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"ACTIVE"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"collaboration"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isShared"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"collaborators"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"permission"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"neq"},"value":{"kind":"EnumValue","value":"OWNER"}}]}}]}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WhiteboardDetailsFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WhiteboardBasicInformationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WhiteboardDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"permission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}}]},{"kind":"Field","name":{"kind":"Name","value":"streamPosition"}},{"kind":"Field","name":{"kind":"Name","value":"intake"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isOpen"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimpleCollaborationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collaboration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isShared"}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Publication"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowClone"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isReadonly"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"shareKeyPermission"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TrailFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentTrail"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WhiteboardRankingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Ranking"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listId"}},{"kind":"Field","name":{"kind":"Name","value":"itemKey"}},{"kind":"Field","name":{"kind":"Name","value":"itemRank"}},{"kind":"Field","name":{"kind":"Name","value":"itemDescription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WhiteboardDetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WhiteboardDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WhiteboardBasicInformationFragment"}},{"kind":"Field","name":{"kind":"Name","value":"collaboration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimpleCollaborationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrailFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ranking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WhiteboardRankingFragment"}}]}}]}}]} as unknown as DocumentNode<FetchSharedWhiteboardsQuery, FetchSharedWhiteboardsQueryVariables>;
export const FetchTemplateWhiteboardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchTemplateWhiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"whiteboardName"}},{"kind":"Field","name":{"kind":"Name","value":"shareKey"}}]}}]}}]}}]} as unknown as DocumentNode<FetchTemplateWhiteboardsQuery, FetchTemplateWhiteboardsQueryVariables>;
export const FetchTrashItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchTrashItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trash"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedBy"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"streamPosition"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"containerId"}},{"kind":"Field","name":{"kind":"Name","value":"containerName"}},{"kind":"Field","name":{"kind":"Name","value":"locationType"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchTrashItemsQuery, FetchTrashItemsQueryVariables>;
export const PublishedWhiteboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"publishedWhiteboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"published"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"streamPosition"}},{"kind":"Field","name":{"kind":"Name","value":"sharedWithMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"whiteboardId"}},{"kind":"Field","name":{"kind":"Name","value":"allowClone"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PublishedWhiteboardQuery, PublishedWhiteboardQueryVariables>;
export const UnfurlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"unfurl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationDocumentTypedId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unfurl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}},{"kind":"Argument","name":{"kind":"Name","value":"location"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationDocumentTypedId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"favicon"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UnfurlQuery, UnfurlQueryVariables>;
export const MyWhiteboardsProjectedSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"myWhiteboardsProjectedSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"correlationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myWhiteboardsProjected"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"whiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"correlationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"correlationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"isSuccess"}},{"kind":"Field","name":{"kind":"Name","value":"projectedTime"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionName"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"causationId"}},{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}}]}}]}}]} as unknown as DocumentNode<MyWhiteboardsProjectedSubscriptionSubscription, MyWhiteboardsProjectedSubscriptionSubscriptionVariables>;
export const GeneratePreprintDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"generatePreprint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preprintId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"promptId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupportedModel"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentWhiteboardId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useWebSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expandReferences"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generatePreprint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preprintId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preprintId"}}},{"kind":"Argument","name":{"kind":"Name","value":"promptId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"promptId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"parentWhiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentWhiteboardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"useWebSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useWebSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"expandReferences"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expandReferences"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionTopic"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}}]} as unknown as DocumentNode<GeneratePreprintMutation, GeneratePreprintMutationVariables>;
export const GetContextStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetContextStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"promptCardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentCardIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentWhiteboardId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agent"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupportedAgent"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expandReferences"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ai"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contextStats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"promptCardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"promptCardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contentCardIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentCardIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"parentWhiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentWhiteboardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agent"}}},{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"expandReferences"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expandReferences"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalTokens"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"files"}},{"kind":"Field","name":{"kind":"Name","value":"cards"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"models"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"modelId"}},{"kind":"Field","name":{"kind":"Name","value":"maxInputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"maxImages"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"isTierAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"isRegionRestricted"}},{"kind":"Field","name":{"kind":"Name","value":"capabilities"}},{"kind":"Field","name":{"kind":"Name","value":"inputModalities"}},{"kind":"Field","name":{"kind":"Name","value":"outputModalities"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleAgents"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetContextStatsQuery, GetContextStatsQueryVariables>;
export const GetSupportedAgentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSupportedAgents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ai"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allAgents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agent"}},{"kind":"Field","name":{"kind":"Name","value":"models"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"modelId"}},{"kind":"Field","name":{"kind":"Name","value":"isRegionRestricted"}},{"kind":"Field","name":{"kind":"Name","value":"isTierAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleAgents"}},{"kind":"Field","name":{"kind":"Name","value":"capabilities"}},{"kind":"Field","name":{"kind":"Name","value":"maxInputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"maxImages"}},{"kind":"Field","name":{"kind":"Name","value":"inputModalities"}},{"kind":"Field","name":{"kind":"Name","value":"outputModalities"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"myAgents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agent"}},{"kind":"Field","name":{"kind":"Name","value":"models"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"modelId"}},{"kind":"Field","name":{"kind":"Name","value":"isRegionRestricted"}},{"kind":"Field","name":{"kind":"Name","value":"isTierAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleAgents"}},{"kind":"Field","name":{"kind":"Name","value":"capabilities"}},{"kind":"Field","name":{"kind":"Name","value":"maxInputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"maxImages"}},{"kind":"Field","name":{"kind":"Name","value":"inputModalities"}},{"kind":"Field","name":{"kind":"Name","value":"outputModalities"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasCustomPreferences"}},{"kind":"Field","name":{"kind":"Name","value":"defaultModels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isRegionRestricted"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"modelId"}},{"kind":"Field","name":{"kind":"Name","value":"isTierAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleAgents"}},{"kind":"Field","name":{"kind":"Name","value":"capabilities"}},{"kind":"Field","name":{"kind":"Name","value":"maxInputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"maxImages"}},{"kind":"Field","name":{"kind":"Name","value":"inputModalities"}},{"kind":"Field","name":{"kind":"Name","value":"outputModalities"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSupportedAgentsQuery, GetSupportedAgentsQueryVariables>;
export const DraftsIndexDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DraftsIndex"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DraftIndexDocumentSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"draft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"index"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fromDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"toDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeEmpty"},"value":{"kind":"BooleanValue","value":false}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasContent"}},{"kind":"Field","name":{"kind":"Name","value":"markdown"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"specialBlocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"checked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}}]}},{"kind":"Field","name":{"kind":"Name","value":"whatsappMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}}]}},{"kind":"Field","name":{"kind":"Name","value":"audios"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DraftsIndexQuery, DraftsIndexQueryVariables>;
export const RestoreHistoryVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RestoreHistoryVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"typedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"versionNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restoreVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"typedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"typedId"}}},{"kind":"Argument","name":{"kind":"Name","value":"versionNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"versionNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newDocumentName"}},{"kind":"Field","name":{"kind":"Name","value":"newVersion"}},{"kind":"Field","name":{"kind":"Name","value":"restoredFromVersion"}}]}}]}}]}}]} as unknown as DocumentNode<RestoreHistoryVersionMutation, RestoreHistoryVersionMutationVariables>;
export const SaveCurrentVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveCurrentVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"typedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"typedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"typedId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"documentName"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"versionName"}}]}}]}}]}}]} as unknown as DocumentNode<SaveCurrentVersionMutation, SaveCurrentVersionMutationVariables>;
export const GetVersionHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVersionHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"typedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"typedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"typedId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"documentName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"authors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"contributedAt"}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetVersionHistoryQuery, GetVersionHistoryQueryVariables>;
export const GetVersionStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVersionStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"typedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"typedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"typedId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSynced"}}]}}]}}]}}]} as unknown as DocumentNode<GetVersionStatusQuery, GetVersionStatusQueryVariables>;
export const ArchiveCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"archiveCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archive"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commandId"}},{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"causationId"}}]}}]}}]}}]} as unknown as DocumentNode<ArchiveCardMutation, ArchiveCardMutationVariables>;
export const DeleteCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commandId"}},{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"causationId"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteCardMutation, DeleteCardMutationVariables>;
export const UnarchiveCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"unarchiveCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unarchive"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commandId"}},{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"causationId"}}]}}]}}]}}]} as unknown as DocumentNode<UnarchiveCardMutation, UnarchiveCardMutationVariables>;
export const PublishCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"publishCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"initialize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publish"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"initialize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"initialize"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardId"}},{"kind":"Field","name":{"kind":"Name","value":"shareKey"}},{"kind":"Field","name":{"kind":"Name","value":"commandId"}}]}}]}}]}}]} as unknown as DocumentNode<PublishCardMutation, PublishCardMutationVariables>;
export const UnpublishCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"unpublishCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unpublish"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commandId"}},{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"causationId"}}]}}]}}]}}]} as unknown as DocumentNode<UnpublishCardMutation, UnpublishCardMutationVariables>;
export const GrantCardPermissionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"grantCardPermission"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CardPermission"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"initialize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grantPermission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}},{"kind":"Argument","name":{"kind":"Name","value":"initialize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"initialize"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commandId"}},{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"causationId"}}]}}]}}]}}]} as unknown as DocumentNode<GrantCardPermissionMutation, GrantCardPermissionMutationVariables>;
export const RevokeCardPermissionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"revokeCardPermission"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokePermission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commandId"}},{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"causationId"}}]}}]}}]}}]} as unknown as DocumentNode<RevokeCardPermissionMutation, RevokeCardPermissionMutationVariables>;
export const AllowAnonymousEditCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"allowAnonymousEditCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowAnonymousEdit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commandId"}}]}}]}}]}}]} as unknown as DocumentNode<AllowAnonymousEditCardMutation, AllowAnonymousEditCardMutationVariables>;
export const DenyAnonymousEditCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"denyAnonymousEditCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"denyAnonymousEdit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commandId"}}]}}]}}]}}]} as unknown as DocumentNode<DenyAnonymousEditCardMutation, DenyAnonymousEditCardMutationVariables>;
export const TransferCardOwnershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"transferCardOwnership"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newOwnerEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transferOwnership"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"newOwnerEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newOwnerEmail"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commandId"}}]}}]}}]}}]} as unknown as DocumentNode<TransferCardOwnershipMutation, TransferCardOwnershipMutationVariables>;
export const RenameCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"renameCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rename"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commandId"}}]}}]}}]}}]} as unknown as DocumentNode<RenameCardMutation, RenameCardMutationVariables>;
export const PutToLibraryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"putToLibrary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addToLibrary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"whiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"causationId"}},{"kind":"Field","name":{"kind":"Name","value":"commandId"}},{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<PutToLibraryMutation, PutToLibraryMutationVariables>;
export const MyCardLibraryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"myCardLibrary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"library"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"shareKey"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"streamPosition"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MyCardLibraryQuery, MyCardLibraryQueryVariables>;
export const MyCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"myCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"library"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"ownerName"}},{"kind":"Field","name":{"kind":"Name","value":"ownerAvatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"shareKey"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"streamPosition"}},{"kind":"Field","name":{"kind":"Name","value":"whiteboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"knownRanklist"}},{"kind":"Field","name":{"kind":"Name","value":"shapeIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collaboration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isShared"}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"permission"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"publication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"shareKeyPermission"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MyCardQuery, MyCardQueryVariables>;
export const MarkMentionAsReadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkMentionAsRead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markAsRead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mentionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentionId"}}}]}]}}]}}]} as unknown as DocumentNode<MarkMentionAsReadMutation, MarkMentionAsReadMutationVariables>;
export const MarkAllMentionsAsReadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkAllMentionsAsRead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markAllAsRead"}}]}}]}}]} as unknown as DocumentNode<MarkAllMentionsAsReadMutation, MarkAllMentionsAsReadMutationVariables>;
export const MarkMentionSelectedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkMentionSelected"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markSelected"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"sessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]} as unknown as DocumentNode<MarkMentionSelectedMutation, MarkMentionSelectedMutationVariables>;
export const RecordMentionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecordMention"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentionedUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"snippet"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deepLink"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"anchorId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mention"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"idempotencyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"mentionedUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentionedUserId"}}},{"kind":"Argument","name":{"kind":"Name","value":"snippet"},"value":{"kind":"Variable","name":{"kind":"Name","value":"snippet"}}},{"kind":"Argument","name":{"kind":"Name","value":"deepLink"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deepLink"}}},{"kind":"Argument","name":{"kind":"Name","value":"anchorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"anchorId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentionId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<RecordMentionMutation, RecordMentionMutationVariables>;
export const MentionInboxDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MentionInbox"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MentionInboxItemFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MentionInboxItemSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inbox"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idempotencyId"}},{"kind":"Field","name":{"kind":"Name","value":"authorId"}},{"kind":"Field","name":{"kind":"Name","value":"authorName"}},{"kind":"Field","name":{"kind":"Name","value":"authorAvatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"sourceId"}},{"kind":"Field","name":{"kind":"Name","value":"anchorId"}},{"kind":"Field","name":{"kind":"Name","value":"snippet"}},{"kind":"Field","name":{"kind":"Name","value":"deepLink"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"readAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MentionInboxQuery, MentionInboxQueryVariables>;
export const MentionUnreadCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MentionUnreadCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unreadCount"}}]}}]}}]} as unknown as DocumentNode<MentionUnreadCountQuery, MentionUnreadCountQueryVariables>;
export const MentionSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MentionSuggestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recentlySelected"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latestUpdated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}}]}}]}}]}}]} as unknown as DocumentNode<MentionSuggestionsQuery, MentionSuggestionsQueryVariables>;
export const SuggestPeopleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SuggestPeople"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestPeople"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}}]}}]} as unknown as DocumentNode<SuggestPeopleQuery, SuggestPeopleQueryVariables>;
export const OnMentionInboxUpdatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnMentionInboxUpdated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onMentionInboxUpdated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"mentionId"}},{"kind":"Field","name":{"kind":"Name","value":"unreadCount"}},{"kind":"Field","name":{"kind":"Name","value":"mention"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idempotencyId"}},{"kind":"Field","name":{"kind":"Name","value":"authorId"}},{"kind":"Field","name":{"kind":"Name","value":"authorName"}},{"kind":"Field","name":{"kind":"Name","value":"authorAvatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"sourceId"}},{"kind":"Field","name":{"kind":"Name","value":"anchorId"}},{"kind":"Field","name":{"kind":"Name","value":"snippet"}},{"kind":"Field","name":{"kind":"Name","value":"deepLink"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"readAt"}}]}}]}}]}}]} as unknown as DocumentNode<OnMentionInboxUpdatedSubscription, OnMentionInboxUpdatedSubscriptionVariables>;
export const CompleteOnboardingStepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteOnboardingStep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"step"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OnboardingStep"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeStep"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"step"},"value":{"kind":"Variable","name":{"kind":"Name","value":"step"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CompleteOnboardingStepMutation, CompleteOnboardingStepMutationVariables>;
export const GetOnboardingStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOnboardingStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"steps"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StepsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"overview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"steps"},"value":{"kind":"Variable","name":{"kind":"Name","value":"steps"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"streamPosition"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"step"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOnboardingStatusQuery, GetOnboardingStatusQueryVariables>;
export const ActivateStarterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ActivateStarter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activateStarter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"causationId"}},{"kind":"Field","name":{"kind":"Name","value":"commandId"}},{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalUserId"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"renewsAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ActivateStarterMutation, ActivateStarterMutationVariables>;
export const CreateBillingPortalSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateBillingPortalSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"previewReturnUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBillingPortalSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"previewReturnUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"previewReturnUrl"}}}]}]}}]}}]} as unknown as DocumentNode<CreateBillingPortalSessionMutation, CreateBillingPortalSessionMutationVariables>;
export const CreateCheckoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCheckout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"discountCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"returnUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"priceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"discountCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"discountCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"returnUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"returnUrl"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"secret"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCheckoutMutation, CreateCheckoutMutationVariables>;
export const CreateStripeExtraCreditsCheckoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateStripeExtraCreditsCheckout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"creditThousands"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"previewReturnUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createStripeExtraCreditsCheckout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"creditThousands"},"value":{"kind":"Variable","name":{"kind":"Name","value":"creditThousands"}}},{"kind":"Argument","name":{"kind":"Name","value":"previewReturnUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"previewReturnUrl"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"secret"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}}]}}]}}]}}]} as unknown as DocumentNode<CreateStripeExtraCreditsCheckoutMutation, CreateStripeExtraCreditsCheckoutMutationVariables>;
export const GraduateFromBetaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GraduateFromBeta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"graduateFromBeta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wasMigrated"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalUserId"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"renewsAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"trialEndsAt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GraduateFromBetaMutation, GraduateFromBetaMutationVariables>;
export const MyPlanMeteredDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyPlanMetered"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FeatureEntity"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supportedFeature"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SupportedFeature"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureState"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entityId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whiteboardId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityType"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"feature"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supportedFeature"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureStateFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureStateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeteredFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"dimension"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeteredPerEntityFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"dimension"}},{"kind":"Field","name":{"kind":"Name","value":"entity"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeteredPerPeriodFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"periodReset"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeteredPerPeriodWithBalanceFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"periodReset"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"balanceUsedThisPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"featureAvailable"}}]}}]}}]} as unknown as DocumentNode<MyPlanMeteredQuery, MyPlanMeteredQueryVariables>;
export const MyPlansDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyPlans"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanDocumentFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalStateFramgent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"terms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureStateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeteredFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"dimension"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeteredPerEntityFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"dimension"}},{"kind":"Field","name":{"kind":"Name","value":"entity"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeteredPerPeriodFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"periodReset"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeteredPerPeriodWithBalanceFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"periodReset"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"balanceUsedThisPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"featureAvailable"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanDocumentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PlanDocument"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalUserId"}},{"kind":"Field","name":{"kind":"Name","value":"plan"}},{"kind":"Field","name":{"kind":"Name","value":"planFamily"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"renewsAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"streamPosition"}},{"kind":"Field","name":{"kind":"Name","value":"trialEnd"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"currentPeriodAvailableExtraUsageCredits"}},{"kind":"Field","name":{"kind":"Name","value":"extraUsageCredits"}},{"kind":"Field","name":{"kind":"Name","value":"confirmedTotalUsedCredits"}},{"kind":"Field","name":{"kind":"Name","value":"nextBalanceCloseAt"}},{"kind":"Field","name":{"kind":"Name","value":"external"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalStateFramgent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureStateFragment"}}]}}]}}]} as unknown as DocumentNode<MyPlansQuery, MyPlansQueryVariables>;
export const ProductInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annual"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"monthly"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"starter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annual"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"monthly"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductInformationQuery, ProductInformationQueryVariables>;
export const PlanStatusSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"PlanStatusSubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanDocumentFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalStateFramgent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"terms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureStateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeteredFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"dimension"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeteredPerEntityFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"dimension"}},{"kind":"Field","name":{"kind":"Name","value":"entity"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeteredPerPeriodFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"periodReset"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeteredPerPeriodWithBalanceFeatureState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"periodReset"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"balanceUsedThisPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"featureAvailable"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanDocumentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PlanDocument"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalUserId"}},{"kind":"Field","name":{"kind":"Name","value":"plan"}},{"kind":"Field","name":{"kind":"Name","value":"planFamily"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"renewsAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"streamPosition"}},{"kind":"Field","name":{"kind":"Name","value":"trialEnd"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"currentPeriodAvailableExtraUsageCredits"}},{"kind":"Field","name":{"kind":"Name","value":"extraUsageCredits"}},{"kind":"Field","name":{"kind":"Name","value":"confirmedTotalUsedCredits"}},{"kind":"Field","name":{"kind":"Name","value":"nextBalanceCloseAt"}},{"kind":"Field","name":{"kind":"Name","value":"external"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalStateFramgent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureStateFragment"}}]}}]}}]} as unknown as DocumentNode<PlanStatusSubscriptionSubscription, PlanStatusSubscriptionSubscriptionVariables>;
export const ClaimReferralRewardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClaimReferralReward"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rewardCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referrals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redeemReward"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"rewardCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rewardCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"globalPosition"}},{"kind":"Field","name":{"kind":"Name","value":"needPaymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rewards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grantedRewards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaignCode"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRedeemed"}},{"kind":"Field","name":{"kind":"Name","value":"refereeId"}},{"kind":"Field","name":{"kind":"Name","value":"rewardCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renewsAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"needPaymentMethod"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ClaimReferralRewardMutation, ClaimReferralRewardMutationVariables>;
export const GetMyReferralProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyReferralProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referrals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qualifiedReferralCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalRewardsGranted"}},{"kind":"Field","name":{"kind":"Name","value":"totalRewardsRedeemed"}},{"kind":"Field","name":{"kind":"Name","value":"rewards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRedeemed"}},{"kind":"Field","name":{"kind":"Name","value":"rewardCode"}},{"kind":"Field","name":{"kind":"Name","value":"refereeId"}},{"kind":"Field","name":{"kind":"Name","value":"rewardType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"referralCode"}},{"kind":"Field","name":{"kind":"Name","value":"referredBy"}},{"kind":"Field","name":{"kind":"Name","value":"referredByEmail"}},{"kind":"Field","name":{"kind":"Name","value":"referrals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"registeredAt"}},{"kind":"Field","name":{"kind":"Name","value":"refereeEmail"}},{"kind":"Field","name":{"kind":"Name","value":"refereeId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMyReferralProfileQuery, GetMyReferralProfileQueryVariables>;
export const IssuePersonalAccessTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IssuePersonalAccessToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scopes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PersonalAccessTokenScope"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"developer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"personalAccessToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"scopes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scopes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"personalAccessToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayHint"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastUsedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"revokedAt"}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IssuePersonalAccessTokenMutation, IssuePersonalAccessTokenMutationVariables>;
export const RevokePersonalAccessTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RevokePersonalAccessToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tokenId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"developer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"personalAccessToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revoke"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tokenId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tokenId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"revokedAt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RevokePersonalAccessTokenMutation, RevokePersonalAccessTokenMutationVariables>;
export const RegisterUserMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RegisterUserMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idProvider"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"avatarUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referralCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"demoSessionId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"demoWhiteboardId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"register"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"externalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalId"}}},{"kind":"Argument","name":{"kind":"Name","value":"idProvider"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idProvider"}}},{"kind":"Argument","name":{"kind":"Name","value":"avatarUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avatarUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"referralCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referralCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"demoSessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"demoSessionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"demoWhiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"demoWhiteboardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneActivationCode"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RegisterUserMutationMutation, RegisterUserMutationMutationVariables>;
export const ResendVerificationEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResendVerificationEmail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendVerificationEmail"}}]}}]}}]} as unknown as DocumentNode<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;
export const ResetPreferredModelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetPreferredModels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ai"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPreferredModels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modelPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ResetPreferredModelsMutation, ResetPreferredModelsMutationVariables>;
export const SetPreferredModelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetPreferredModels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SupportedAgent"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"models"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SupportedModel"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ai"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setPreferredModels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agent"}}},{"kind":"Argument","name":{"kind":"Name","value":"models"},"value":{"kind":"Variable","name":{"kind":"Name","value":"models"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modelPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SetPreferredModelsMutation, SetPreferredModelsMutationVariables>;
export const UpdateUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"avatarUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timezone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zoomSpeed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appearance"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserAppearance"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"avatarUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avatarUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"displayName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"timezone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timezone"}}},{"kind":"Argument","name":{"kind":"Name","value":"zoomSpeed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zoomSpeed"}}},{"kind":"Argument","name":{"kind":"Name","value":"appearance"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appearance"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"zoomSpeed"}},{"kind":"Field","name":{"kind":"Name","value":"appearance"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const UpdateUserPresenceColorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserPresenceColor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"presenceColor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"presenceColor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"presenceColor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"presenceColor"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserPresenceColorMutation, UpdateUserPresenceColorMutationVariables>;
export const ChangeZoomSpeedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeZoomSpeed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zoomSpeed"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeZoomSpeed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zoomSpeed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zoomSpeed"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zoomSpeed"}}]}}]}}]}}]} as unknown as DocumentNode<ChangeZoomSpeedMutation, ChangeZoomSpeedMutationVariables>;
export const ChangeAppearanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeAppearance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appearance"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserAppearance"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeAppearance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appearance"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appearance"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appearance"}}]}}]}}]}}]} as unknown as DocumentNode<ChangeAppearanceMutation, ChangeAppearanceMutationVariables>;
export const FindByEmailQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindByEmailQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"newEmailToConfirm"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"presenceColor"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"zoomSpeed"}},{"kind":"Field","name":{"kind":"Name","value":"appearance"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindByEmailQueryQuery, FindByEmailQueryQueryVariables>;
export const GetAuth0UserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAuth0User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auth0User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}}]} as unknown as DocumentNode<GetAuth0UserQuery, GetAuth0UserQueryVariables>;
export const GetCurrentCountryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"flagEmoji"}}]}}]}}]}}]} as unknown as DocumentNode<GetCurrentCountryQuery, GetCurrentCountryQueryVariables>;
export const GetPersonalAccessTokensDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPersonalAccessTokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"developer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"personalAccessToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayHint"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastUsedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"revokedAt"}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPersonalAccessTokensQuery, GetPersonalAccessTokensQueryVariables>;
export const MoveToLocationMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MoveToLocationMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"destination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"permission"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetPermission"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"moveToLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}},{"kind":"Argument","name":{"kind":"Name","value":"destination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"destination"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"permission"},"value":{"kind":"Variable","name":{"kind":"Name","value":"permission"}}},{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}}]}]}}]}}]} as unknown as DocumentNode<MoveToLocationMutationMutation, MoveToLocationMutationMutationVariables>;
export const PrepareAssetUploadMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PrepareAssetUploadMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationDocumentTypedId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"permission"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetPermission"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentWhiteboardId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"backgroundIngest"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepareUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fileName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationDocumentTypedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationDocumentTypedId"}}},{"kind":"Argument","name":{"kind":"Name","value":"permission"},"value":{"kind":"Variable","name":{"kind":"Name","value":"permission"}}},{"kind":"Argument","name":{"kind":"Name","value":"shareKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"parentWhiteboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentWhiteboardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"backgroundIngest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"backgroundIngest"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}}]}}]}}]}}]} as unknown as DocumentNode<PrepareAssetUploadMutationMutation, PrepareAssetUploadMutationMutationVariables>;
export const AssistantAnsweredPartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"AssistantAnsweredPart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assistantAnsweredPart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]} as unknown as DocumentNode<AssistantAnsweredPartSubscription, AssistantAnsweredPartSubscriptionVariables>;
export const GetWhatsAppPhoneNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWhatsAppPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whatsAppPhoneNumber"}}]}}]}}]} as unknown as DocumentNode<GetWhatsAppPhoneNumberQuery, GetWhatsAppPhoneNumberQueryVariables>;
export const GeneratePhoneActivationCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GeneratePhoneActivationCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generatePhoneActivationCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailActivationCode"}},{"kind":"Field","name":{"kind":"Name","value":"emailToActivate"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneActivationCode"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GeneratePhoneActivationCodeMutation, GeneratePhoneActivationCodeMutationVariables>;
export const UpdateUserProfileFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserProfileFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"avatarUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timezone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"avatarUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avatarUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"displayName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"Argument","name":{"kind":"Name","value":"timezone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timezone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"timeZoneId"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserProfileFieldsMutation, UpdateUserProfileFieldsMutationVariables>;